var _toConsumableArray = require("/u01/hops/repo/hops-front-rely/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self)["hops-agent-wa"] = t();
}(this, function () {
  "use strict";

  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
  function t(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }
  t(function (e) {
    var t = function (e) {
      var t,
        i = Object.prototype,
        a = i.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        r = o.iterator || "@@iterator",
        n = o.asyncIterator || "@@asyncIterator",
        s = o.toStringTag || "@@toStringTag";
      function c(e, t, i) {
        return Object.defineProperty(e, t, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        c({}, "");
      } catch (e) {
        c = function c(e, t, i) {
          return e[t] = i;
        };
      }
      function l(e, t, i, a) {
        var o = t && t.prototype instanceof T ? t : T,
          r = Object.create(o.prototype),
          n = new E(a || []);
        return r._invoke = function (e, t, i) {
          var a = d;
          return function (o, r) {
            if (a === m) throw new Error("Generator is already running");
            if (a === S) {
              if ("throw" === o) throw r;
              return x();
            }
            for (i.method = o, i.arg = r;;) {
              var n = i.delegate;
              if (n) {
                var s = w(n, i);
                if (s) {
                  if (s === p) continue;
                  return s;
                }
              }
              if ("next" === i.method) i.sent = i._sent = i.arg;else if ("throw" === i.method) {
                if (a === d) throw a = S, i.arg;
                i.dispatchException(i.arg);
              } else "return" === i.method && i.abrupt("return", i.arg);
              a = m;
              var c = u(e, t, i);
              if ("normal" === c.type) {
                if (a = i.done ? S : h, c.arg === p) continue;
                return {
                  value: c.arg,
                  done: i.done
                };
              }
              "throw" === c.type && (a = S, i.method = "throw", i.arg = c.arg);
            }
          };
        }(e, i, n), r;
      }
      function u(e, t, i) {
        try {
          return {
            type: "normal",
            arg: e.call(t, i)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = l;
      var d = "suspendedStart",
        h = "suspendedYield",
        m = "executing",
        S = "completed",
        p = {};
      function T() {}
      function v() {}
      function f() {}
      var b = {};
      b[r] = function () {
        return this;
      };
      var g = Object.getPrototypeOf,
        y = g && g(g(I([])));
      y && y !== i && a.call(y, r) && (b = y);
      var C = f.prototype = T.prototype = Object.create(b);
      function G(e) {
        ["next", "throw", "return"].forEach(function (t) {
          c(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function H(e, t) {
        function i(o, r, n, s) {
          var c = u(e[o], e, r);
          if ("throw" !== c.type) {
            var l = c.arg,
              d = l.value;
            return d && "object" == typeof d && a.call(d, "__await") ? t.resolve(d.__await).then(function (e) {
              i("next", e, n, s);
            }, function (e) {
              i("throw", e, n, s);
            }) : t.resolve(d).then(function (e) {
              l.value = e, n(l);
            }, function (e) {
              return i("throw", e, n, s);
            });
          }
          s(c.arg);
        }
        var o;
        this._invoke = function (e, a) {
          function r() {
            return new t(function (t, o) {
              i(e, a, t, o);
            });
          }
          return o = o ? o.then(r, r) : r();
        };
      }
      function w(e, i) {
        var a = e.iterator[i.method];
        if (a === t) {
          if (i.delegate = null, "throw" === i.method) {
            if (e.iterator.return && (i.method = "return", i.arg = t, w(e, i), "throw" === i.method)) return p;
            i.method = "throw", i.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return p;
        }
        var o = u(a, e.iterator, i.arg);
        if ("throw" === o.type) return i.method = "throw", i.arg = o.arg, i.delegate = null, p;
        var r = o.arg;
        return r ? r.done ? (i[e.resultName] = r.value, i.next = e.nextLoc, "return" !== i.method && (i.method = "next", i.arg = t), i.delegate = null, p) : r : (i.method = "throw", i.arg = new TypeError("iterator result is not an object"), i.delegate = null, p);
      }
      function A(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function M(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function E(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(A, this), this.reset(!0);
      }
      function I(e) {
        if (e) {
          var i = e[r];
          if (i) return i.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              n = function i() {
                for (; ++o < e.length;) {
                  if (a.call(e, o)) return i.value = e[o], i.done = !1, i;
                }
                return i.value = t, i.done = !0, i;
              };
            return n.next = n;
          }
        }
        return {
          next: x
        };
      }
      function x() {
        return {
          value: t,
          done: !0
        };
      }
      return v.prototype = C.constructor = f, f.constructor = v, v.displayName = c(f, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, c(e, s, "GeneratorFunction")), e.prototype = Object.create(C), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, G(H.prototype), H.prototype[n] = function () {
        return this;
      }, e.AsyncIterator = H, e.async = function (t, i, a, o, r) {
        void 0 === r && (r = Promise);
        var n = new H(l(t, i, a, o), r);
        return e.isGeneratorFunction(i) ? n : n.next().then(function (e) {
          return e.done ? e.value : n.next();
        });
      }, G(C), c(C, s, "Generator"), C[r] = function () {
        return this;
      }, C.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];
        for (var i in e) {
          t.push(i);
        }
        return t.reverse(), function i() {
          for (; t.length;) {
            var a = t.pop();
            if (a in e) return i.value = a, i.done = !1, i;
          }
          return i.done = !0, i;
        };
      }, e.values = I, E.prototype = {
        constructor: E,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(M), !e) for (var i in this) {
            "t" === i.charAt(0) && a.call(this, i) && !isNaN(+i.slice(1)) && (this[i] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var i = this;
          function o(a, o) {
            return s.type = "throw", s.arg = e, i.next = a, o && (i.method = "next", i.arg = t), !!o;
          }
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var n = this.tryEntries[r],
              s = n.completion;
            if ("root" === n.tryLoc) return o("end");
            if (n.tryLoc <= this.prev) {
              var c = a.call(n, "catchLoc"),
                l = a.call(n, "finallyLoc");
              if (c && l) {
                if (this.prev < n.catchLoc) return o(n.catchLoc, !0);
                if (this.prev < n.finallyLoc) return o(n.finallyLoc);
              } else if (c) {
                if (this.prev < n.catchLoc) return o(n.catchLoc, !0);
              } else {
                if (!l) throw new Error("try statement without catch or finally");
                if (this.prev < n.finallyLoc) return o(n.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var o = this.tryEntries[i];
            if (o.tryLoc <= this.prev && a.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var r = o;
              break;
            }
          }
          r && ("break" === e || "continue" === e) && r.tryLoc <= t && t <= r.finallyLoc && (r = null);
          var n = r ? r.completion : {};
          return n.type = e, n.arg = t, r ? (this.method = "next", this.next = r.finallyLoc, p) : this.complete(n);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), p;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var i = this.tryEntries[t];
            if (i.finallyLoc === e) return this.complete(i.completion, i.afterLoc), M(i), p;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var i = this.tryEntries[t];
            if (i.tryLoc === e) {
              var a = i.completion;
              if ("throw" === a.type) {
                var o = a.arg;
                M(i);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, i, a) {
          return this.delegate = {
            iterator: I(e),
            resultName: i,
            nextLoc: a
          }, "next" === this.method && (this.arg = t), p;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = t;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(t);
    }
  });
  /*! *****************************************************************************
  	Copyright (c) Microsoft Corporation.
  
  	Permission to use, copy, modify, and/or distribute this software for any
  	purpose with or without fee is hereby granted.
  
  	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  	PERFORMANCE OF THIS SOFTWARE.
  	***************************************************************************** */
  var i,
    a,
    _o2 = function o() {
      return (_o2 = Object.assign || function (e) {
        for (var t, i = 1, a = arguments.length; i < a; i++) {
          for (var o in t = arguments[i]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }).apply(this, arguments);
    };
  function r(e, t, i, a) {
    return new (i || (i = Promise))(function (o, r) {
      function n(e) {
        try {
          c(a.next(e));
        } catch (e) {
          r(e);
        }
      }
      function s(e) {
        try {
          c(a.throw(e));
        } catch (e) {
          r(e);
        }
      }
      function c(e) {
        var t;
        e.done ? o(e.value) : (t = e.value, t instanceof i ? t : new i(function (e) {
          e(t);
        })).then(n, s);
      }
      c((a = a.apply(e, t || [])).next());
    });
  }
  function n(e, t) {
    var i,
      a,
      o,
      r,
      n = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
    return r = {
      next: s(0),
      throw: s(1),
      return: s(2)
    }, "function" == typeof Symbol && (r[Symbol.iterator] = function () {
      return this;
    }), r;
    function s(r) {
      return function (s) {
        return function (r) {
          if (i) throw new TypeError("Generator is already executing.");
          for (; n;) {
            try {
              if (i = 1, a && (o = 2 & r[0] ? a.return : r[0] ? a.throw || ((o = a.return) && o.call(a), 0) : a.next) && !(o = o.call(a, r[1])).done) return o;
              switch (a = 0, o && (r = [2 & r[0], o.value]), r[0]) {
                case 0:
                case 1:
                  o = r;
                  break;
                case 4:
                  return n.label++, {
                    value: r[1],
                    done: !1
                  };
                case 5:
                  n.label++, a = r[1], r = [0];
                  continue;
                case 7:
                  r = n.ops.pop(), n.trys.pop();
                  continue;
                default:
                  if (!(o = n.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== r[0] && 2 !== r[0])) {
                    n = 0;
                    continue;
                  }
                  if (3 === r[0] && (!o || r[1] > o[0] && r[1] < o[3])) {
                    n.label = r[1];
                    break;
                  }
                  if (6 === r[0] && n.label < o[1]) {
                    n.label = o[1], o = r;
                    break;
                  }
                  if (o && n.label < o[2]) {
                    n.label = o[2], n.ops.push(r);
                    break;
                  }
                  o[2] && n.ops.pop(), n.trys.pop();
                  continue;
              }
              r = t.call(e, n);
            } catch (e) {
              r = [6, e], a = 0;
            } finally {
              i = o = 0;
            }
          }
          if (5 & r[0]) throw r[1];
          return {
            value: r[0] ? r[1] : void 0,
            done: !0
          };
        }([r, s]);
      };
    }
  }
  function s() {
    for (var e = 0, t = 0, i = arguments.length; t < i; t++) {
      e += arguments[t].length;
    }
    var a = Array(e),
      o = 0;
    for (t = 0; t < i; t++) {
      for (var r = arguments[t], n = 0, s = r.length; n < s; n++, o++) {
        a[o] = r[n];
      }
    }
    return a;
  }
  !function (e) {
    e.API = "api", e.SEGMENT = "segment", e.BEHAVIOR = "behavior";
  }(a || (a = {}));
  var c = {
    domain: location.origin,
    reportUrl: "",
    collector: "",
    accessTokenUrl: location.origin,
    customUrl: "",
    serviceId: "",
    service: "",
    serviceVersion: "1.0.0",
    environment: "production",
    pushIntervalDuration: 3e4,
    useFmp: !0,
    enableSPA: !0,
    autoSendPv: !0,
    autoTracePerf: !0,
    isTrace: !1,
    isAjax: !0,
    resourceDelay: 0,
    isResource: !0,
    isError: !0,
    isBehavior: !1,
    isCustom: !1,
    isRequest: !1,
    isResponse: !1,
    clientId: null,
    clientSecret: null,
    ignore: {
      ignoreErrors: [],
      ignoreUrls: [],
      ignoreApis: ["/api/v1/report/web"]
    },
    behavior: {
      console: ["log", "error"],
      click: !0
    },
    maxLength: 1e3,
    hashRouter: "history",
    pagePath: "",
    detailMode: !0,
    handlers: (i = {}, i[a.SEGMENT] = [], i[a.API] = [], i[a.BEHAVIOR] = [], i),
    recordHandler: null,
    namespace: "sw8",
    maxBatchSizeBytes: 1024,
    maxBatchLength: 150,
    traceClusterCode: null,
    accessToken: "access_token_hopsAgent",
    apiCheckStatus: null,
    actionLength: 50
  };
  function l(e) {
    c = _o2(_o2(_o2({}, c), e), {
      namespace: e.namespace ? e.namespace + "-sw8" : "sw8",
      reportUrl: e.reportUrl ? e.reportUrl : e.domain + "/v1/up-log",
      collector: e.collector ? e.collector : e.domain + "/v1/front-trace",
      customUrl: e.customUrl ? e.customUrl : e.domain + "/v1/custom-upload"
    });
  }
  function u(e) {
    return !!e && !!c[e] && c[e];
  }
  function d(e, t) {
    return "function" != typeof u("recordHandler") ? t : u("recordHandler")(e, t);
  }
  function h(e, t) {
    for (var i, a = [], o = 2; o < arguments.length; o++) {
      a[o - 2] = arguments[o];
    }
    return c.handlers[e].length ? null !== (i = c.handlers[e].reduce(function (e, t) {
      return t.call.apply(t, s([null, e], a));
    }, t)) && void 0 !== i ? i : null : t;
  }
  function m(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }
  var S,
    p,
    T = function T(e, t, i, a) {
      t = t || "&", i = i || "=";
      var o = {};
      if ("string" != typeof e || 0 === e.length) return o;
      var r = /\+/g;
      e = e.split(t);
      var n = 1e3;
      a && "number" == typeof a.maxKeys && (n = a.maxKeys);
      var s = e.length;
      n > 0 && s > n && (s = n);
      for (var c = 0; c < s; ++c) {
        var l,
          u,
          d,
          h,
          S = e[c].replace(r, "%20"),
          p = S.indexOf(i);
        p >= 0 ? (l = S.substr(0, p), u = S.substr(p + 1)) : (l = S, u = ""), d = decodeURIComponent(l), h = decodeURIComponent(u), m(o, d) ? Array.isArray(o[d]) ? o[d].push(h) : o[d] = [o[d], h] : o[d] = h;
      }
      return o;
    },
    v = function v(e) {
      switch (typeof e) {
        case "string":
          return e;
        case "boolean":
          return e ? "true" : "false";
        case "number":
          return isFinite(e) ? e : "";
        default:
          return "";
      }
    },
    f = function f(e, t, i, a) {
      return t = t || "&", i = i || "=", null === e && (e = void 0), "object" == typeof e ? Object.keys(e).map(function (a) {
        var o = encodeURIComponent(v(a)) + i;
        return Array.isArray(e[a]) ? e[a].map(function (e) {
          return o + encodeURIComponent(v(e));
        }).join(t) : o + encodeURIComponent(v(e[a]));
      }).join(t) : a ? encodeURIComponent(v(a)) + i + encodeURIComponent(v(e)) : "";
    },
    b = t(function (e, t) {
      t.decode = t.parse = T, t.encode = t.stringify = f;
    }),
    g = (b.decode, b.parse, b.encode, b.stringify, function (e) {
      return e && e.Math == Math && e;
    }),
    y = g("object" == typeof globalThis && globalThis) || g("object" == typeof window && window) || g("object" == typeof self && self) || g("object" == typeof e && e) || function () {
      return this;
    }() || Function("return this")(),
    C = function C(e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    },
    G = !C(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    }),
    H = function H(e) {
      return "object" == typeof e ? null !== e : "function" == typeof e;
    },
    w = y.document,
    A = H(w) && H(w.createElement),
    M = function M(e) {
      return A ? w.createElement(e) : {};
    },
    E = !G && !C(function () {
      return 7 != Object.defineProperty(M("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    }),
    I = function I(e) {
      if (!H(e)) throw TypeError(String(e) + " is not an object");
      return e;
    },
    x = function x(e, t) {
      if (!H(e)) return e;
      var i, a;
      if (t && "function" == typeof (i = e.toString) && !H(a = i.call(e))) return a;
      if ("function" == typeof (i = e.valueOf) && !H(a = i.call(e))) return a;
      if (!t && "function" == typeof (i = e.toString) && !H(a = i.call(e))) return a;
      throw TypeError("Can't convert object to primitive value");
    },
    L = Object.defineProperty,
    O = {
      f: G ? L : function (e, t, i) {
        if (I(e), t = x(t, !0), I(i), E) try {
          return L(e, t, i);
        } catch (e) {}
        if ("get" in i || "set" in i) throw TypeError("Accessors not supported");
        return "value" in i && (e[t] = i.value), e;
      }
    },
    P = function P(e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    },
    D = G ? function (e, t, i) {
      return O.f(e, t, P(1, i));
    } : function (e, t, i) {
      return e[t] = i, e;
    },
    N = function N(e, t) {
      try {
        D(y, e, t);
      } catch (i) {
        y[e] = t;
      }
      return t;
    },
    X = "__core-js_shared__",
    R = y[X] || N(X, {}),
    B = t(function (e) {
      (e.exports = function (e, t) {
        return R[e] || (R[e] = void 0 !== t ? t : {});
      })("versions", []).push({
        version: "3.11.0",
        mode: "global",
        copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
      });
    }),
    k = function k(e) {
      if (null == e) throw TypeError("Can't call method on " + e);
      return e;
    },
    U = function U(e) {
      return Object(k(e));
    },
    V = {}.hasOwnProperty,
    W = function W(e, t) {
      return V.call(U(e), t);
    },
    F = 0,
    Z = Math.random(),
    K = function K(e) {
      return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++F + Z).toString(36);
    },
    _ = {}.toString,
    z = function z(e) {
      return _.call(e).slice(8, -1);
    },
    j = "process" == z(y.process),
    Y = y,
    q = function q(e) {
      return "function" == typeof e ? e : void 0;
    },
    Q = function Q(e, t) {
      return arguments.length < 2 ? q(Y[e]) || q(y[e]) : Y[e] && Y[e][t] || y[e] && y[e][t];
    },
    J = Q("navigator", "userAgent") || "",
    $ = y.process,
    ee = $ && $.versions,
    te = ee && ee.v8;
  te ? p = (S = te.split("."))[0] + S[1] : J && (!(S = J.match(/Edge\/(\d+)/)) || S[1] >= 74) && (S = J.match(/Chrome\/(\d+)/)) && (p = S[1]);
  var ie = p && +p,
    ae = !!Object.getOwnPropertySymbols && !C(function () {
      return !Symbol.sham && (j ? 38 === ie : ie > 37 && ie < 41);
    }),
    oe = ae && !Symbol.sham && "symbol" == typeof Symbol.iterator,
    re = B("wks"),
    ne = y.Symbol,
    se = oe ? ne : ne && ne.withoutSetter || K,
    ce = function ce(e) {
      return W(re, e) && (ae || "string" == typeof re[e]) || (ae && W(ne, e) ? re[e] = ne[e] : re[e] = se("Symbol." + e)), re[e];
    },
    le = {};
  le[ce("toStringTag")] = "z";
  var ue = "[object z]" === String(le),
    de = Function.toString;
  "function" != typeof R.inspectSource && (R.inspectSource = function (e) {
    return de.call(e);
  });
  var he,
    me,
    Se,
    pe = R.inspectSource,
    Te = y.WeakMap,
    ve = "function" == typeof Te && /native code/.test(pe(Te)),
    fe = B("keys"),
    be = function be(e) {
      return fe[e] || (fe[e] = K(e));
    },
    ge = {},
    ye = "Object already initialized",
    Ce = y.WeakMap;
  if (ve) {
    var Ge = R.state || (R.state = new Ce()),
      He = Ge.get,
      we = Ge.has,
      Ae = Ge.set;
    he = function he(e, t) {
      if (we.call(Ge, e)) throw new TypeError(ye);
      return t.facade = e, Ae.call(Ge, e, t), t;
    }, me = function me(e) {
      return He.call(Ge, e) || {};
    }, Se = function Se(e) {
      return we.call(Ge, e);
    };
  } else {
    var Me = be("state");
    ge[Me] = !0, he = function he(e, t) {
      if (W(e, Me)) throw new TypeError(ye);
      return t.facade = e, D(e, Me, t), t;
    }, me = function me(e) {
      return W(e, Me) ? e[Me] : {};
    }, Se = function Se(e) {
      return W(e, Me);
    };
  }
  var Ee = {
      set: he,
      get: me,
      has: Se,
      enforce: function enforce(e) {
        return Se(e) ? me(e) : he(e, {});
      },
      getterFor: function getterFor(e) {
        return function (t) {
          var i;
          if (!H(t) || (i = me(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
          return i;
        };
      }
    },
    Ie = t(function (e) {
      var t = Ee.get,
        i = Ee.enforce,
        a = String(String).split("String");
      (e.exports = function (e, t, o, r) {
        var n,
          s = !!r && !!r.unsafe,
          c = !!r && !!r.enumerable,
          l = !!r && !!r.noTargetGet;
        "function" == typeof o && ("string" != typeof t || W(o, "name") || D(o, "name", t), (n = i(o)).source || (n.source = a.join("string" == typeof t ? t : ""))), e !== y ? (s ? !l && e[t] && (c = !0) : delete e[t], c ? e[t] = o : D(e, t, o)) : c ? e[t] = o : N(t, o);
      })(Function.prototype, "toString", function () {
        return "function" == typeof this && t(this).source || pe(this);
      });
    }),
    xe = ce("toStringTag"),
    Le = "Arguments" == z(function () {
      return arguments;
    }()),
    Oe = ue ? z : function (e) {
      var t, i, a;
      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (i = function (e, t) {
        try {
          return e[t];
        } catch (e) {}
      }(t = Object(e), xe)) ? i : Le ? z(t) : "Object" == (a = z(t)) && "function" == typeof t.callee ? "Arguments" : a;
    },
    Pe = ue ? {}.toString : function () {
      return "[object " + Oe(this) + "]";
    };
  ue || Ie(Object.prototype, "toString", Pe, {
    unsafe: !0
  });
  var De = {}.propertyIsEnumerable,
    Ne = Object.getOwnPropertyDescriptor,
    Xe = {
      f: Ne && !De.call({
        1: 2
      }, 1) ? function (e) {
        var t = Ne(this, e);
        return !!t && t.enumerable;
      } : De
    },
    Re = "".split,
    Be = C(function () {
      return !Object("z").propertyIsEnumerable(0);
    }) ? function (e) {
      return "String" == z(e) ? Re.call(e, "") : Object(e);
    } : Object,
    ke = function ke(e) {
      return Be(k(e));
    },
    Ue = Object.getOwnPropertyDescriptor,
    Ve = {
      f: G ? Ue : function (e, t) {
        if (e = ke(e), t = x(t, !0), E) try {
          return Ue(e, t);
        } catch (e) {}
        if (W(e, t)) return P(!Xe.f.call(e, t), e[t]);
      }
    },
    We = Math.ceil,
    Fe = Math.floor,
    Ze = function Ze(e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? Fe : We)(e);
    },
    Ke = Math.min,
    _e = function _e(e) {
      return e > 0 ? Ke(Ze(e), 9007199254740991) : 0;
    },
    ze = Math.max,
    je = Math.min,
    Ye = function Ye(e, t) {
      var i = Ze(e);
      return i < 0 ? ze(i + t, 0) : je(i, t);
    },
    qe = function qe(e) {
      return function (t, i, a) {
        var o,
          r = ke(t),
          n = _e(r.length),
          s = Ye(a, n);
        if (e && i != i) {
          for (; n > s;) {
            if ((o = r[s++]) != o) return !0;
          }
        } else for (; n > s; s++) {
          if ((e || s in r) && r[s] === i) return e || s || 0;
        }
        return !e && -1;
      };
    },
    Qe = {
      includes: qe(!0),
      indexOf: qe(!1)
    },
    Je = Qe.indexOf,
    $e = function $e(e, t) {
      var i,
        a = ke(e),
        o = 0,
        r = [];
      for (i in a) {
        !W(ge, i) && W(a, i) && r.push(i);
      }
      for (; t.length > o;) {
        W(a, i = t[o++]) && (~Je(r, i) || r.push(i));
      }
      return r;
    },
    et = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
    tt = et.concat("length", "prototype"),
    it = {
      f: Object.getOwnPropertyNames || function (e) {
        return $e(e, tt);
      }
    },
    at = {
      f: Object.getOwnPropertySymbols
    },
    ot = Q("Reflect", "ownKeys") || function (e) {
      var t = it.f(I(e)),
        i = at.f;
      return i ? t.concat(i(e)) : t;
    },
    rt = function rt(e, t) {
      for (var i = ot(t), a = O.f, o = Ve.f, r = 0; r < i.length; r++) {
        var n = i[r];
        W(e, n) || a(e, n, o(t, n));
      }
    },
    nt = /#|\.prototype\./,
    st = function st(e, t) {
      var i = lt[ct(e)];
      return i == dt || i != ut && ("function" == typeof t ? C(t) : !!t);
    },
    ct = st.normalize = function (e) {
      return String(e).replace(nt, ".").toLowerCase();
    },
    lt = st.data = {},
    ut = st.NATIVE = "N",
    dt = st.POLYFILL = "P",
    ht = st,
    mt = Ve.f,
    St = function St(e, t) {
      var i,
        a,
        o,
        r,
        n,
        s = e.target,
        c = e.global,
        l = e.stat;
      if (i = c ? y : l ? y[s] || N(s, {}) : (y[s] || {}).prototype) for (a in t) {
        if (r = t[a], o = e.noTargetGet ? (n = mt(i, a)) && n.value : i[a], !ht(c ? a : s + (l ? "." : "#") + a, e.forced) && void 0 !== o) {
          if (typeof r == typeof o) continue;
          rt(r, o);
        }
        (e.sham || o && o.sham) && D(r, "sham", !0), Ie(i, a, r, e);
      }
    },
    pt = y.Promise,
    Tt = function Tt(e, t, i) {
      for (var a in t) {
        Ie(e, a, t[a], i);
      }
      return e;
    },
    vt = O.f,
    ft = ce("toStringTag"),
    bt = function bt(e, t, i) {
      e && !W(e = i ? e : e.prototype, ft) && vt(e, ft, {
        configurable: !0,
        value: t
      });
    },
    gt = ce("species"),
    yt = function yt(e) {
      if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
      return e;
    },
    Ct = function Ct(e, t, i) {
      if (!(e instanceof t)) throw TypeError("Incorrect " + (i ? i + " " : "") + "invocation");
      return e;
    },
    Gt = {},
    Ht = ce("iterator"),
    wt = Array.prototype,
    At = function At(e) {
      return void 0 !== e && (Gt.Array === e || wt[Ht] === e);
    },
    Mt = function Mt(e, t, i) {
      if (yt(e), void 0 === t) return e;
      switch (i) {
        case 0:
          return function () {
            return e.call(t);
          };
        case 1:
          return function (i) {
            return e.call(t, i);
          };
        case 2:
          return function (i, a) {
            return e.call(t, i, a);
          };
        case 3:
          return function (i, a, o) {
            return e.call(t, i, a, o);
          };
      }
      return function () {
        return e.apply(t, arguments);
      };
    },
    Et = ce("iterator"),
    It = function It(e) {
      if (null != e) return e[Et] || e["@@iterator"] || Gt[Oe(e)];
    },
    xt = function xt(e) {
      var t = e.return;
      if (void 0 !== t) return I(t.call(e)).value;
    },
    Lt = function Lt(e, t) {
      this.stopped = e, this.result = t;
    },
    Ot = function Ot(e, t, i) {
      var a,
        o,
        r,
        n,
        s,
        c,
        l,
        u = i && i.that,
        d = !(!i || !i.AS_ENTRIES),
        h = !(!i || !i.IS_ITERATOR),
        m = !(!i || !i.INTERRUPTED),
        S = Mt(t, u, 1 + d + m),
        p = function p(e) {
          return a && xt(a), new Lt(!0, e);
        },
        T = function T(e) {
          return d ? (I(e), m ? S(e[0], e[1], p) : S(e[0], e[1])) : m ? S(e, p) : S(e);
        };
      if (h) a = e;else {
        if ("function" != typeof (o = It(e))) throw TypeError("Target is not iterable");
        if (At(o)) {
          for (r = 0, n = _e(e.length); n > r; r++) {
            if ((s = T(e[r])) && s instanceof Lt) return s;
          }
          return new Lt(!1);
        }
        a = o.call(e);
      }
      for (c = a.next; !(l = c.call(a)).done;) {
        try {
          s = T(l.value);
        } catch (e) {
          throw xt(a), e;
        }
        if ("object" == typeof s && s && s instanceof Lt) return s;
      }
      return new Lt(!1);
    },
    Pt = ce("iterator"),
    Dt = !1;
  try {
    var Nt = 0,
      Xt = {
        next: function next() {
          return {
            done: !!Nt++
          };
        },
        return: function _return() {
          Dt = !0;
        }
      };
    Xt[Pt] = function () {
      return this;
    }, Array.from(Xt, function () {
      throw 2;
    });
  } catch (e) {}
  var Rt,
    Bt,
    kt,
    Ut = ce("species"),
    Vt = function Vt(e, t) {
      var i,
        a = I(e).constructor;
      return void 0 === a || null == (i = I(a)[Ut]) ? t : yt(i);
    },
    Wt = Q("document", "documentElement"),
    Ft = /(?:iphone|ipod|ipad).*applewebkit/i.test(J),
    Zt = y.location,
    Kt = y.setImmediate,
    _t = y.clearImmediate,
    zt = y.process,
    jt = y.MessageChannel,
    Yt = y.Dispatch,
    qt = 0,
    Qt = {},
    Jt = "onreadystatechange",
    $t = function $t(e) {
      if (Qt.hasOwnProperty(e)) {
        var t = Qt[e];
        delete Qt[e], t();
      }
    },
    ei = function ei(e) {
      return function () {
        $t(e);
      };
    },
    ti = function ti(e) {
      $t(e.data);
    },
    ii = function ii(e) {
      y.postMessage(e + "", Zt.protocol + "//" + Zt.host);
    };
  Kt && _t || (Kt = function Kt(e) {
    for (var t = [], i = 1; arguments.length > i;) {
      t.push(arguments[i++]);
    }
    return Qt[++qt] = function () {
      ("function" == typeof e ? e : Function(e)).apply(void 0, t);
    }, Rt(qt), qt;
  }, _t = function _t(e) {
    delete Qt[e];
  }, j ? Rt = function Rt(e) {
    zt.nextTick(ei(e));
  } : Yt && Yt.now ? Rt = function Rt(e) {
    Yt.now(ei(e));
  } : jt && !Ft ? (kt = (Bt = new jt()).port2, Bt.port1.onmessage = ti, Rt = Mt(kt.postMessage, kt, 1)) : y.addEventListener && "function" == typeof postMessage && !y.importScripts && Zt && "file:" !== Zt.protocol && !C(ii) ? (Rt = ii, y.addEventListener("message", ti, !1)) : Rt = Jt in M("script") ? function (e) {
    Wt.appendChild(M("script")).onreadystatechange = function () {
      Wt.removeChild(this), $t(e);
    };
  } : function (e) {
    setTimeout(ei(e), 0);
  });
  var ai,
    oi,
    ri,
    ni,
    si,
    ci,
    li,
    ui,
    di = {
      set: Kt,
      clear: _t
    },
    hi = /web0s(?!.*chrome)/i.test(J),
    mi = Ve.f,
    Si = di.set,
    pi = y.MutationObserver || y.WebKitMutationObserver,
    Ti = y.document,
    vi = y.process,
    fi = y.Promise,
    bi = mi(y, "queueMicrotask"),
    gi = bi && bi.value;
  gi || (ai = function ai() {
    var e, t;
    for (j && (e = vi.domain) && e.exit(); oi;) {
      t = oi.fn, oi = oi.next;
      try {
        t();
      } catch (e) {
        throw oi ? ni() : ri = void 0, e;
      }
    }
    ri = void 0, e && e.enter();
  }, Ft || j || hi || !pi || !Ti ? fi && fi.resolve ? (li = fi.resolve(void 0), ui = li.then, ni = function ni() {
    ui.call(li, ai);
  }) : ni = j ? function () {
    vi.nextTick(ai);
  } : function () {
    Si.call(y, ai);
  } : (si = !0, ci = Ti.createTextNode(""), new pi(ai).observe(ci, {
    characterData: !0
  }), ni = function ni() {
    ci.data = si = !si;
  }));
  var yi,
    Ci,
    Gi,
    Hi,
    wi = gi || function (e) {
      var t = {
        fn: e,
        next: void 0
      };
      ri && (ri.next = t), oi || (oi = t, ni()), ri = t;
    },
    Ai = function Ai(e) {
      var t, i;
      this.promise = new e(function (e, a) {
        if (void 0 !== t || void 0 !== i) throw TypeError("Bad Promise constructor");
        t = e, i = a;
      }), this.resolve = yt(t), this.reject = yt(i);
    },
    Mi = {
      f: function f(e) {
        return new Ai(e);
      }
    },
    Ei = function Ei(e, t) {
      if (I(e), H(t) && t.constructor === e) return t;
      var i = Mi.f(e);
      return (0, i.resolve)(t), i.promise;
    },
    Ii = function Ii(e) {
      try {
        return {
          error: !1,
          value: e()
        };
      } catch (e) {
        return {
          error: !0,
          value: e
        };
      }
    },
    xi = di.set,
    Li = ce("species"),
    Oi = "Promise",
    Pi = Ee.get,
    Di = Ee.set,
    Ni = Ee.getterFor(Oi),
    _Xi = pt,
    Ri = y.TypeError,
    Bi = y.document,
    ki = y.process,
    Ui = Q("fetch"),
    Vi = Mi.f,
    Wi = Vi,
    Fi = !!(Bi && Bi.createEvent && y.dispatchEvent),
    Zi = "function" == typeof PromiseRejectionEvent,
    Ki = "unhandledrejection",
    _i = ht(Oi, function () {
      if (!(pe(_Xi) !== String(_Xi))) {
        if (66 === ie) return !0;
        if (!j && !Zi) return !0;
      }
      if (ie >= 51 && /native code/.test(_Xi)) return !1;
      var e = _Xi.resolve(1),
        t = function t(e) {
          e(function () {}, function () {});
        };
      return (e.constructor = {})[Li] = t, !(e.then(function () {}) instanceof t);
    }),
    zi = _i || !function (e, t) {
      if (!t && !Dt) return !1;
      var i = !1;
      try {
        var a = {};
        a[Pt] = function () {
          return {
            next: function next() {
              return {
                done: i = !0
              };
            }
          };
        }, e(a);
      } catch (e) {}
      return i;
    }(function (e) {
      _Xi.all(e).catch(function () {});
    }),
    ji = function ji(e) {
      var t;
      return !(!H(e) || "function" != typeof (t = e.then)) && t;
    },
    Yi = function Yi(e, t) {
      if (!e.notified) {
        e.notified = !0;
        var i = e.reactions;
        wi(function () {
          for (var a = e.value, o = 1 == e.state, r = 0; i.length > r;) {
            var n,
              s,
              c,
              l = i[r++],
              u = o ? l.ok : l.fail,
              d = l.resolve,
              h = l.reject,
              m = l.domain;
            try {
              u ? (o || (2 === e.rejection && $i(e), e.rejection = 1), !0 === u ? n = a : (m && m.enter(), n = u(a), m && (m.exit(), c = !0)), n === l.promise ? h(Ri("Promise-chain cycle")) : (s = ji(n)) ? s.call(n, d, h) : d(n)) : h(a);
            } catch (e) {
              m && !c && m.exit(), h(e);
            }
          }
          e.reactions = [], e.notified = !1, t && !e.rejection && Qi(e);
        });
      }
    },
    qi = function qi(e, t, i) {
      var a, o;
      Fi ? ((a = Bi.createEvent("Event")).promise = t, a.reason = i, a.initEvent(e, !1, !0), y.dispatchEvent(a)) : a = {
        promise: t,
        reason: i
      }, !Zi && (o = y["on" + e]) ? o(a) : e === Ki && function (e, t) {
        var i = y.console;
        i && i.error && (1 === arguments.length ? i.error(e) : i.error(e, t));
      }("Unhandled promise rejection", i);
    },
    Qi = function Qi(e) {
      xi.call(y, function () {
        var t,
          i = e.facade,
          a = e.value;
        if (Ji(e) && (t = Ii(function () {
          j ? ki.emit("unhandledRejection", a, i) : qi(Ki, i, a);
        }), e.rejection = j || Ji(e) ? 2 : 1, t.error)) throw t.value;
      });
    },
    Ji = function Ji(e) {
      return 1 !== e.rejection && !e.parent;
    },
    $i = function $i(e) {
      xi.call(y, function () {
        var t = e.facade;
        j ? ki.emit("rejectionHandled", t) : qi("rejectionhandled", t, e.value);
      });
    },
    ea = function ea(e, t, i) {
      return function (a) {
        e(t, a, i);
      };
    },
    ta = function ta(e, t, i) {
      e.done || (e.done = !0, i && (e = i), e.value = t, e.state = 2, Yi(e, !0));
    },
    ia = function ia(e, t, i) {
      if (!e.done) {
        e.done = !0, i && (e = i);
        try {
          if (e.facade === t) throw Ri("Promise can't be resolved itself");
          var a = ji(t);
          a ? wi(function () {
            var i = {
              done: !1
            };
            try {
              a.call(t, ea(ia, i, e), ea(ta, i, e));
            } catch (t) {
              ta(i, t, e);
            }
          }) : (e.value = t, e.state = 1, Yi(e, !1));
        } catch (t) {
          ta({
            done: !1
          }, t, e);
        }
      }
    };
  _i && (_Xi = function Xi(e) {
    Ct(this, _Xi, Oi), yt(e), yi.call(this);
    var t = Pi(this);
    try {
      e(ea(ia, t), ea(ta, t));
    } catch (e) {
      ta(t, e);
    }
  }, (yi = function yi(e) {
    Di(this, {
      type: Oi,
      done: !1,
      notified: !1,
      parent: !1,
      reactions: [],
      rejection: !1,
      state: 0,
      value: void 0
    });
  }).prototype = Tt(_Xi.prototype, {
    then: function then(e, t) {
      var i = Ni(this),
        a = Vi(Vt(this, _Xi));
      return a.ok = "function" != typeof e || e, a.fail = "function" == typeof t && t, a.domain = j ? ki.domain : void 0, i.parent = !0, i.reactions.push(a), 0 != i.state && Yi(i, !1), a.promise;
    },
    catch: function _catch(e) {
      return this.then(void 0, e);
    }
  }), Ci = function Ci() {
    var e = new yi(),
      t = Pi(e);
    this.promise = e, this.resolve = ea(ia, t), this.reject = ea(ta, t);
  }, Mi.f = Vi = function Vi(e) {
    return e === _Xi || e === Gi ? new Ci(e) : Wi(e);
  }, "function" == typeof pt && (Hi = pt.prototype.then, Ie(pt.prototype, "then", function (e, t) {
    var i = this;
    return new _Xi(function (e, t) {
      Hi.call(i, e, t);
    }).then(e, t);
  }, {
    unsafe: !0
  }), "function" == typeof Ui && St({
    global: !0,
    enumerable: !0,
    forced: !0
  }, {
    fetch: function fetch(e) {
      return Ei(_Xi, Ui.apply(y, arguments));
    }
  }))), St({
    global: !0,
    wrap: !0,
    forced: _i
  }, {
    Promise: _Xi
  }), bt(_Xi, Oi, !1), function (e) {
    var t = Q(e),
      i = O.f;
    G && t && !t[gt] && i(t, gt, {
      configurable: !0,
      get: function get() {
        return this;
      }
    });
  }(Oi), Gi = Q(Oi), St({
    target: Oi,
    stat: !0,
    forced: _i
  }, {
    reject: function reject(e) {
      var t = Vi(this);
      return t.reject.call(void 0, e), t.promise;
    }
  }), St({
    target: Oi,
    stat: !0,
    forced: _i
  }, {
    resolve: function resolve(e) {
      return Ei(this, e);
    }
  }), St({
    target: Oi,
    stat: !0,
    forced: zi
  }, {
    all: function all(e) {
      var t = this,
        i = Vi(t),
        a = i.resolve,
        o = i.reject,
        r = Ii(function () {
          var i = yt(t.resolve),
            r = [],
            n = 0,
            s = 1;
          Ot(e, function (e) {
            var c = n++,
              l = !1;
            r.push(void 0), s++, i.call(t, e).then(function (e) {
              l || (l = !0, r[c] = e, --s || a(r));
            }, o);
          }), --s || a(r);
        });
      return r.error && o(r.value), i.promise;
    },
    race: function race(e) {
      var t = this,
        i = Vi(t),
        a = i.reject,
        o = Ii(function () {
          var o = yt(t.resolve);
          Ot(e, function (e) {
            o.call(t, e).then(i.resolve, a);
          });
        });
      return o.error && a(o.value), i.promise;
    }
  });
  /*!
  	 * cookie
  	 * Copyright(c) 2012-2014 Roman Shtylman
  	 * Copyright(c) 2015 Douglas Christopher Wilson
  	 * MIT Licensed
  	 */
  var aa = function aa(e, t) {
      if ("string" != typeof e) throw new TypeError("argument str must be a string");
      for (var i = {}, a = t || {}, o = e.split(sa), r = a.decode || ra, n = 0; n < o.length; n++) {
        var s = o[n],
          c = s.indexOf("=");
        if (!(c < 0)) {
          var l = s.substr(0, c).trim(),
            u = s.substr(++c, s.length).trim();
          '"' == u[0] && (u = u.slice(1, -1)), null == i[l] && (i[l] = la(u, r));
        }
      }
      return i;
    },
    oa = function oa(e, t, i) {
      var a = i || {},
        o = a.encode || na;
      if ("function" != typeof o) throw new TypeError("option encode is invalid");
      if (!ca.test(e)) throw new TypeError("argument name is invalid");
      var r = o(t);
      if (r && !ca.test(r)) throw new TypeError("argument val is invalid");
      var n = e + "=" + r;
      if (null != a.maxAge) {
        var s = a.maxAge - 0;
        if (isNaN(s) || !isFinite(s)) throw new TypeError("option maxAge is invalid");
        n += "; Max-Age=" + Math.floor(s);
      }
      if (a.domain) {
        if (!ca.test(a.domain)) throw new TypeError("option domain is invalid");
        n += "; Domain=" + a.domain;
      }
      if (a.path) {
        if (!ca.test(a.path)) throw new TypeError("option path is invalid");
        n += "; Path=" + a.path;
      }
      if (a.expires) {
        if ("function" != typeof a.expires.toUTCString) throw new TypeError("option expires is invalid");
        n += "; Expires=" + a.expires.toUTCString();
      }
      a.httpOnly && (n += "; HttpOnly");
      a.secure && (n += "; Secure");
      if (a.sameSite) {
        switch ("string" == typeof a.sameSite ? a.sameSite.toLowerCase() : a.sameSite) {
          case !0:
            n += "; SameSite=Strict";
            break;
          case "lax":
            n += "; SameSite=Lax";
            break;
          case "strict":
            n += "; SameSite=Strict";
            break;
          case "none":
            n += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return n;
    },
    ra = decodeURIComponent,
    na = encodeURIComponent,
    sa = /; */,
    ca = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
  function la(e, t) {
    try {
      return t(e);
    } catch (t) {
      return e;
    }
  }
  function ua(e, t) {
    void 0 === t && (t = {});
    var i = function (e) {
      if (e && "j" === e[0] && ":" === e[1]) return e.substr(2);
      return e;
    }(e);
    if (function (e, t) {
      return void 0 === t && (t = !e || "{" !== e[0] && "[" !== e[0] && '"' !== e[0]), !t;
    }(i, t.doNotParse)) try {
      return JSON.parse(i);
    } catch (e) {}
    return e;
  }
  var _da = function da() {
      return (_da = Object.assign || function (e) {
        for (var t, i = 1, a = arguments.length; i < a; i++) {
          for (var o in t = arguments[i]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }).apply(this, arguments);
    },
    ha = new (function () {
      function e(e, t) {
        var i = this;
        this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.cookies = function (e, t) {
          return "string" == typeof e ? aa(e, t) : "object" == typeof e && null !== e ? e : {};
        }(e, t), new Promise(function () {
          i.HAS_DOCUMENT_COOKIE = "object" == typeof document && "string" == typeof document.cookie;
        }).catch(function () {});
      }
      return e.prototype._updateBrowserValues = function (e) {
        this.HAS_DOCUMENT_COOKIE && (this.cookies = aa(document.cookie, e));
      }, e.prototype._emitChange = function (e) {
        for (var t = 0; t < this.changeListeners.length; ++t) {
          this.changeListeners[t](e);
        }
      }, e.prototype.get = function (e, t, i) {
        return void 0 === t && (t = {}), this._updateBrowserValues(i), ua(this.cookies[e], t);
      }, e.prototype.getAll = function (e, t) {
        void 0 === e && (e = {}), this._updateBrowserValues(t);
        var i = {};
        for (var a in this.cookies) {
          i[a] = ua(this.cookies[a], e);
        }
        return i;
      }, e.prototype.set = function (e, t, i) {
        var a;
        "object" == typeof t && (t = JSON.stringify(t)), this.cookies = _da(_da({}, this.cookies), ((a = {})[e] = t, a)), this.HAS_DOCUMENT_COOKIE && (document.cookie = oa(e, t, i)), this._emitChange({
          name: e,
          value: t,
          options: i
        });
      }, e.prototype.remove = function (e, t) {
        var i = t = _da(_da({}, t), {
          expires: new Date(1970, 1, 1, 0, 0, 1),
          maxAge: 0
        });
        this.cookies = _da({}, this.cookies), delete this.cookies[e], this.HAS_DOCUMENT_COOKIE && (document.cookie = oa(e, "", i)), this._emitChange({
          name: e,
          value: void 0,
          options: t
        });
      }, e.prototype.addChangeListener = function (e) {
        this.changeListeners.push(e);
      }, e.prototype.removeChangeListener = function (e) {
        var t = this.changeListeners.indexOf(e);
        t >= 0 && this.changeListeners.splice(t, 1);
      }, e;
    }())();
  function ma() {
    var e = c.accessToken,
      t = ha.get(e, {
        path: "/"
      });
    if (!c.clientId || !c.clientSecret) return console.log("无clientId和clientSecret，无法发起数据上报"), t;
    if (!t && va.tokenFlag) {
      ga();
      var i = new FormData();
      return i.append("client_id", c.clientId), i.append("client_secret", c.clientSecret), i.append("grant_type", "client_credentials"), fetch(c.accessTokenUrl, {
        method: "POST",
        body: i
      }).then(function (e) {
        return e.json();
      }).then(function (e) {
        return e && e.access_token ? (Sa(e.access_token), ya(), e.access_token) : null;
      }).catch(function (e) {
        ga();
      });
    }
    return t;
  }
  function Sa(e) {
    var t = c.accessToken;
    ha.set(t, e, {
      path: "/"
    });
  }
  function pa() {
    ga();
    var e = new FormData();
    return e.append("client_id", c.clientId), e.append("client_secret", c.clientSecret), e.append("grant_type", "client_credentials"), fetch(c.accessTokenUrl, {
      method: "POST",
      body: e
    }).then(function (e) {
      return e.json();
    }).then(function (e) {
      var t;
      e && e.access_token ? (ya(), Sa(e.access_token)) : (t = c.accessToken, ha.remove(t, {
        path: "/"
      }));
    }).catch(function (e) {
      ga();
    });
  }
  var Ta = new (function () {
      function e() {
        this.url = c.reportUrl.indexOf("?") > 0 ? c.reportUrl + "&uuid=" + c.serviceId : c.reportUrl + "?uuid=" + c.serviceId;
      }
      return e.prototype.sendByXhr = function (e, t, i) {
        return r(this, void 0, void 0, function () {
          var i, a, o, r, s, l;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, ma()];
              case 1:
                if (i = n.sent()) {
                  if (this.url = c.reportUrl + "?uuid=" + c.serviceId, a = window.__oXMLHttpRequest_ || window.XMLHttpRequest, delete e.collector, !this.url) return [2];
                  (o = new a()).open("post", this.url, !0), o.setRequestHeader("Authorization", "bearer " + i), o.onreadystatechange = function () {
                    4 === o.readyState && (null == t || t(o)), 4 === o.readyState && 401 === o.status && pa();
                  }, r = (r = Array.isArray(e) ? e : [e]).map(function (e) {
                    return Va(e);
                  }), s = new FormData(), l = Ua(d(this.url, r)), s.append("source", new Blob([l], {
                    type: "application/x-bzip"
                  })), o.send(s);
                }
                return [2];
            }
          });
        });
      }, e;
    }())(),
    va = {
      isRegister: !1,
      isFirst: !1,
      page: "",
      sid: "",
      contextId: "",
      sBegin: Date.now(),
      _health: {
        errcount: 0,
        apisucc: 0,
        apifail: 0
      },
      circle: !1,
      cssInserted: !1,
      segments: [],
      monitorSegments: {
        api: [],
        error: [],
        common: [],
        behavior: []
      },
      customSegments: [],
      customMsg: [],
      messageIndexPrefix: "X-wa-metrics-cache",
      customMsgIndexPrefix: "X-wa-metrics-cache-custom",
      tokenFlag: !0,
      reportFlag: !0,
      customReportFlag: !0,
      resourceFlag: !0
    };
  function fa(e) {
    va.contextId = e;
  }
  function ba(e) {
    va.segments.push(e);
  }
  function ga() {
    va.tokenFlag = !1;
  }
  function ya() {
    va.tokenFlag = !0;
  }
  function Ca(e) {
    return va.reportFlag = e;
  }
  function Ga(e) {
    return va.customReportFlag = e;
  }
  function Ha() {
    va.monitorSegments = {
      api: [],
      error: [],
      common: [],
      behavior: []
    }, Ca(!0);
  }
  function wa(e, t) {
    var i = Ua(e);
    va.monitorSegments[t].push(i);
    var a = Ma();
    a.length === c.maxBatchLength && va.reportFlag && (Ca(!1), Ta.sendByXhr(a), Ha());
  }
  function Aa(e) {
    var t = Ua(e);
    va.customSegments.push(t), va.customSegments.length === c.maxBatchLength && va.customReportFlag && (Ga(!1), Ta.sendByXhr(va.customSegments), va.customSegments = [], Ga(!0));
  }
  function Ma() {
    var e = [];
    return Object.keys(va.monitorSegments).forEach(function (t) {
      e = e.concat(va.monitorSegments[t]);
    }), e;
  }
  var Ea = function Ea() {};
  function Ia() {
    for (var e, t, i = 20, a = new Array(i), o = Date.now().toString(36).split(""); i-- > 0;) {
      t = (e = 36 * Math.random() | 0).toString(36), a[i] = e % 3 ? t : t.toUpperCase();
    }
    for (var r = 0; r < 8; r++) {
      a.splice(3 * r + 2, 0, o[r]);
    }
    return a.join("");
  }
  function xa(e, t) {
    var i = 0,
      a = e.length;
    if (function (e, t) {
      var i = Object.prototype.toString.call(e).substring(8).replace("]", "");
      return t ? i === t : i;
    }(e, "Array")) for (; i < a && !1 !== t.call(e[i], e[i], i); i++) {
      ;
    } else for (var o in e) {
      if (!1 === t.call(e[o], e[o], o)) break;
    }
    return e;
  }
  var La = function La(e, t, i) {
      window.addEventListener ? window.addEventListener(e, function (e) {
        t.call(this, e);
      }, !0) : window.attachEvent && window.attachEvent("on" + e, function (e) {
        t.call(this, e);
      });
    },
    Oa = function Oa(e) {
      return (e ? Pa(e.replace(/^#\/?/, "")) : "") || "[index]";
    },
    Pa = function Pa(e) {
      return e && "string" == typeof e ? e.replace(/^(https?:)?\/\//, "").replace(/\?.*$/, "") : "";
    },
    Da = function () {
      var e = "object" == typeof console ? console.warn : Ea;
      try {
        var t = {
          warn: e
        };
        t.warn.call(t);
      } catch (e) {
        return Ea;
      }
      return e;
    }(),
    Na = function Na(e, t) {
      var i;
      "function" == typeof window.CustomEvent ? i = new CustomEvent(e, {
        detail: t
      }) : ((i = window.document.createEvent("HTMLEvents")).initEvent(e, !1, !0), i.detail = t), window.dispatchEvent(i);
    },
    Xa = self != top;
  function Ra() {
    return va.page ? va.page : location.pathname.toLowerCase();
  }
  function Ba() {
    var e = localStorage.getItem("pvuid") || "";
    return e || (e = Ia(), localStorage.setItem("pvuid", e)), e;
  }
  function ka() {
    var e,
      t,
      i,
      a,
      o = function (e) {
        var t = e + "=",
          i = document.cookie.indexOf(t);
        if (-1 == i) return "";
        var a = document.cookie.indexOf(";", i + t.length);
        -1 == a && (a = document.cookie.length);
        return document.cookie.substring(i + t.length, a);
      }("hops_agent_wa_uid") || "";
    return o || (o = Ia(), e = "hops_agent_wa_uid", t = o, i = function () {
      var e = new Date(),
        t = 23 - e.getHours(),
        i = 59 - e.getMinutes();
      return 1e3 * (3600 * t + 60 * i);
    }(), (a = new Date()).setTime(a.getTime() + i), document.cookie = e + "=" + t + "; path=/;expires = " + new Date(2147483647e3).toGMTString(), localStorage.setItem("hops_agent_wa_uid", o)), o;
  }
  function Ua(e) {
    var t = encodeURIComponent(JSON.stringify(e));
    return btoa(t);
  }
  function Va(e) {
    var t = atob(e),
      i = decodeURIComponent(t);
    return JSON.parse(i);
  }
  function Wa(e) {
    return void 0 === e && (e = []), e.filter(function (e) {
      return !["fetch", "xmlhttprequest"].includes(e.initiatorType);
    });
  }
  var Fa = function Fa() {
    var e = I(this),
      t = "";
    return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
  };
  function Za(e, t) {
    return RegExp(e, t);
  }
  var Ka,
    _a,
    za = {
      UNSUPPORTED_Y: C(function () {
        var e = Za("a", "y");
        return e.lastIndex = 2, null != e.exec("abcd");
      }),
      BROKEN_CARET: C(function () {
        var e = Za("^r", "gy");
        return e.lastIndex = 2, null != e.exec("str");
      })
    },
    ja = RegExp.prototype.exec,
    Ya = B("native-string-replace", String.prototype.replace),
    qa = ja,
    Qa = (Ka = /a/, _a = /b*/g, ja.call(Ka, "a"), ja.call(_a, "a"), 0 !== Ka.lastIndex || 0 !== _a.lastIndex),
    Ja = za.UNSUPPORTED_Y || za.BROKEN_CARET,
    $a = void 0 !== /()??/.exec("")[1];
  (Qa || $a || Ja) && (qa = function qa(e) {
    var t,
      i,
      a,
      o,
      r = this,
      n = Ja && r.sticky,
      s = Fa.call(r),
      c = r.source,
      l = 0,
      u = e;
    return n && (-1 === (s = s.replace("y", "")).indexOf("g") && (s += "g"), u = String(e).slice(r.lastIndex), r.lastIndex > 0 && (!r.multiline || r.multiline && "\n" !== e[r.lastIndex - 1]) && (c = "(?: " + c + ")", u = " " + u, l++), i = new RegExp("^(?:" + c + ")", s)), $a && (i = new RegExp("^" + c + "$(?!\\s)", s)), Qa && (t = r.lastIndex), a = ja.call(n ? i : r, u), n ? a ? (a.input = a.input.slice(l), a[0] = a[0].slice(l), a.index = r.lastIndex, r.lastIndex += a[0].length) : r.lastIndex = 0 : Qa && a && (r.lastIndex = r.global ? a.index + a[0].length : t), $a && a && a.length > 1 && Ya.call(a[0], i, function () {
      for (o = 1; o < arguments.length - 2; o++) {
        void 0 === arguments[o] && (a[o] = void 0);
      }
    }), a;
  });
  var eo = qa;
  St({
    target: "RegExp",
    proto: !0,
    forced: /./.exec !== eo
  }, {
    exec: eo
  });
  var to = ce("species"),
    io = !C(function () {
      var e = /./;
      return e.exec = function () {
        var e = [];
        return e.groups = {
          a: "7"
        }, e;
      }, "7" !== "".replace(e, "$<a>");
    }),
    ao = "$0" === "a".replace(/./, "$0"),
    oo = ce("replace"),
    ro = !!/./[oo] && "" === /./[oo]("a", "$0"),
    no = !C(function () {
      var e = /(?:)/,
        t = e.exec;
      e.exec = function () {
        return t.apply(this, arguments);
      };
      var i = "ab".split(e);
      return 2 !== i.length || "a" !== i[0] || "b" !== i[1];
    }),
    so = function so(e, t, i, a) {
      var o = ce(e),
        r = !C(function () {
          var t = {};
          return t[o] = function () {
            return 7;
          }, 7 != ""[e](t);
        }),
        n = r && !C(function () {
          var t = !1,
            i = /a/;
          return "split" === e && ((i = {}).constructor = {}, i.constructor[to] = function () {
            return i;
          }, i.flags = "", i[o] = /./[o]), i.exec = function () {
            return t = !0, null;
          }, i[o](""), !t;
        });
      if (!r || !n || "replace" === e && (!io || !ao || ro) || "split" === e && !no) {
        var s = /./[o],
          c = i(o, ""[e], function (e, t, i, a, o) {
            return t.exec === RegExp.prototype.exec ? r && !o ? {
              done: !0,
              value: s.call(t, i, a)
            } : {
              done: !0,
              value: e.call(i, t, a)
            } : {
              done: !1
            };
          }, {
            REPLACE_KEEPS_$0: ao,
            REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: ro
          }),
          l = c[0],
          u = c[1];
        Ie(String.prototype, e, l), Ie(RegExp.prototype, o, 2 == t ? function (e, t) {
          return u.call(e, this, t);
        } : function (e) {
          return u.call(e, this);
        });
      }
      a && D(RegExp.prototype[o], "sham", !0);
    },
    co = function co(e) {
      return function (t, i) {
        var a,
          o,
          r = String(k(t)),
          n = Ze(i),
          s = r.length;
        return n < 0 || n >= s ? e ? "" : void 0 : (a = r.charCodeAt(n)) < 55296 || a > 56319 || n + 1 === s || (o = r.charCodeAt(n + 1)) < 56320 || o > 57343 ? e ? r.charAt(n) : a : e ? r.slice(n, n + 2) : o - 56320 + (a - 55296 << 10) + 65536;
      };
    },
    lo = {
      codeAt: co(!1),
      charAt: co(!0)
    },
    uo = lo.charAt,
    ho = function ho(e, t, i) {
      return t + (i ? uo(e, t).length : 1);
    },
    mo = function mo(e, t) {
      var i = e.exec;
      if ("function" == typeof i) {
        var a = i.call(e, t);
        if ("object" != typeof a) throw TypeError("RegExp exec method returned something other than an Object or null");
        return a;
      }
      if ("RegExp" !== z(e)) throw TypeError("RegExp#exec called on incompatible receiver");
      return eo.call(e, t);
    };
  so("match", 1, function (e, t, i) {
    return [function (t) {
      var i = k(this),
        a = null == t ? void 0 : t[e];
      return void 0 !== a ? a.call(t, i) : new RegExp(t)[e](String(i));
    }, function (e) {
      var a = i(t, e, this);
      if (a.done) return a.value;
      var o = I(e),
        r = String(this);
      if (!o.global) return mo(o, r);
      var n = o.unicode;
      o.lastIndex = 0;
      for (var s, c = [], l = 0; null !== (s = mo(o, r));) {
        var u = String(s[0]);
        c[l] = u, "" === u && (o.lastIndex = ho(r, _e(o.lastIndex), n)), l++;
      }
      return 0 === l ? null : c;
    }];
  });
  var So = Math.floor,
    po = "".replace,
    To = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
    vo = /\$([$&'`]|\d{1,2})/g,
    fo = function fo(e, t, i, a, o, r) {
      var n = i + e.length,
        s = a.length,
        c = vo;
      return void 0 !== o && (o = U(o), c = To), po.call(r, c, function (r, c) {
        var l;
        switch (c.charAt(0)) {
          case "$":
            return "$";
          case "&":
            return e;
          case "`":
            return t.slice(0, i);
          case "'":
            return t.slice(n);
          case "<":
            l = o[c.slice(1, -1)];
            break;
          default:
            var u = +c;
            if (0 === u) return r;
            if (u > s) {
              var d = So(u / 10);
              return 0 === d ? r : d <= s ? void 0 === a[d - 1] ? c.charAt(1) : a[d - 1] + c.charAt(1) : r;
            }
            l = a[u - 1];
        }
        return void 0 === l ? "" : l;
      });
    },
    bo = Math.max,
    go = Math.min;
  so("replace", 2, function (e, t, i, a) {
    var o = a.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE,
      r = a.REPLACE_KEEPS_$0,
      n = o ? "$" : "$0";
    return [function (i, a) {
      var o = k(this),
        r = null == i ? void 0 : i[e];
      return void 0 !== r ? r.call(i, o, a) : t.call(String(o), i, a);
    }, function (e, a) {
      if (!o && r || "string" == typeof a && -1 === a.indexOf(n)) {
        var s = i(t, e, this, a);
        if (s.done) return s.value;
      }
      var c = I(e),
        l = String(this),
        u = "function" == typeof a;
      u || (a = String(a));
      var d = c.global;
      if (d) {
        var h = c.unicode;
        c.lastIndex = 0;
      }
      for (var m = [];;) {
        var S = mo(c, l);
        if (null === S) break;
        if (m.push(S), !d) break;
        "" === String(S[0]) && (c.lastIndex = ho(l, _e(c.lastIndex), h));
      }
      for (var p, T = "", v = 0, f = 0; f < m.length; f++) {
        S = m[f];
        for (var b = String(S[0]), g = bo(go(Ze(S.index), l.length), 0), y = [], C = 1; C < S.length; C++) {
          y.push(void 0 === (p = S[C]) ? p : String(p));
        }
        var G = S.groups;
        if (u) {
          var H = [b].concat(y, g, l);
          void 0 !== G && H.push(G);
          var w = String(a.apply(void 0, H));
        } else w = fo(b, l, g, y, G, a);
        g >= v && (T += l.slice(v, g) + w, v = g + b.length);
      }
      return T + l.slice(v);
    }];
  });
  var yo = O.f,
    Co = Function.prototype,
    Go = Co.toString,
    Ho = /^\s*function ([^ (]*)/,
    wo = "name";
  function Ao(e, t, i) {
    return t in e ? Object.defineProperty(e, t, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = i, e;
  }
  function Mo(e, t) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      t && (a = a.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, a);
    }
    return i;
  }
  G && !(wo in Co) && yo(Co, wo, {
    configurable: !0,
    get: function get() {
      try {
        return Go.call(this).match(Ho)[1];
      } catch (e) {
        return "";
      }
    }
  });
  var Eo = Array.isArray || function (e) {
      return "Array" == z(e);
    },
    Io = function Io(e, t, i) {
      var a = x(t);
      a in e ? O.f(e, a, P(0, i)) : e[a] = i;
    },
    xo = ce("species"),
    Lo = function Lo(e) {
      return ie >= 51 || !C(function () {
        var t = [];
        return (t.constructor = {})[xo] = function () {
          return {
            foo: 1
          };
        }, 1 !== t[e](Boolean).foo;
      });
    },
    Oo = Lo("slice"),
    Po = ce("species"),
    Do = [].slice,
    No = Math.max;
  St({
    target: "Array",
    proto: !0,
    forced: !Oo
  }, {
    slice: function slice(e, t) {
      var i,
        a,
        o,
        r = ke(this),
        n = _e(r.length),
        s = Ye(e, n),
        c = Ye(void 0 === t ? n : t, n);
      if (Eo(r) && ("function" != typeof (i = r.constructor) || i !== Array && !Eo(i.prototype) ? H(i) && null === (i = i[Po]) && (i = void 0) : i = void 0, i === Array || void 0 === i)) return Do.call(r, s, c);
      for (a = new (void 0 === i ? Array : i)(No(c - s, 0)), o = 0; s < c; s++, o++) {
        s in r && Io(a, o, r[s]);
      }
      return a.length = o, a;
    }
  });
  var Xo = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
    Ro = "[" + Xo + "]",
    Bo = RegExp("^" + Ro + Ro + "*"),
    ko = RegExp(Ro + Ro + "*$"),
    Uo = function Uo(e) {
      return function (t) {
        var i = String(k(t));
        return 1 & e && (i = i.replace(Bo, "")), 2 & e && (i = i.replace(ko, "")), i;
      };
    },
    Vo = {
      start: Uo(1),
      end: Uo(2),
      trim: Uo(3)
    },
    Wo = Vo.trim;
  St({
    target: "String",
    proto: !0,
    forced: function (e) {
      return C(function () {
        return !!Xo[e]() || "​᠎" != "​᠎"[e]() || Xo[e].name !== e;
      });
    }("trim")
  }, {
    trim: function trim() {
      return Wo(this);
    }
  });
  var Fo = [].join,
    Zo = Be != Object,
    Ko = function (e, t) {
      var i = [][e];
      return !!i && C(function () {
        i.call(null, t || function () {
          throw 1;
        }, 1);
      });
    }("join", ",");
  St({
    target: "Array",
    proto: !0,
    forced: Zo || !Ko
  }, {
    join: function join(e) {
      return Fo.call(ke(this), void 0 === e ? "," : e);
    }
  });
  var _o = ce("match"),
    zo = function zo(e) {
      var t;
      return H(e) && (void 0 !== (t = e[_o]) ? !!t : "RegExp" == z(e));
    },
    jo = za.UNSUPPORTED_Y,
    Yo = [].push,
    qo = Math.min,
    Qo = 4294967295;
  so("split", 2, function (e, t, i) {
    var a;
    return a = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (e, i) {
      var a = String(k(this)),
        o = void 0 === i ? Qo : i >>> 0;
      if (0 === o) return [];
      if (void 0 === e) return [a];
      if (!zo(e)) return t.call(a, e, o);
      for (var r, n, s, c = [], l = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (e.sticky ? "y" : ""), u = 0, d = new RegExp(e.source, l + "g"); (r = eo.call(d, a)) && !((n = d.lastIndex) > u && (c.push(a.slice(u, r.index)), r.length > 1 && r.index < a.length && Yo.apply(c, r.slice(1)), s = r[0].length, u = n, c.length >= o));) {
        d.lastIndex === r.index && d.lastIndex++;
      }
      return u === a.length ? !s && d.test("") || c.push("") : c.push(a.slice(u)), c.length > o ? c.slice(0, o) : c;
    } : "0".split(void 0, 0).length ? function (e, i) {
      return void 0 === e && 0 === i ? [] : t.call(this, e, i);
    } : t, [function (t, i) {
      var o = k(this),
        r = null == t ? void 0 : t[e];
      return void 0 !== r ? r.call(t, o, i) : a.call(String(o), t, i);
    }, function (e, o) {
      var r = i(a, e, this, o, a !== t);
      if (r.done) return r.value;
      var n = I(e),
        s = String(this),
        c = Vt(n, RegExp),
        l = n.unicode,
        u = (n.ignoreCase ? "i" : "") + (n.multiline ? "m" : "") + (n.unicode ? "u" : "") + (jo ? "g" : "y"),
        d = new c(jo ? "^(?:" + n.source + ")" : n, u),
        h = void 0 === o ? Qo : o >>> 0;
      if (0 === h) return [];
      if (0 === s.length) return null === mo(d, s) ? [s] : [];
      for (var m = 0, S = 0, p = []; S < s.length;) {
        d.lastIndex = jo ? 0 : S;
        var T,
          v = mo(d, jo ? s.slice(S) : s);
        if (null === v || (T = qo(_e(d.lastIndex + (jo ? S : 0)), s.length)) === m) S = ho(s, S, l);else {
          if (p.push(s.slice(m, S)), p.length === h) return p;
          for (var f = 1; f <= v.length - 1; f++) {
            if (p.push(v[f]), p.length === h) return p;
          }
          S = m = T;
        }
      }
      return p.push(s.slice(m)), p;
    }];
  }, jo);
  var Jo = "toString",
    $o = RegExp.prototype,
    er = $o.toString,
    tr = C(function () {
      return "/a/b" != er.call({
        source: "a",
        flags: "b"
      });
    }),
    ir = er.name != Jo;
  (tr || ir) && Ie(RegExp.prototype, Jo, function () {
    var e = I(this),
      t = String(e.source),
      i = e.flags;
    return "/" + t + "/" + String(void 0 === i && e instanceof RegExp && !("flags" in $o) ? Fa.call(e) : i);
  }, {
    unsafe: !0
  });
  var ar = function () {
      var e,
        t = "Samsung",
        i = "Sony Ericsson",
        a = "Motorola",
        o = "LG",
        r = "HTC",
        n = "Coolpad",
        s = "Acer",
        c = {
          SAMSUNG: {
            "GT-S3370C": [t, "Corby 3G"],
            "GT-S3650": [t, "Corby"],
            "GT-S3653": [t, "Corby"],
            "GT-S3850": [t, "Corby II"],
            "GT-S5230": [t, "Star"],
            "GT-S5230W": [t, "Star"],
            "GT-S5233": [t, "Star"],
            "GT-S5260": [t, "Star II"],
            "GT-S5560": [t, "Marvel"],
            "GT-S5620": [t, "Monte"],
            "GT-S7550": [t, "Blue Earth"],
            "GT-S8000": [t, "Jet"],
            "GT-S8003": [t, "Jet"],
            "SGH-F480": [t, "Tocco"],
            "SGH-T528g": [t, "Straight Talk"],
            "GT-B3410": [t, "Star Qwerty"],
            "GT-B5310": [t, "Corby Pro"],
            "GT-B7722": [t, "Star Duos"],
            "GT-C6712": [t, "Star II Duos"]
          }
        },
        l = {
          SAMSUNG: {
            "GT- S5250": [t, "Wave 525"],
            "GT-S5250": [t, "Wave 525"],
            "GT-S5253": [t, "Wave 525"],
            "GT-S5330": [t, "Wave 533"],
            "GT-S5380": [t, "Wave Y"],
            "GT-S5380D": [t, "Wave Y"],
            "GT-S5380K": [t, "Wave Y"],
            "GT-S5750E": [t, "Wave 575"],
            "GT-S5753E": [t, "Wave 575"],
            "GT-S7230B": [t, "Wave 723"],
            "GT-S7230E": [t, "Wave 723"],
            "GT-S7233E": [t, "Wave 723"],
            "GT-S7250": [t, "Wave M"],
            "GT-S7250D": [t, "Wave M"],
            "GT-S8500": [t, "Wave"],
            "GT-S8500C": [t, "Wave"],
            "GT-S8500R": [t, "Wave"],
            "GT-S8500T": [t, "Wave"],
            "GT-S8530": [t, "Wave II"],
            "GT-S8600": [t, "Wave 3"],
            "SHW-M410": [t, "Wave 3"]
          }
        },
        u = {
          SAMSUNG: {
            "GT-I9500": [t, "GT-I9500"]
          }
        },
        d = {
          "Coolpad D508": [n, "D508"],
          "Coolpad E600": [n, "E600"],
          "SCH-F839": [t, "SCH-F839"]
        },
        h = {
          DX900: [s, "Tempo DX900"],
          F900: [s, "Tempo F900"],
          "Coolpad F800": [n, "F800"],
          "garmin-asus-Nuvifone-M10": ["Garmin-Asus", "Nuvifone M10"],
          "HP iPAQ 510": ["HP", "iPAQ 510"],
          "HD mini T5555": [r, "HD mini"],
          "HTC HD mini": [r, "HD mini"],
          "HTC HD mini T5555": [r, "HD mini"],
          "HTC HD2": [r, "HD2"],
          "HTC HD2 T8585": [r, "HD2"],
          "HD2 T8585": [r, "HD2"],
          "T-Mobile LEO": [r, "HD2"],
          dopodT5588: [r, "Hengshan"],
          "HTC Mega-T3333": [r, "Mega"],
          "HTC Snap S521": [r, "Snap"],
          "HTC Touch2 T3320": [r, "Touch 2"],
          "HTC Touch2 T3333": [r, "Touch 2"],
          "HTC Touch2 T3335": [r, "Touch 2"],
          "HTC P3700": [r, "Touch Diamond"],
          "HTC Touch Diamond2 T5353": [r, "Touch Diamond 2"],
          "HTC Touch HD T8282": [r, "Touch HD"],
          "HTC Touch HD T8283": [r, "Touch HD"],
          "HTC Touch HD2 T8585": [r, "Touch HD2"],
          "HTC Touch Pro2 T7373": [r, "Touch Pro 2"],
          T7380: [r, "Touch Pro 2"],
          "HTC TyTN II": [r, "TyTN II"],
          "GT-B7300": [t, "Omnia Lite"],
          "GT-B7610": [t, "Omnia Pro"],
          "GT-i8000": [t, "Omnia 2"],
          "GT-I8000": [t, "Omnia 2"],
          "GT-I8000U": [t, "Omnia 2"],
          M1i: [i, "M1i Aspen"]
        },
        m = {
          Acer: {
            Allegro: [s, "Allegro"],
            M310: [s, "Allegro"]
          },
          Asus: {
            Galaxy6: ["Asus", "Galaxy 6"]
          },
          DELL: {
            "Venue Pro": ["Dell", "Venue Pro"]
          },
          FujitsuToshibaMobileCommun: {
            IS12T: ["Fujitsu Toshiba", "IS12T"]
          },
          HTC: {
            "7 Mozart": [r, "7 Mozart"],
            "7 Mozart T8698": [r, "7 Mozart"],
            T8697: [r, "7 Mozart"],
            T8698: [r, "7 Mozart"],
            PD67100: [r, "7 Mozart"],
            "Mozart T8698": [r, "7 Mozart"],
            Mozart: [r, "7 Mozart"],
            "USCCHTC-PC93100": [r, "Arrive"],
            Gold: [r, "Gold "],
            HD2: [r, "HD2"],
            HD7: [r, "HD7"],
            "HD7 T9292": [r, "HD7"],
            T9295: [r, "HD7"],
            T9296: [r, "HD7"],
            "HD7 Infinity": [r, "HD7"],
            T7575: [r, "7 Pro"],
            "7 Pro T7576": [r, "7 Pro"],
            mwp6985: [r, "Trophy"],
            "7 Trophy T8686": [r, "Trophy"],
            "7 Trophy": [r, "Trophy"],
            PC40100: [r, "Trophy"],
            "Touch-IT Trophy": [r, "Trophy"],
            Radar: [r, "Radar"],
            "Radar 4G": [r, "Radar"],
            "Radar C110e": [r, "Radar"],
            Mazaa: [r, "Mazaa"],
            Mondrian: [r, "Mondrian"],
            Schubert: [r, "Schubert"],
            "7 Schubert T9292": [r, "Schubert"],
            Spark: [r, "Spark"],
            T8788: [r, "Surround"],
            "TITAN X310e": [r, "Titan"],
            X310e: [r, "Titan"],
            PI39100: [r, "Titan"],
            PI86100: [r, "Titan II"],
            Ultimate: [r, "Ultimate"]
          },
          LG: {
            GW910: [o, "Optimus 7"],
            "LG E-900": [o, "Optimus 7 E900"],
            "LG-E900": [o, "Optimus 7 E900"],
            "LG-E900h": [o, "Optimus 7 E900"],
            "LG-C900": [o, "Optimus 7Q"],
            "LG-C900B": [o, "Quantum"],
            "LG-C900k": [o, "Quantum"]
          },
          nokia: {
            SeaRay: ["Nokia", "Lumia 800"],
            "800C": ["Nokia", "Lumia 800"]
          },
          NOKIA: {
            710: ["Nokia", "Lumia 710"],
            "Nokia 710": ["Nokia", "Lumia 710"],
            "Lumia 710": ["Nokia", "Lumia 710"],
            "Lumia 719": ["Nokia", "Lumia 719"],
            "Lumia 800": ["Nokia", "Lumia 800"],
            800: ["Nokia", "Lumia 800"],
            "Lumia 900": ["Nokia", "Lumia 900"],
            XXX: ["Nokia", "prototype"]
          },
          SAMSUNG: {
            "GT-I8350": [t, "Omnia W"],
            "GT-I8350T": [t, "Omnia W"],
            "SGH-i677": [t, "Focus Flash"],
            "SGH-i707": [t, "Taylor"],
            "SGH-i917": [t, "Omnia 7"],
            "SGH-I917": [t, "Omnia 7"],
            "SGH-i917.": [t, "Focus"],
            "SGH-i917R": [t, "Focus"],
            "SGH-i937": [t, "Focus S"],
            OMNIA7: [t, "Omnia 7"],
            OMINA7: [t, "Omnia 7"],
            Taylor: [t, "Taylor"]
          },
          TOSHIBA: {
            TSUNAGI: ["Toshiba", "Tsunagi"]
          }
        },
        S = (Ao(e = {
          Android: [null, null],
          "google sdk": [null, null],
          sdk: [null, null],
          generic: [null, null],
          "generic x86": [null, null],
          "amd brazos": ["AMD", "Fusionbased device"],
          "Amlogic M1 reference board": ["Amlogic", "M1 reference board"],
          AML8726M: ["Amlogic", "AML8726-Mbased device"],
          "vexpress a9": ["ARM", "Versatile Express development platform"],
          bcm7231: ["Broadcom", "BCM7231based device", "television"],
          bcm7425: ["Broadcom", "BCM7425based device", "television"],
          bcm7429: ["Broadcom", "BCM7429based device", "television"],
          "imx50 rdp": ["Freescale", "i.MX50based device"],
          "imx51 bbg": ["Freescale", "i.MX51based device"],
          "imx53 loco": ["Freescale", "i.MX53based device"],
          "imx53 mp204f3": ["Freescale", "i.MX53based device"],
          "imx53 smd": ["Freescale", "i.MX53based device"],
          "imx53 yeagle": ["Freescale", "i.MX53based device"],
          imx6q: ["Freescale", "i.MX6Qbased device"],
          "ODROID-A": ["Hardkernel", "ODROID-A developer tablet", "tablet"],
          "mfld dv10": ["Intel", "Medfieldbased device"],
          "mfld dv20": ["Intel", "Medfieldbased device"],
          "mfld lw00": ["Intel", "Medfieldbased device"],
          "mfld pr2": ["Intel", "Medfieldbased device"],
          "mfld pr3": ["Intel", "Medfieldbased device"],
          "berlin bg2": ["Marvell", "Armada 1000based device", "television"],
          "MStar Amber3": ["MStar", "Amber3based device"],
          "Konka Amber3": ["MStar", "Amber3based device"],
          mt5396: ["Mediatek", "MT5396based device", "television"],
          bird75v2: ["Mediatek", "MT6575based device"],
          "eagle75v1 2": ["Mediatek", "MT6575based device"],
          "MBX DVBT reference board (c03ref)": ["MXB", "DVBT reference board", "television"],
          NS2816: ["Nufront", "NuSmart 2816based device"],
          Ventana: ["nVidia", "Tegra Ventana development kit"],
          Cardhu: ["nVidia", "Tegra 3based device"],
          Panda: ["Pandaboard", "Development Kit"],
          pandaboard: ["Pandaboard", "Development Kit"],
          PandaBoard: ["Pandaboard", "Development Kit"],
          MSM: ["Qualcomm", "Snapdragonbased device"],
          "msm7227 ffa": ["Qualcomm", "Snapdragon S1based device"],
          "msm7627 surf": ["Qualcomm", "Snapdragon S1based device"],
          msm7627a: ["Qualcomm", "Snapdragon S1based device"],
          "msm7627a sku1": ["Qualcomm", "Snapdragon S1based device"],
          "msm7627a sku3": ["Qualcomm", "Snapdragon S1based device"],
          "msm7630 fusion": ["Qualcomm", "Snapdragon S2based device"],
          "msm7630 surf": ["Qualcomm", "Snapdragon S2based device"],
          "msm8660 cougar": ["Qualcomm", "Snapdragon S3based device"],
          "msm8660 surf": ["Qualcomm", "Snapdragon S3based device"],
          msm8960: ["Qualcomm", "Snapdragon S4based device"],
          rk2808sdk: ["Rockchip", "RK2808based device"],
          RK2818: ["Rockchip", "RK2818based device"],
          rk2818sdk: ["Rockchip", "RK2818based device"],
          "Android-for-Rockchip-2818": ["Rockchip", "RK2818based device"],
          rk29sdk: ["Rockchip", "RK29based device"],
          Rk29sdk: ["Rockchip", "RK29based device"],
          rk30sdk: ["Rockchip", "RK30based device"],
          s3c6410: ["Samsung", "S3C6410based device"],
          smdk6410: ["Samsung", "S3C6410based device"],
          SMDKC110: ["Samsung", "Exynos 3110based device"],
          SMDKV210: ["Samsung", "Exynos 4210based device"],
          S5PV210: ["Samsung", "Exynos 4210based device"],
          "sec smdkc210": ["Samsung", "Exynos 4210based device"],
          SMDK4x12: ["Samsung", "Exynos 4212 or 4412based device"],
          smp86xx: ["Sigma", "SMP86xxbased device", "television"],
          sv8860: ["Skyviia", "SV8860based device", "television"],
          "ste u8500": ["ST Ericsson", "Novathor U8500based device"],
          "Telechips M801 Evaluation Board": ["Telechips", "M801based device", "television"],
          "Telechips TCC8900 Evaluation Board": ["Telechips", "TCC8900based device", "television"],
          "TCC8920 STB EV": ["Telechips", "TCC8920based device", "television"],
          OMAP: ["Texas Instruments", "OMAPbased device"],
          "OMAP SS": ["Texas Instruments", "OMAPbased device"],
          "LogicPD Zoom2": ["Texas Instruments", "OMAPbased device"],
          omap3evm: ["Texas Instruments", "OMAP3based device"],
          Omap5sevm: ["Texas Instruments", "OMAP5based device"],
          "pnx8473 kiryung": ["Trident", "PNX8473based device", "television"],
          crespo: ["Google", "Nexus S"],
          Crespo: ["Google", "Nexus S"],
          Crespo4G: ["Google", "Nexus S"],
          Passion: ["Google", "Nexus One"],
          Bravo: ["HTC", "Desire"],
          dream: ["HTC", "Dream"],
          Vogue: ["HTC", "Touch"],
          "Vendor Optimus": ["LG", "Optimus"],
          Stingray: ["Motorola", "XOOM", "tablet"],
          Wingray: ["Motorola", "XOOM", "tablet"],
          maguro: ["Samsung", "Galaxy Nexus"],
          Maguro: ["Samsung", "Galaxy Nexus"],
          "Toro-VZW": ["Samsung", "Galaxy Nexus"],
          blaze: ["Texas Instruments", "Blaze Tablet", "tablet"],
          Blaze: ["Texas Instruments", "Blaze Tablet", "tablet"],
          "Blaze Tablet": ["Texas Instruments", "Blaze Tablet", "tablet"],
          BlueStacks: ["BlueStacks", "App Player", "desktop"],
          "youwave custom": ["Youwave", "Android on PC", "desktop"],
          A100: ["Acer", "Iconia Tab A100", "tablet"],
          A101: ["Acer", "Iconia Tab A101", "tablet"],
          A200: ["Acer", "Iconia Tab A200", "tablet"],
          A500: ["Acer", "Iconia Tab A500", "tablet"],
          A501: ["Acer", "Iconia Tab A501", "tablet"],
          A510: ["Acer", "Iconia Tab A510", "tablet"],
          A511: ["Acer", "Iconia Tab A511", "tablet"],
          A700: ["Acer", "Iconia Tab A700", "tablet"],
          "Acer A800": ["Acer", "Iconia Tab A800", "tablet"],
          E110: ["Acer", "beTouch E110"],
          E120: ["Acer", "beTouch E120"],
          E130: ["Acer", "beTouch E130"],
          E140: ["Acer", "beTouch E140"],
          E210: ["Acer", "beTouch E210"],
          E310: ["Acer", "Liquid mini"],
          E320: ["Acer", "Liquid Express"],
          E330: ["Acer", "Liquid Glow"],
          E400: ["Acer", "beTouch E400"],
          G100W: ["Acer", "G100W"],
          S100: ["Acer", "Liquid"],
          S110: ["Acer", "Stream"],
          S120: ["Acer", "Liquid mt"],
          S300: ["Acer", "Iconia Smart"],
          S500: ["Acer", "CloudMobile"],
          TD600: ["Acer", "beTouch TD600"],
          Liquid: ["Acer", "Liquid"],
          "Liquid E": ["Acer", "Liquid E"],
          "Liquid Mt": ["Acer", "Liquid mt"],
          "Liquid MT": ["Acer", "Liquid mt"],
          "Liquid Metal": ["Acer", "Liquid mt"],
          Stream: ["Acer", "Stream"],
          N700: ["aigo", "N700", "tablet"],
          M801: ["aigo", "M801", "tablet"],
          Novo7: ["Ainovo", "Novo7", "tablet"],
          "Novo7 Aurora": ["Ainovo", "Novo7 Aurora", "tablet"],
          "Novo7 Advanced": ["Ainovo", "Novo7 Advanced", "tablet"],
          "Novo7 Advanced2": ["Ainovo", "Novo7 Advanced 2", "tablet"],
          "Novo7 Basic": ["Ainovo", "Novo7 Basic", "tablet"],
          "Novo7 ELF": ["Ainovo", "Novo7 Elf", "tablet"],
          "Novo7 PALADIN": ["Ainovo", "Novo7 Paladin", "tablet"],
          "Novo8 Advanced": ["Ainovo", "Novo8 Advanced", "tablet"],
          "one touch 890": ["Alcatel", "One Touch 890"],
          "one touch 890D": ["Alcatel", "One Touch 890"],
          "one touch 891": ["Alcatel", "One Touch 891"],
          "ONE TOUCH 903": ["Alcatel", "One Touch 903SHV-E170K"],
          "one touch 906": ["Alcatel", "One Touch 906"],
          "one touch 908": ["Alcatel", "One Touch 908"],
          "one touch 908F": ["Alcatel", "One Touch 908"],
          "one touch 908S": ["Alcatel", "One Touch 908"],
          "one touch 910": ["Alcatel", "One Touch 910"],
          "one touch 918": ["Alcatel", "One Touch 918"],
          "one touch 918D": ["Alcatel", "One Touch 918"],
          "ONE TOUCH 918D": ["Alcatel", "One Touch 918"],
          "one touch 918M": ["Alcatel", "One Touch 918"],
          "one touch 918N": ["Alcatel", "One Touch 918"],
          "one touch 980": ["Alcatel", "One Touch 980"],
          "one touch 980A": ["Alcatel", "One Touch 980"],
          "one touch 981A": ["Alcatel", "One Touch 981"],
          "one touch 986": ["Alcatel", "One Touch 986"],
          "one touch 990": ["Alcatel", "One Touch 990"],
          "one touch 990A": ["Alcatel", "One Touch 990"],
          "one touch 991": ["Alcatel", "One Touch 991"],
          "one touch 991D": ["Alcatel", "One Touch 991"],
          "ONE TOUCH 993": ["Alcatel", "One Touch 993"],
          "one touch 995": ["Alcatel", "One Touch 995"],
          "Telenor OneTouch": ["Alcatel", "One Touch 990"],
          "OT 918": ["Alcatel", "One Touch 918"],
          Venture: ["Alcatel", "Venture"],
          "Allwinner A10": ["AllWinner", "A10", "tablet"],
          "97FC": ["AllWinner", "A10 97FC", "tablet"],
          "Kindle Fire": ["Amazon", "Kindle Fire", "tablet"],
          "Amazon Kindle Fire": ["Amazon", "Kindle Fire", "tablet"],
          AMD120: ["AnyDATA", "AnyTAB AMD120", "tablet"],
          MW0811: ["AOC", "Breeze MW0811", "tablet"],
          "MW0821 V2.0": ["AOC", "Breeze MW0821", "tablet"],
          MW0922: ["AOC", "Breeze MW0922", "tablet"],
          "Apanda A60": ["Apanda", "A60"],
          "apanda-A60": ["Apanda", "A60"],
          A80KSC: ["Archos", "Arnova 8", "tablet"],
          AN7CG2: ["Archos", "Arnova 7", "tablet"],
          A101B: ["Archos", "Arnova 10", "tablet"],
          AN10BG2DT: ["Archos", "Arnova 10 B", "tablet"],
          AN10G2: ["Archos", "Arnova 10 G2", "tablet"],
          A32: ["Archos", "32", "media"],
          A35DE: ["Archos", "35 Smart Home Phone"],
          A43: ["Archos", "43", "media"],
          Archos5: ["Archos", "5", "media"],
          A70H: ["Archos", "7", "tablet"],
          A70HB: ["Archos", "7", "tablet"],
          A70BHT: ["Archos", "7", "tablet"],
          A70CHT: ["Archos", "7C", "tablet"],
          A70S: ["Archos", "70", "tablet"],
          A7EB: ["Archos", "70B", "tablet"],
          "ARCHOS 70it2": ["Archos", "70 IT 2", "tablet"],
          "ARCHOS 80G9": ["Archos", "80 G9", "tablet"],
          "ARCHOS 101G9": ["Archos", "101 G9", "tablet"],
          A101IT: ["Archos", "101 IT", "tablet"],
          ASTRI: ["ASTRI", "e-reader", "ereader"],
          eeepc: ["Asus", "Eee Pc"],
          "asus laptop": ["Asus", "Eee Pc"],
          ME171: ["Asus", "Eee Pad MeMO", "tablet"],
          "Slider SL101": ["Asus", "Eee Pad Slider", "tablet"],
          EPAD: ["Asus", "Eee Pad Transformer", "tablet"],
          TF101: ["Asus", "Eee Pad Transformer", "tablet"],
          "Transformer TF101": ["Asus", "Eee Pad Transformer", "tablet"],
          "Transformer TF101G": ["Asus", "Eee Pad Transformer", "tablet"],
          TF201: ["Asus", "Eee Pad Transformer Prime", "tablet"],
          "Transformer Prime TF201": ["Asus", "Eee Pad Transformer Prime", "tablet"],
          "Transformer Prime": ["Asus", "Eee Pad Transformer Prime", "tablet"],
          "Transformer Pad TF300T": ["Asus", "Transformer Pad 300", "tablet"],
          "ASUS Transformer TF300T": ["Asus", "Transformer Pad 300", "tablet"],
          "ASUS Transformer Pad TF300T": ["Asus", "Transformer Pad 300", "tablet"],
          "ASUS Transformer Pad TF300TG": ["Asus", "Transformer Pad 300", "tablet"],
          "ASUS Transformer Pad TF700T": ["Asus", "Transformer Pad Infinity 700", "tablet"],
          "ASUS Transformer Pad TF700K": ["Asus", "Transformer Pad Infinity 700", "tablet"],
          "ASUS Transformer TF700K": ["Asus", "Transformer Pad Infinity 700", "tablet"],
          PadFone: ["Asus", "Padfone", "tablet"],
          "OMS TTD": ["Asus", "Eee Pc T10"],
          "ASUS T20": ["Asus", "Eee Pc T20"],
          ETBW11AA: ["Asus", "Tough"],
          "AUX V900": ["AUX", "V900"],
          M910A: ["AUX", "M910"],
          "PICOpad-QGN": ["Axioo", "Picopad QGN", "tablet"],
          NOOK: ["Barnes & Noble", "NOOK", "ereader"],
          NookColor: ["Barnes & Noble", "NOOK Color", "ereader"],
          "NOOK BNRV200": ["Barnes & Noble", "NOOK Color", "ereader"],
          "NOOK BNRV300": ["Barnes & Noble", "NOOK Color", "ereader"],
          NookTablet: ["Barnes & Noble", "NOOK Tablet", "ereader"],
          "Nook Tablet": ["Barnes & Noble", "NOOK Tablet", "ereader"],
          "NOOK BNTV250": ["Barnes & Noble", "NOOK Tablet", "ereader"],
          "NOOK BNTV250A": ["Barnes & Noble", "NOOK Tablet", "ereader"],
          BNTV250: ["Barnes & Noble", "NOOK Tablet", "ereader"],
          BNTV250A: ["Barnes & Noble", "NOOK Tablet", "ereader"],
          "NOOK Slate": ["Barnes & Noble", "NOOK Tablet", "ereader"],
          "BenWee 5100": ["BenWee", "5100"],
          CA907AAC0G: ["Besta", "CA907AAC0G"],
          BM999: ["Bmorn", "BM999", "tablet"],
          V11: ["Bmorn", "V11", "tablet"],
          V99: ["Bmorn", "V99", "tablet"],
          "bq DaVinci": ["bq", "DaVinci", "tablet"],
          CT704: ["Carrefour", "CT704", "tablet"],
          CT1002: ["Carrefour", "CT1002", "tablet"],
          "Camangi-Mangrove7": ["Camangi", "Mangrove 7", "tablet"],
          WS171: ["Camangi", "WebStation", "tablet"],
          IS11CA: ["Casio", "GzOne IS11CA"],
          C771: ["Casio", "GzOne Commando"],
          "CAT NOVA": ["Cat", "NOVA", "tablet"],
          ARMM3V: ["chinaleap", "ARMM3V", "tablet"],
          "CIUS-7": ["Cisco", "Cius", "tablet"],
          "CIUS-7-AT": ["Cisco", "Cius", "tablet"],
          "CSL Spice MI300": ["CSL", "Spice MI300"],
          "CSL-MI410": ["CSL", "Spice MI410"],
          MID1024: ["Coby", "Kyros MID1024", "tablet"],
          MID1125: ["Coby", "Kyros MID1125", "tablet"],
          MID1126: ["Coby", "Kyros MID1126", "tablet"],
          MID7010: ["Coby", "Kyros MID7010", "tablet"],
          MID7012: ["Coby", "Kyros MID7012", "tablet"],
          MID7015: ["Coby", "Kyros MID7015", "tablet"],
          MID7015A: ["Coby", "Kyros MID7015", "tablet"],
          MID7016: ["Coby", "Kyros MID7016", "tablet"],
          MID7020: ["Coby", "Kyros MID7020", "tablet"],
          MID7022: ["Coby", "Kyros MID7022", "tablet"],
          MID7024: ["Coby", "Kyros MID7024", "tablet"],
          MID7025: ["Coby", "Kyros MID7025", "tablet"],
          MID7127: ["Coby", "Kyros MID7127", "tablet"],
          MID8024: ["Coby", "Kyros MID8024", "tablet"],
          MID8125: ["Coby", "Kyros MID8125", "tablet"],
          MID8127: ["Coby", "Kyros MID8127", "tablet"],
          Z71: ["Commtiva", "Z71"],
          "V-T100": ["Commtiva", "V-T100"],
          "FIH-FB0": ["Commtiva", "HD700"],
          "Coolpad D510": ["Coolpad", "D510"],
          "Coolpad 8020": ["Coolpad", "8020"],
          D530: ["Coolpad", "D530"],
          "Coolpad D530": ["Coolpad", "D530"],
          D539: ["Coolpad", "D539"],
          "Coolpad D539": ["Coolpad", "D539"],
          E239: ["Coolpad", "E239"],
          "Coolpad E239": ["Coolpad", "E239"],
          "Coolpad N930": ["Coolpad", "N930"],
          N930: ["Coolpad", "N930"],
          "Coolpad W706": ["Coolpad", "W706"],
          "Coolpad W706+": ["Coolpad", "W706"],
          "Coolpad W708": ["Coolpad", "W708"],
          W711: ["Coolpad", "W711"],
          "Coolpad 5010": ["Coolpad", "5010"],
          "Coolpad 5210": ["Coolpad", "5210"],
          "Coolpad 5820": ["Coolpad", "5820"],
          5832: ["Coolpad", "5832"],
          "Coolpad 5832": ["Coolpad", "5832"],
          5855: ["Coolpad", "5855"],
          "Coolpad 5860": ["Coolpad", "5860"],
          "Coolpad 5860+": ["Coolpad", "5860"],
          "Coolpad 5860s": ["Coolpad", "5860"],
          5860: ["Coolpad", "5860"],
          "5860A": ["Coolpad", "5860"],
          "Coolpad 5870": ["Coolpad", "5870"],
          5870: ["Coolpad", "5870"],
          "Coolpad 7005": ["Coolpad", "7005"],
          7260: ["Coolpad", "7260"],
          "Coolpad 7019": ["Coolpad", "7019"],
          "Coolpad 7260": ["Coolpad", "7260"],
          "Coolpad 8013": ["Coolpad", "8013"],
          "Coolpad 8809": ["Coolpad", "8809"],
          "Coolpad 8810": ["Coolpad", "8810"],
          8810: ["Coolpad", "8810"],
          8150: ["Coolpad", "8150"],
          "Coolpad 8150D": ["Coolpad", "8150"],
          "Coolpad 8811": ["Coolpad", "8811"],
          "Coolpad 9900": ["Coolpad", "9900"],
          "Coolpad 8050": ["Coolpad", "8050"],
          ZiiO7: ["Creative", "ZiiO 7", "tablet"],
          "ZiiLABS ZiiO7": ["Creative", "ZiiO 7", "tablet"],
          "ZiiLABS ZiiO10 ": ["Creative", "ZiiO 10", "tablet"],
          "CUBE K8GT A": ["Cube", "K8GT A", "tablet"],
          "CUBE K8GT B": ["Cube", "K8GT B", "tablet"],
          "K8GT C": ["Cube", "K8GT C", "tablet"],
          "K8GT H": ["Cube", "K8GT H", "tablet"],
          "CUBE K8GT H": ["Cube", "K8GT H", "tablet"],
          "K8GT W": ["Cube", "K8GT W", "tablet"],
          "CUBE U8GT": ["Cube", "U8GT", "tablet"],
          "CUBE U9GT": ["Cube", "U9GT", "tablet"],
          "CUBE U9GT 2": ["Cube", "U9GT 2", "tablet"],
          "Cube U9GT2": ["Cube", "U9GT 2", "tablet"],
          U9GT: ["Cube", "U9GT", "tablet"],
          "U9GT2 From moage.com": ["Cube", "U9GT 2", "tablet"],
          "N90 From moage.com": ["Cube", "U9GT 2", "tablet"],
          "U9GT S": ["Cube", "U9GT S", "tablet"],
          "U9GT S A": ["Cube", "U9GT SA", "tablet"],
          "U9GTS A": ["Cube", "U9GT SA", "tablet"],
          "U10GT 2": ["Cube", "U10GT 2", "tablet"],
          "U10GT S": ["Cube", "U10GT S", "tablet"],
          "U30GT-H": ["Cube", "U30GT H", "tablet"],
          "CUBE Q7PRO": ["Cube", "Q7 Pro", "tablet"],
          "CUBE Q7PRO J": ["Cube", "Q7 Pro", "tablet"],
          "Cydle M7 (v0005.04.03.12.ko)": ["Cydle", "M7 MultiPAD", "tablet"],
          "Dell Aero": ["Dell", "Aero"],
          "Dell M01M": ["Dell", "Mini 5", "tablet"],
          "Dell Streak": ["Dell", "Streak", "tablet"],
          "001DL": ["Dell", "Streak", "tablet"],
          "101DL": ["Dell", "Streak Pro", "tablet"],
          GS01: ["Dell", "Streak Pro", "tablet"],
          "Dell Streak Pro": ["Dell", "Streak Pro", "tablet"],
          streak7: ["Dell", "Streak 7", "tablet"],
          "Dell Streak 7": ["Dell", "Streak 7", "tablet"],
          "Dell Streak 10 Pro": ["Dell", "Streak 10 Pro", "tablet"],
          "Dell V04B": ["Dell", "Streak V04B", "tablet"],
          "Dell Venue": ["Dell", "Venue"],
          "Dell XCD35": ["Dell", "XCD35"],
          XCD35: ["Dell", "XCD35"],
          iDx7: ["Digma", "iDx7", "tablet"],
          iDx10: ["Digma", "iDx10", "tablet"],
          "iDx10 3G": ["Digma", "iDx10", "tablet"],
          DM009SH: ["Disney Mobile", "DM009SH"],
          DM010SH: ["Disney Mobile", "DM010SH"],
          DM012SH: ["Disney Mobile", "DM012SH"],
          "F-08D": ["Disney Mobile", "F-08D"],
          "P-05D": ["Disney Mobile", "P-05D"],
          "Tablet-P27": ["DracoTek", "P27 Tablet", "tablet"],
          edgejr: ["EnTourage", "Pocket eDGe", "tablet"],
          l97D: ["EPad", "l97D", "tablet"],
          M4301: ["Eston", "MID M4301", "media"],
          P10AN: ["Exper", "Easypad P10AN", "tablet"],
          "FIH-F0X": ["FIH", "F0X"],
          "Fly IQ260": ["Fly", "IQ260 BlackBird"],
          ISW11F: ["Fujitsu", "Arrows Z"],
          ISW13F: ["Fujitsu", "Arrows Z"],
          IS12F: ["Fujitsu", "Arrows ES"],
          "F-01D": ["Fujitsu", "Arrows Tab LTE", "tablet"],
          "F-03D": ["Fujitsu", "Arrows Kiss"],
          "F-05D": ["Fujitsu", "Arrows X LTE"],
          "F-07D": ["Fujitsu", "Arrows Ã�Â¼"],
          "F-10D": ["Fujitsu", "Arrows X F-10D"],
          "F-12C": ["Fujitsu", "Globetrotter"],
          f12arc: ["Fujitsu", "F12arc"],
          M532: ["Fujitsu", "Stylistic M532", "tablet"],
          Garminfone: ["Garmin-Asus", "Garminfone"],
          "Garmin-Asus A10": ["Garmin-Asus", "Nuvifone A10"],
          "Garmin-Asus A50": ["Garmin-Asus", "Nuvifone A50"],
          TPA60W: ["Gateway", "TPA60W", "tablet"],
          "Geeksphone ZERO": ["Geeksphone", "ZERO"],
          "gemei G2": ["Gemei", "G2", "tablet"],
          "Gemei G2": ["Gemei", "G2", "tablet"],
          "gemei G3": ["Gemei", "G3", "tablet"],
          "Gemei G9": ["Gemei", "G9", "tablet"],
          "GSmart G1317D": ["Gigabyte", "GSmart G1317D"],
          "Gigabyte TB100": ["Gigabyte", "TB100", "tablet"],
          GN100: ["Gionee", "GN100"],
          GN105: ["Gionee", "GN105"],
          GN106: ["Gionee", "GN106"],
          GN200: ["Gionee", "GN200"],
          GN205: ["Gionee", "GN205"],
          GN700W: ["Gionee", "GN700W"],
          GN708W: ["Gionee", "GN708W"],
          "Google Ion": ["Google", "Ion"],
          "Nexus One": ["Google", "Nexus One"],
          NexusOne: ["Google", "Nexus One"],
          "HTC Nexus One": ["Google", "Nexus One"],
          "Nexus S": ["Google", "Nexus S"],
          "Google Nexus S": ["Google", "Nexus S"],
          "Nexus S 4G": ["Google", "Nexus S 4G"],
          "Dooderbutt-4.0.3-v1": ["Google", "Nexus S 4G"],
          "Nexus 7": ["Google", "Nexus 7", "tablet"],
          "Haier HW-W910": ["Haier", "HW-W910"],
          SN10T1: ["HANNspree", "HANNSpad SN10T1", "tablet"],
          SN10T2: ["HANNspree", "HANNSpad SN10T2", "tablet"],
          HannsComb: ["HANNspree", "HANNSpad", "tablet"],
          X1: ["HCL", "ME X1", "tablet"],
          "MID Serails": ["Herotab", "C8", "tablet"],
          "MID Serials": ["Herotab", "C8", "tablet"],
          "COSMO DUO": ["Hiscreen", "Cosmo DUO", "tablet"],
          "HS-U8": ["Hisense", "U8"],
          "HS-T92": ["Hisense", "T92"],
          "HS-E860": ["Hisense", "E860"],
          "HS-E910": ["Hisense", "E910"],
          "HS-E926": ["Hisense", "E926"],
          "HS-EG900": ["Hisense", "EG900"],
          "HS-ET919": ["Hisense", "ET919"],
          EG968B: ["Hisense", "EG968B"],
          "HKPHONE H8-3G": ["HKPhone", "H8 3G"],
          "HOSIN U2": ["Hosin", "U2"],
          Touchpad: ["HP", "TouchPad", "tablet"],
          "HP Touchpad": ["HP", "TouchPad", "tablet"],
          "cm tenderloin": ["HP", "TouchPad", "tablet"],
          "aokp tenderloin": ["HP", "TouchPad", "tablet"],
          "HTC Amaze 4G": ["HTC", "Amaze 4G"],
          "HTC Ruby": ["HTC", "Amaze 4G"],
          "HTC Amaze 4G(Ruby)": ["HTC", "Amaze 4G"],
          "Amaze 4G": ["HTC", "Amaze 4G"],
          "HTC Aria": ["HTC", "Aria"],
          "HTC Aria A6380": ["HTC", "Aria"],
          "HTC Liberty A6380": ["HTC", "Aria"],
          "HTC Liberty": ["HTC", "Aria"],
          "HTC A6366": ["HTC", "Aria"],
          "HTC Bee": ["HTC", "Bee"],
          "HTC ChaCha": ["HTC", "ChaCha"],
          "HTC ChaCha A810e": ["HTC", "ChaCha"],
          "HTC ChaChaCha A810e": ["HTC", "ChaCha"],
          "HTC A810e": ["HTC", "ChaCha"],
          "HTC A9188": ["HTC", "Tianxi"],
          "HTC Bravo": ["HTC", "Desire"],
          "HTC Desire": ["HTC", "Desire"],
          "HTC Desire A8181": ["HTC", "Desire"],
          "HTC Desire A8183": ["HTC", "Desire"],
          "HTC Desire Beats A8181": ["HTC", "Desire"],
          "HTC Desire CDMA": ["HTC", "Desire"],
          "HTC Desire SMS": ["HTC", "Desire"],
          "HTC Desire S.M.S": ["HTC", "Desire"],
          "HTC Desire C": ["HTC", "Desire C"],
          "HTC DesireHD": ["HTC", "Desire HD"],
          "HTC DesireHD A9191": ["HTC", "Desire HD"],
          "HTC DesireHD A9192": ["HTC", "Desire HD"],
          "HTC Desire HD A9191": ["HTC", "Desire HD"],
          "HTC A9191": ["HTC", "Desire HD"],
          "HTC A9191 for AT&T": ["HTC", "Desire HD"],
          "HTC A9192": ["HTC", "Desire HD"],
          "HTC Desire HD": ["HTC", "Desire HD"],
          "HTC Desire HD with Beats Audio": ["HTC", "Desire HD"],
          "HTC Desire S": ["HTC", "Desire S"],
          "HTC DesireS": ["HTC", "Desire S"],
          "HTC DesiresS": ["HTC", "Desire S"],
          "HTC DesireS S510e": ["HTC", "Desire S"],
          "HTC DesireS S510b": ["HTC", "Desire S"],
          "HTC Desire S S510e": ["HTC", "Desire S"],
          "HTC S510e": ["HTC", "Desire S"],
          "HTC Desire Saga": ["HTC", "Desire S"],
          "HTC Desire V": ["HTC", "Desire V"],
          "HTC T328w": ["HTC", "Desire V"],
          "HTC Desire VC": ["HTC", "Desire VC"],
          "HTC T328d": ["HTC", "Desire VC"],
          "HTC T328t": ["HTC", "Desire VT"],
          "HTC Desire Z": ["HTC", "Desire Z"],
          "HTC DesireZ": ["HTC", "Desire Z"],
          "HTC DesireZ A7272": ["HTC", "Desire Z"],
          "HTC Desire Z A7272": ["HTC", "Desire Z"],
          "HTC Vision": ["HTC", "Desire Z"],
          "HTC A7275": ["HTC", "Desire Z"],
          "HTC Dream": ["HTC", "Dream"],
          "HTC S710d": ["HTC", "Droid Incredible 2"],
          "HTC Incredible 2": ["HTC", "Droid Incredible 2"],
          "HTC X515d": ["HTC", "EVO 3D"],
          "HTC X515m": ["HTC", "EVO 3D"],
          "HTC X515C": ["HTC", "EVO 3D"],
          "HTC Evo 3D": ["HTC", "EVO 3D"],
          "HTC EVO 3D": ["HTC", "EVO 3D"],
          "HTC EVO 3D GSM": ["HTC", "EVO 3D"],
          "HTC EVO 3D X515a": ["HTC", "EVO 3D"],
          "HTC EVO 3D GSM X515m": ["HTC", "EVO 3D"],
          "HTC EVO 3D X515m": ["HTC", "EVO 3D"],
          "HTC EVO 3D X515M": ["HTC", "EVO 3D"],
          "HTC EVO3D X515a": ["HTC", "EVO 3D"],
          "HTC EVO3D X515m": ["HTC", "EVO 3D"],
          "HTC Evo 3D X515m": ["HTC", "EVO 3D"],
          "HTC Evo 3D with Beats Audio X515m": ["HTC", "EVO 3D"],
          "HTC Evo 4G": ["HTC", "EVO 4G"],
          "HTC EVO 4G": ["HTC", "EVO 4G"],
          "HTC X515E": ["HTC", "EVO 4G+"],
          "HTC EVO 4G+ For Sprint": ["HTC", "EVO 4G+"],
          "HTC EVO 4G++ For Sprint": ["HTC", "EVO 4G+"],
          "HTC C715c": ["HTC", "EVO Design 4G"],
          "HTC Design 4G": ["HTC", "EVO Design 4G"],
          "HTC EVO design 4G": ["HTC", "EVO Design 4G"],
          "HTC EVO Design 4G": ["HTC", "EVO Design 4G"],
          "HTC Evo Shift": ["HTC", "EVO Shift"],
          "HTC EVO Shift 4G": ["HTC", "EVO Shift"],
          "HTC A310e": ["HTC", "Explorer"],
          "HTC Explorer": ["HTC", "Explorer"],
          "HTC Explorer A310b": ["HTC", "Explorer"],
          "HTC Explorer A310e": ["HTC", "Explorer"],
          "HTC P510e": ["HTC", "Flyer", "tablet"],
          "HTC Flyer": ["HTC", "Flyer", "tablet"],
          "HTC Flyer P510e": ["HTC", "Flyer", "tablet"],
          "HTC Flyer P512": ["HTC", "Flyer", "tablet"],
          "HTC Flyer P512 NA": ["HTC", "Flyer", "tablet"],
          "HTC P515E": ["HTC", "Flyer 4G", "tablet"],
          "HTC Gratia A6380": ["HTC", "Gratia"],
          "HTC HD": ["HTC", "HD"],
          "HTC HD2": ["HTC", "HD2"],
          "HTC HD2 T8585": ["HTC", "HD2"],
          "HTC HD2(Leo)": ["HTC", "HD2"],
          "HTC HD7": ["HTC", "HD7"],
          "HTC T9299+": ["HTC", "HD7"],
          "HTC HD7 for Sprint": ["HTC", "HD7"],
          "HTC HD7 4G T9299 For AT&T": ["HTC", "HD7"],
          "HTC HD7 4G T9299+ For AT&T": ["HTC", "HD7"],
          "HTC T9299+ For AT&T": ["HTC", "HD7"],
          "HTC HD7S T9399+": ["HTC", "HD7s"],
          "HTC HD7S T9899+": ["HTC", "HD7s"],
          "HTC T9899+ For AT&T": ["HTC", "HD7s"],
          "VitMod ExtraLite 1.6.5.fullodex for HTC HD7 Pro": ["HTC", "HD7 Pro"],
          "HTC Hero": ["HTC", "Hero"],
          "HTC HERO": ["HTC", "Hero"],
          "HTC Hero CDMA": ["HTC", "Hero"],
          "HTC HERO CDMA": ["HTC", "Hero"],
          "HTC HERO200": ["HTC", "Hero 200"],
          "HTC Hero S": ["HTC", "Hero S"],
          "HTC IMAGIO": ["HTC", "Imagio"],
          "HTC Incredible": ["HTC", "Incredible"],
          "HTC Incredible S710E": ["HTC", "Incredible S"],
          "HTC S710e": ["HTC", "Incredible S"],
          "HTC Incredible S": ["HTC", "Incredible S"],
          "HTC Incredible S S710e": ["HTC", "Incredible S"],
          "HTC Incredible S s710e": ["HTC", "Incredible S"],
          "HTC IncredibleS S710e": ["HTC", "Incredible S"],
          "HTC Incredible S with Beats Audio": ["HTC", "Incredible S"],
          "HTC Vivo": ["HTC", "Incredible S"],
          "HTC Innovation": ["HTC", "Innovation"],
          "HTC Inspire 4G": ["HTC", "Inspire 4G"],
          "HTC HD7 Inspire 4G For Vodafone": ["HTC", "Inspire 4G"],
          "HTC P715a": ["HTC", "Jetstream", "tablet"],
          "HTC Legend": ["HTC", "Legend"],
          "HTC Magic": ["HTC", "Magic"],
          "HTC Sapphire": ["HTC", "Magic"],
          "HTC Lexikon": ["HTC", "Merge"],
          "HTC One S": ["HTC", "One S"],
          "HTC Z520e": ["HTC", "One S"],
          "HTC One V": ["HTC", "One V"],
          "HTC T320e": ["HTC", "One V"],
          "HTC One X": ["HTC", "One X"],
          "HTC S720e": ["HTC", "One X"],
          "HTC Endeavour-LS": ["HTC", "One X"],
          "HTC One XL": ["HTC", "One XL"],
          "HTC X710a": ["HTC", "Raider 4G"],
          "HTC Raider": ["HTC", "Raider 4G"],
          "HTC Raider X710e": ["HTC", "Raider 4G"],
          "HTC Raider X710s": ["HTC", "Raider 4G"],
          "HTC Raider 4G X710e": ["HTC", "Raider 4G"],
          "HTC PH39100": ["HTC", "Raider 4G"],
          "HTC Holiday": ["HTC", "Raider 4G"],
          "HTC Velocity 4G X710s": ["HTC", "Raider 4G"],
          "HTC Rezound": ["HTC", "Rezound"],
          "HTC Rhyme S510b": ["HTC", "Rhyme"],
          "HTC S510b": ["HTC", "Rhyme"],
          "HTC Bliss": ["HTC", "Rhyme"],
          "HTC Bliss S510b": ["HTC", "Rhyme"],
          "HTC Salsa C510e": ["HTC", "Salsa"],
          "HTC C510e": ["HTC", "Salsa"],
          "HTC Z710a": ["HTC", "Sensation"],
          "HTC Z710e": ["HTC", "Sensation"],
          "HTC Z710t": ["HTC", "Sensation"],
          "HTC Sensation": ["HTC", "Sensation"],
          "HTC Sensation Z710": ["HTC", "Sensation"],
          "HTC Sensation Z710a": ["HTC", "Sensation"],
          "HTC Sensation Z710e": ["HTC", "Sensation"],
          "HTC Sensation Z710E": ["HTC", "Sensation"],
          "HTC Sensation Z710e For AT&T": ["HTC", "Sensation"],
          "HTC Sensation Z710e with Beats Audio": ["HTC", "Sensation"],
          "HTC Sensation with Beats Audio Z710e": ["HTC", "Sensation"],
          "HTC Sensation with Beats Audio": ["HTC", "Sensation"],
          "HTC Sensation Taste": ["HTC", "Sensation"],
          "HTC Pyramid": ["HTC", "Sensation"],
          "HTC Pyramid Z710a": ["HTC", "Sensation"],
          "HTC Pyramid Z710e": ["HTC", "Sensation"],
          "HTC Sensation 4G": ["HTC", "Sensation"],
          "HTC Sensation 4G with Beats Audio": ["HTC", "Sensation"],
          "HTC Sensation G14": ["HTC", "Sensation"],
          "HTC Sensation G14 for AT&T": ["HTC", "Sensation"],
          "HTC G14 sensation": ["HTC", "Sensation"],
          "HTC Z715e": ["HTC", "Sensation XE"],
          "HTC Sensation Z715e": ["HTC", "Sensation XE"],
          "HTC SensationXE Beats": ["HTC", "Sensation XE"],
          "HTC SensationXE Beats Z715a": ["HTC", "Sensation XE"],
          "HTC SensationXE Beats Z715e": ["HTC", "Sensation XE"],
          "HTC Sensation XE": ["HTC", "Sensation XE"],
          "HTC Sensation XE Z715e": ["HTC", "Sensation XE"],
          "HTC SensationXE Z715e": ["HTC", "Sensation XE"],
          "HTC Sensation XE Beats": ["HTC", "Sensation XE"],
          "HTC SensationXE with Beats Audio": ["HTC", "Sensation XE"],
          "HTC Sensation XE with Beats Audio": ["HTC", "Sensation XE"],
          "HTC Sensation XE with Beats Audio Z715a": ["HTC", "Sensation XE"],
          "HTC Sensation Juredroid XE Beats Audio": ["HTC", "Sensation XE"],
          "HTC Sensation XE with Beats Audio Z715e": ["HTC", "Sensation XE"],
          "HTC Sensation XE With Beats Audio Z715e": ["HTC", "Sensation XE"],
          "HTC Sensation 4G XE with Beats Audio": ["HTC", "Sensation XE"],
          "HTC Sensation with Beats Audio Z715e": ["HTC", "Sensation XE"],
          "HTC X315E": ["HTC", "Sensation XL"],
          "HTC SensationXL Beats X315b": ["HTC", "Sensation XL"],
          "HTC SensationXL Beats X315e": ["HTC", "Sensation XL"],
          "HTC Sensation XL with Beats Audio X315b": ["HTC", "Sensation XL"],
          "HTC Sensation XL with Beats Audio X315e": ["HTC", "Sensation XL"],
          "HTC Runnymede": ["HTC", "Sensation XL"],
          "HTC G21": ["HTC", "Sensation XL"],
          "HTC PH06130": ["HTC", "Status"],
          "HTC Status": ["HTC", "Status"],
          "HTC Tattoo": ["HTC", "Tattoo"],
          "HTC TATTOO A3288": ["HTC", "Tattoo"],
          "HTC click": ["HTC", "Tattoo"],
          "HTC X310e": ["HTC", "Titan"],
          "HTC T7373": ["HTC", "Touch Pro II"],
          "HTC ThunderBolt": ["HTC", "ThunderBolt"],
          "HTC Mecha": ["HTC", "ThunderBolt"],
          "HTC Velocity 4G": ["HTC", "Velocity 4G"],
          "HTC Wildfire": ["HTC", "Wildfire"],
          "HTC Wildfire A3333": ["HTC", "Wildfire"],
          "HTC A3366": ["HTC", "Wildfire"],
          "HTC A3380": ["HTC", "Wildfire"],
          "HTC WildfireS": ["HTC", "Wildfire S"],
          "HTC Wildfire S": ["HTC", "Wildfire S"],
          "Htc Wildfire s": ["HTC", "Wildfire S"],
          "HTC Wildfire S A510e": ["HTC", "Wildfire S"],
          "HTC Wildfire S A510b": ["HTC", "Wildfire S"],
          "HTC WildfireS A510e": ["HTC", "Wildfire S"],
          "HTC WildfireS A510b": ["HTC", "Wildfire S"],
          "htc wildfire s a510e": ["HTC", "Wildfire S"],
          "HTC Wildfire S A515c": ["HTC", "Wildfire S"],
          "HTC A510a": ["HTC", "Wildfire S"],
          "HTC A510e": ["HTC", "Wildfire S"],
          "HTC A510c": ["HTC", "Wildfire S"],
          HTCX06HT: ["HTC", "Desire"],
          "HTC A6390": ["HTC", "A6390"],
          "HTC A8180": ["HTC", "A8180"],
          "HTC PG762": ["HTC", "PG762"],
          "HTC S715e": ["HTC", "S715e"],
          "HTC S720t": ["HTC", "S720t"],
          "HTC Z510d": ["HTC", "Z510d"],
          "HTC Z560e": ["HTC", "Z560e"],
          "HTC VLE U": ["HTC", "One S"],
          "HTC VLE#U": ["HTC", "One S"],
          "HTC VIE U": ["HTC", "One S"],
          "HTC EVA UL": ["HTC", "One V"],
          "HTC ENR U": ["HTC", "One X"],
          "ENR U": ["HTC", "One X"],
          EndeavorU: ["HTC", "One X"],
          Liberty: ["HTC", "Aria"],
          Desire: ["HTC", "Desire"],
          "Desire A8181": ["HTC", "Desire"],
          "desire hd": ["HTC", "Desire HD"],
          "Desire HD": ["HTC", "Desire HD"],
          "Dedire HD": ["HTC", "Desire HD"],
          "Desire Hd (ace)": ["HTC", "Desire HD"],
          "Desire S": ["HTC", "Desire S"],
          DesireS: ["HTC", "Desire S"],
          "Desire Saga": ["HTC", "Desire S"],
          "Desire Z": ["HTC", "Desire Z"],
          Dream: ["HTC", "Dream"],
          "Droid Incredible": ["HTC", "Droid Incredible"],
          EVO: ["HTC", "EVO"],
          "Evo HD2": ["HTC", "EVO HD"],
          "Evo 3D Beats X515m": ["HTC", "EVO 3D"],
          "Evo 3D GSM": ["HTC", "EVO 3D"],
          "EVO 3D X515m": ["HTC", "EVO 3D"],
          "EVO3D X515m": ["HTC", "EVO 3D"],
          "Evo 4G": ["HTC", "EVO 4G"],
          "EVO 4G": ["HTC", "EVO 4G"],
          photon: ["HTC", "HD mini"],
          "GinDream/GinMagic": ["HTC", "Dream"],
          HD2: ["HTC", "HD2"],
          "HD7  Pro": ["HTC", "HD7 Pro"],
          Hero: ["HTC", "Hero"],
          "HERO CDMA": ["HTC", "Hero"],
          HERO200: ["HTC", "Hero 200"],
          Incredible: ["HTC", "Droid Incredible"],
          "Incredible 2": ["HTC", "Droid Incredible 2"],
          "Incredible S": ["HTC", "Incredible S"],
          "IncredibleS S710e": ["HTC", "Incredible S"],
          IncredibleS: ["HTC", "Incredible S"],
          "Inspire HD": ["HTC", "Inspire 4G"],
          "Inspire 4G": ["HTC", "Inspire 4G"],
          Legend: ["HTC", "Legend"],
          NexusHD2: ["HTC", "HD2"],
          "Nexus HD2": ["HTC", "HD2"],
          "Docomo HT-03A": ["HTC", "Magic"],
          "MIUI.us Sensation 4G": ["HTC", "Sensation 4G"],
          "SiRF Dream": ["HTC", "Dream"],
          Pyramid: ["HTC", "Sensation"],
          Sensation: ["HTC", "Sensation"],
          "Sensation Z710e": ["HTC", "Sensation"],
          "Sensation 4G": ["HTC", "Sensation"],
          "Sensation 4g": ["HTC", "Sensation"],
          "TripNiCE Pyramid": ["HTC", "Sensation"],
          "SensationXE Beats Z715e": ["HTC", "Sensation XE"],
          "SensationXL Beats X315e": ["HTC", "Sensation XL"],
          Click: ["HTC", "Tattoo"],
          Wildfire: ["HTC", "Wildfire"],
          "Wildfire S": ["HTC", "Wildfire S"],
          "Wildfire S A510e": ["HTC", "Wildfire S"],
          "Sprint APX515CKT": ["HTC", "EVO 3D"],
          "Sprint APA9292KT": ["HTC", "EVO 4G"],
          "Sprint APA7373KT": ["HTC", "EVO Shift 4G"],
          "Sprint APC715CKT": ["HTC", "EVO Design 4G"],
          A3380: ["HTC", "Wildfire"],
          A6277: ["HTC", "Hero"],
          a7272: ["HTC", "Desire Z"],
          "A7272+(HTC DesireZ)": ["HTC", "Desire Z"],
          S31HT: ["HTC", "Aria"],
          S710d: ["HTC", "Droid Incredible 2"],
          S710D: ["HTC", "Droid Incredible 2"],
          X06HT: ["HTC", "Desire"],
          "001HT": ["HTC", "Desire HD"],
          X325a: ["HTC", "One X"],
          Z520m: ["HTC", "One S"],
          Z710: ["HTC", "Sensation"],
          Z710e: ["HTC", "Sensation"],
          T9199h: ["HTC", "T9199h"],
          "HTC S610d": ["HTC", "S610d"],
          ADR6200: ["HTC", "Droid Eris"],
          ADR6300: ["HTC", "Droid Incredible"],
          ADR6325VW: ["HTC", "Merge"],
          ADR6330VW: ["HTC", "Rhyme"],
          ADR6350: ["HTC", "Droid Incredible 2"],
          ADR6400L: ["HTC", "Thunderbolt 4G"],
          "ADR6400L 4G": ["HTC", "Thunderbolt 4G"],
          "ADR6410LVW 4G": ["HTC", "Fireball"],
          ADR6425LVW: ["HTC", "Rezound"],
          "ADR6425LVW 4G": ["HTC", "Rezound"],
          "Coquettish Red": ["HTC", "Rezound"],
          PB99400: ["HTC", "Droid Incredible"],
          pcdadr6350: ["HTC", "Droid Incredible 2"],
          PC36100: ["HTC", "EVO 4G"],
          PG06100: ["HTC", "EVO Shift 4G"],
          PG41200: ["HTC", "EVO View 4G", "tablet"],
          PG86100: ["HTC", "EVO 3D"],
          PG8610000: ["HTC", "EVO 3D"],
          PH44100: ["HTC", "EVO Design 4G"],
          PJ83100: ["HTC", "One X"],
          ISW11HT: ["HTC", "EVO 4G"],
          ISW12HT: ["HTC", "EVO 3D"],
          ISW13HT: ["HTC", "J"],
          "USCCADR6275US Carrier ID 45": ["HTC", "Desire"],
          USCCADR6285US: ["HTC", "Hero S"],
          "USCCADR6325US Carrier ID 45": ["HTC", "Merge"],
          MediaPad: ["Huawei", "MediaPad", "tablet"],
          "Huawei MediaPad": ["Huawei", "MediaPad", "tablet"],
          "HUAWEI MediaPad": ["Huawei", "MediaPad", "tablet"],
          "Huawei S7-312u": ["Huawei", "MediaPad", "tablet"],
          "MediaPad 10 FHD": ["Huawei", "MediaPad", "tablet"],
          "Huawei C8500": ["Huawei", "C8500"],
          "Huawei C8500S": ["Huawei", "C8500"],
          "Huawei C8600": ["Huawei", "C8600"],
          "Huawei C8650": ["Huawei", "C8650"],
          "Huawei C8650+": ["Huawei", "C8650"],
          "Huawei C8800": ["Huawei", "IDEOS X5"],
          "Huawei C8810": ["Huawei", "Ascend G300"],
          "Huawei C8812": ["Huawei", "Ascend C8812"],
          "Huawei C8812E": ["Huawei", "Ascend C8812"],
          "Huawei C8825D": ["Huawei", "Ascend C8825D"],
          "Huawei C8860E": ["Huawei", "Honor"],
          "Huawei M835": ["Huawei", "M835"],
          "Huawei M860": ["Huawei", "Ascend"],
          "Huawei M921": ["Huawei", "M921"],
          "Huawei S8520": ["Huawei", "S8520"],
          "Huawei S8600": ["Huawei", "S8600"],
          "Huawei T8300": ["Huawei", "T8300"],
          "Huawei T8600": ["Huawei", "T8600"],
          "Huawei T8830": ["Huawei", "T8830"],
          T8830: ["Huawei", "T8830"],
          T8620: ["Huawei", "T8620"],
          "Huawei T8828": ["Huawei", "T8828"],
          "Huawei U8220": ["Huawei", "U8220"],
          "Huawei u8500": ["Huawei", "IDEOS X2"],
          "Huawei U8815": ["Huawei", "Ascend G300"],
          "Huawei U8825D": ["Huawei", "Ascend G330D"],
          "Huawei U8850": ["Huawei", "Vision"],
          "Huawei U8652": ["Huawei", "Sonic"],
          "Huawei U8800-51": ["Huawei", "IDEOS X5"],
          "Huawei U8818": ["Huawei", "Ascend G300"],
          "Huawei U9000": ["Huawei", "Ascend X"],
          "Huawei IDEOS U8500": ["Huawei", "IDEOS X2"],
          "Huawei IDEOS U8650": ["Huawei", "Sonic"],
          "Huawei IDEOS X3": ["Huawei", "IDEOS X3"],
          "Huawei Ideos X5": ["Huawei", "IDEOS X5"],
          "Huawei Ideos X5 1.12.9(ret4rt)": ["Huawei", "IDEOS X5"],
          "Huawei SONIC": ["Huawei", "Sonic"],
          "Huawei 8100-9": ["Huawei", "U8100"],
          FUSIONideos: ["Huawei", "IDEOS"],
          "Gnappo Ideos": ["Huawei", "IDEOS"],
          Ideos: ["Huawei", "IDEOS"],
          "IDEOS X5": ["Huawei", "IDEOS X5"],
          "Ideos S7": ["Huawei", "IDEOS S7", "tablet"],
          "IDEOS S7": ["Huawei", "IDEOS S7", "tablet"],
          "IDEOS S7 Slim": ["Huawei", "IDEOS S7", "tablet"],
          "Huawei S7": ["Huawei", "IDEOS S7", "tablet"],
          SONIC: ["Huawei", "Sonic"],
          "Kyivstar Aqua": ["Huawei", "Sonic"],
          "Lucky Ultra Sonic U8650": ["Huawei", "Sonic"],
          "Turkcell T20": ["Huawei", "Sonic"],
          "MTC 950": ["Huawei", "U8160"],
          "MTC 955": ["Huawei", "Sonic"],
          "MTC Evo": ["Huawei", "C8500"],
          "MTC Android": ["Huawei", "U8110"],
          S31HW: ["Huawei", "Pocket WiFi S"],
          S41HW: ["Huawei", "Pocket WiFi S II"],
          "007HW": ["Huawei", "Vision"],
          UM840: ["Huawei", "Evolution"],
          M860: ["Huawei", "Ascend"],
          M865: ["Huawei", "Ascend II"],
          M886: ["Huawei", "Glory"],
          C8150: ["Huawei", "IDEOS"],
          c8500: ["Huawei", "C8500"],
          C8500: ["Huawei", "C8500"],
          C8500S: ["Huawei", "C8500"],
          C8600: ["Huawei", "C8600"],
          c8650: ["Huawei", "C8650"],
          C8650: ["Huawei", "C8650"],
          c8800: ["Huawei", "C8800"],
          C8800: ["Huawei", "C8800"],
          c8810: ["Huawei", "Ascend G300C"],
          C8812: ["Huawei", "Ascend C8812"],
          S8600: ["Huawei", "S8600"],
          U8100: ["Huawei", "U8100"],
          U8110: ["Huawei", "U8110"],
          u8120: ["Huawei", "U8120"],
          U8120: ["Huawei", "U8120"],
          U8180: ["Huawei", "IDEOS X1"],
          U8220: ["Huawei", "Pulse"],
          U8300: ["Huawei", "U8300"],
          U8350: ["Huawei", "Boulder"],
          U8150: ["Huawei", "IDEOS"],
          U8160: ["Huawei", "U8160"],
          U8500: ["Huawei", "IDEOS X2"],
          "U8500 HiQQ": ["Huawei", "U8500 HiQQ Edition"],
          U8510: ["Huawei", "IDEOS X3"],
          u8650: ["Huawei", "Sonic"],
          U8650: ["Huawei", "Sonic"],
          "U8650-1": ["Huawei", "Sonic"],
          U8660: ["Huawei", "Sonic"],
          u8800: ["Huawei", "IDEOS X5"],
          U8800: ["Huawei", "IDEOS X5"],
          "U8800+": ["Huawei", "IDEOS X5"],
          U8800X: ["Huawei", "IDEOS X5"],
          U8800pro: ["Huawei", "IDEOS X5 Pro"],
          U8800PRO: ["Huawei", "IDEOS X5 Pro"],
          U8800Pro: ["Huawei", "IDEOS X5 Pro"],
          u8800pro: ["Huawei", "IDEOS X5 Pro"],
          "U8800 Pro": ["Huawei", "IDEOS X5 Pro"],
          U8818: ["Huawei", "Ascend G300"],
          U8850: ["Huawei", "Vision"],
          u8860: ["Huawei", "Honor"],
          U8860: ["Huawei", "Honor"],
          U9000: ["Huawei", "Ascend X"],
          U9200: ["Huawei", "Ascend P1"],
          "U9200-1": ["Huawei", "Ascend P1"],
          U9500: ["Huawei", "Ascend D1"],
          U9501L: ["Huawei", "Ascend D LTE"],
          U9510: ["Huawei", "Ascend D quad"],
          U9510E: ["Huawei", "Ascend D quad"],
          Comet: ["Huawei", "Comet"],
          GS02: ["Huawei", "Honor"],
          GS03: ["Huawei", "Ascend P1"],
          "DroniX-0.5": ["Huawei", "U8180"],
          "MTS-SP101": ["Huawei", "C8511"],
          TSP21: ["Huawei", "U8110"],
          "HYUNDAI H6": ["Hyundai", "Storm H6"],
          "iBall Slide i7011": ["iBall", "Slide i7011"],
          "NetTAB RUNE": ["IconBit", "NetTab Rune", "tablet"],
          D70W: ["Icoo", "D70W", "tablet"],
          D80: ["Icoo", "D80", "tablet"],
          "INFOBAR A01": ["iida", "INFOBAR A01"],
          M009F: ["Infotmic", "M009F"],
          AZ210A: ["Intel", "AZ210A"],
          AZ210B: ["Intel", "AZ210B"],
          AZ510: ["Intel", "AZ510"],
          greenridge: ["Intel", "Green Ridge", "tablet"],
          "INQ Cloud Touch": ["INQ", "Cloud Touch"],
          "ILT-MX100": ["iRiver", "Tab", "tablet"],
          IVIO_DE38: ["Ivio", "DE38"],
          "JY-G2": ["Jiayu", "G2"],
          "JXD S601WIFI": ["JXD", "S601 WIFI", "media"],
          A2: ["KakaTech", "A2"],
          D91: ["KK", "D91", "tablet"],
          K080: ["Kobo", "K080", "ereader"],
          A106: ["koobee", "A160"],
          "KPT A9": ["KPT", "A9"],
          "EV-S100": ["Kttech", "Take EV-S100"],
          "KM-S120": ["Kttech", "Take 2 KM-S120"],
          "KM-S200": ["TAKE", "Janus KM-S200"],
          "KM-S220": ["Kttech", "Take Tachy KM-S220"],
          "Kyobo mirasol eReader": ["Kyobo", "eReader", "ereader"],
          ISW11K: ["Kyocera", "Digno"],
          "JC-KSP8000": ["Kyocera", "Echo"],
          KSP8000: ["Kyocera", "Echo"],
          Zio: ["Kyocera", "Zio"],
          C5155: ["Kyocera", "C5155"],
          C5170: ["Kyocera", "C5170"],
          M9300: ["Kyocera", "M9300"],
          E800: ["K-Touch", "E800"],
          W606: ["K-Touch", "W606"],
          "K-Touch T619": ["K-Touch", "T619"],
          "K-Touch W619": ["K-Touch", "W619"],
          "K-Touch W650": ["K-Touch", "W650"],
          W700: ["K-Touch", "W700"],
          W800: ["K-Touch", "W800"],
          W806: ["K-Touch", "W806"],
          W808: ["K-Touch", "W808"],
          W810: ["K-Touch", "W810"],
          X900: ["Lava", "XOLO X900"],
          "Lenovo A798t": ["Lenovo", "A798t"],
          "LENOVO-Lenovo-A288t": ["Lenovo", "LePhone A288"],
          "ThinkPad Tablet": ["Lenovo", "ThinkPad Tablet", "tablet"],
          K1: ["Lenovo", "IdeaPad K1", "tablet"],
          "Ideapad S10-3T": ["Lenovo", "IdeaPad S10-3T", "tablet"],
          "S2005A-H": ["Lenovo", "S2005A"],
          "IdeaTab S2007A-D": ["Lenovo", "IdeaTab S2007A", "tablet"],
          IdeaTabV2007A: ["Lenovo", "IdeaTab V2007A", "tablet"],
          "IdeaTabV2007A-D-I": ["Lenovo", "IdeaTab V2007A", "tablet"],
          IdeaTabV2010A: ["Lenovo", "IdeaTab V2010A", "tablet"],
          "IdeaTab A2107A-H": ["Lenovo", "IdeaTab V2107A", "tablet"],
          "A1 07": ["Lenovo", "LePad", "tablet"],
          "lepad 001b": ["Lenovo", "LePad", "tablet"],
          "lepad 001n": ["Lenovo", "LePad", "tablet"],
          "3GC101": ["Lenovo", "LePhone 3GC101"],
          "Lenovo 3GC101": ["Lenovo", "LePhone 3GC101"],
          "3GW100": ["Lenovo", "LePhone 3GW100"],
          "Lenovo 3GW100": ["Lenovo", "LePhone 3GW100"],
          "3GW101": ["Lenovo", "LePhone 3GW101"],
          "Lenovo 3GW101": ["Lenovo", "LePhone 3GW101"],
          "Lephone 3GW101": ["Lenovo", "LePhone 3GW101"],
          "Lenovo A1-32AB0": ["Lenovo", "LePhone A1-32AB0"],
          "Lenovo S1-37AH0": ["Lenovo", "LePhone S1-37AH0"],
          "S1 37AHO": ["Lenovo", "LePhone S1-37AH0"],
          "Lenovo S2-38AH0": ["Lenovo", "LePhone S2-38AH0"],
          "Lenovo S2-38AT0": ["Lenovo", "LePhone S2-38AT0"],
          "Lenovo A288t": ["Lenovo", "LePhone A288"],
          "Lenovo A366t": ["Lenovo", "LePhone A366"],
          "Lenovo A390e": ["Lenovo", "LePhone A390"],
          "Lenovo A500": ["Lenovo", "LePhone A500"],
          "Lenovo A520": ["Lenovo", "LePhone A520"],
          "Lenovo A560e": ["Lenovo", "A560"],
          "Lenovo A668t": ["Lenovo", "LePhone A668"],
          "Lenovo A698t": ["Lenovo", "LePhone A698"],
          "Lenovo A750": ["Lenovo", "LePhone A750"],
          "Lenovo A780": ["Lenovo", "LePhone A780"],
          "Lenovo A789": ["Lenovo", "LePhone A789"],
          "Lenovo A790e": ["Lenovo", "LePhone A790"],
          "Lenovo P70": ["Lenovo", "LePhone P70"],
          "Lenovo P700": ["Lenovo", "LePhone P700"],
          "Lenovo S850e": ["Lenovo", "S850"],
          "Lenovo S880": ["Lenovo", "S880"],
          "Lenovo K860": ["Lenovo", "K860"],
          A30t: ["Lenovo", "A30t"],
          "Lenovo A60": ["Lenovo", "A60"],
          "Lenovo A65": ["Lenovo", "A65"],
          "Lenovo A66t": ["Lenovo", "A66t"],
          "Lenovo A68e": ["Lenovo", "A68e"],
          "Lenovo K800": ["Lenovo", "K800"],
          "IDEA TV T100": ["Lenovo", "IDEA TV", "television"],
          "IDEA TV K91": ["Lenovo", "IDEA TV", "television"],
          TC970: ["Le Pan", "TC970", "tablet"],
          LePanII: ["Le Pan", "II", "tablet"],
          "LG-C555": ["LG", "Optimus Chat"],
          "LG-C555-parrot": ["LG", "Optimus Chat"],
          "LG-C660h": ["LG", "Optimus Pro"],
          "LG-C729": ["LG", "DoublePlay"],
          "LG-C800G": ["LG", "Eclypse"],
          "LG-CX670": ["LG", "Optimus 3G"],
          "LG-E400": ["LG", "Optimus L3"],
          "LG-E400f": ["LG", "Optimus L3"],
          "LG-E510": ["LG", "Optimus Hub"],
          "LG-E510f": ["LG", "Optimus Hub"],
          "LG-E510g": ["LG", "Optimus Hub"],
          "LG-E610": ["LG", "Optimus L5"],
          "LG-E612": ["LG", "Optimus L5"],
          "LG-E612g": ["LG", "Optimus L5"],
          "LG-E615F": ["LG", "E615"],
          "LG-E617G": ["LG", "E617"],
          "LG-E720": ["LG", "Optimus Chic"],
          "LG-E720b": ["LG", "Optimus Chic"],
          "LG-E730": ["LG", "Optimus Sol"],
          "LG-E970": ["LG", "Shine"],
          "LG-F100L": ["LG", "Optimus Vu"],
          "LG-F100S": ["LG", "Optimus Vu"],
          "LG-F120K": ["LG", "Optimus LTE Tag"],
          "LG-F120L": ["LG", "Optimus LTE Tag"],
          "LG-F120S": ["LG", "Optimus LTE Tag"],
          "LG-F160K": ["LG", "Optimus LTE II"],
          "LG-F160L": ["LG", "Optimus LTE II"],
          "LG-F160S": ["LG", "Optimus LTE II"],
          "LG-F180L": ["LG", "F180L"],
          "LG-GT540": ["LG", "Optimus"],
          "LG-GT540f": ["LG", "Optimus"],
          "LG-GT540 Swift": ["LG", "Optimus"],
          "LG-GW620": ["LG", "GW620"],
          "LG-KH5200": ["LG", "Andro-1"],
          "LG-KU3700": ["LG", "Optimus One"],
          "LG-KU5400": ["LG", "PRADA 3.0"],
          "LG-KU5900": ["LG", "Optimus Black"],
          "LG-L40G": ["LG", "L40G"],
          "LG-LG855": ["LG", "Marquee"],
          "LG-LS670": ["LG", "Optimus S"],
          "LG-LS696": ["LG", "Optimus Elite"],
          "LG-LS840": ["LG", "Viper 4G"],
          "LG-LS855": ["LG", "Marquee"],
          "LG-LS860": ["LG", "'Cayenne'"],
          "LG-LS970": ["LG", "'Eclipse'"],
          "LG-LU3000": ["LG", "Optimus Mach"],
          "LG-LU3100": ["LG", "Optimus Chic"],
          "LG-LU3700": ["LG", "Optimus One"],
          "LG-LU5400": ["LG", "PRADA 3.0"],
          "LG-LU6200": ["LG", "Optimus Q2"],
          "LG-lu6200": ["LG", "Optimus Q2"],
          "LG-LU6500": ["LG", "Optimus Note"],
          "LG-LU6800": ["LG", "Optimus Big"],
          "LG-LU8300": ["LG", "Optimus Pad LTE"],
          "LG-LW690": ["LG", "Optimus C"],
          "LG-LW770": ["LG", "LW770"],
          "LG-MS690": ["LG", "Optimus M"],
          "LG-MS770": ["LG", "MS770"],
          "LG-MS840": ["LG", "Connect 4G"],
          "LG-MS910": ["LG", "Esteem"],
          "LG-MS695": ["LG", "Optimus M+"],
          "LG P350": ["LG", "Optimus Me"],
          "LG-P350": ["LG", "Optimus Me"],
          "LG-P350f": ["LG", "Optimus Me"],
          "LG-P350g": ["LG", "Optimus Me"],
          "LG-P355": ["LG", "P355"],
          "LG-P500": ["LG", "Optimus One"],
          "LG-P500h": ["LG", "Optimus One"],
          "LG-P500h-parrot": ["LG", "Optimus One"],
          "LG-P503": ["LG", "Optimus One"],
          "LG-P504": ["LG", "Optimus One"],
          "LG-P505": ["LG", "Phoenix"],
          "LG-P505R": ["LG", "Phoenix"],
          "LG-P506": ["LG", "Thrive"],
          "LG-P509": ["LG", "Optimus T"],
          "LG-P690": ["LG", "Optimus Net"],
          "LG-P693": ["LG", "P693"],
          "LG-P698": ["LG", "Optimus Net"],
          "LG-P698f": ["LG", "Optimus Net"],
          "LG-P700": ["LG", "Optimus L7"],
          "LG-P705": ["LG", "Optimus L7"],
          "LG-P705f": ["LG", "Optimus L7"],
          "LG-P705g": ["LG", "Optimus L7"],
          "LG-P708g": ["LG", "P708"],
          "LG-P720": ["LG", "Optimus Chic"],
          "LG-P720h": ["LG", "Optimus Chic"],
          "LG-P725": ["LG", "Optimus 3D Max"],
          "LG-P760": ["LG", "P760"],
          "LG-P769": ["LG", "P769"],
          "LG-P860": ["LG", "P860"],
          "LG-P870": ["LG", "P870"],
          "LG-P870F": ["LG", "P870"],
          "LG-P880": ["LG", "X3"],
          "LG-P880g": ["LG", "X3"],
          "LG-P895": ["LG", "P895"],
          "LG-P920": ["LG", "Optimus 3D"],
          "LG-P920h": ["LG", "Optimus 3D"],
          "LG-P925": ["LG", "Thrill"],
          "LG-P925g": ["LG", "Thrill"],
          "LG-P930": ["LG", "Nitro HD"],
          "LG-P936": ["LG", "Optimus LTE"],
          "LG-P940": ["LG", "PRADA 3.0"],
          "LG-P970": ["LG", "Optimus Black"],
          "LG-P970h": ["LG", "Optimus Black"],
          "LG-P990": ["LG", "Optimus 2X Speed"],
          "LG-P990h": ["LG", "Optimus 2X Speed"],
          "LG-P990hN": ["LG", "Optimus 2X Speed"],
          "LG-P990H": ["LG", "Optimus 2X Speed"],
          "LG-P993": ["LG", "Optimus 2X"],
          "LG-SU540": ["LG", "PRADA 3.0"],
          "LG-SU640": ["LG", "Optimus LTE"],
          "LG-SU660": ["LG", "Optimus 2X"],
          "LG-SU760": ["LG", "Optimus 3D"],
          "LG-SU760-Kust": ["LG", "Optimus 3D"],
          "LG-SU870": ["LG", "Optimus 3D Cube"],
          "LG-SU880": ["LG", "Optimus EX"],
          "LG-US670": ["LG", "Optimus U"],
          "LG-US730": ["LG", "US730"],
          "LG-V900": ["LG", "Optimus Pad", "tablet"],
          "LG-V905R": ["LG", "Optimus G-Slate", "tablet"],
          "LG-V909": ["LG", "Optimus G-Slate", "tablet"],
          "LG-VM670": ["LG", "Optimus V"],
          "LG-VM696": ["LG", "Optimus Elite"],
          "LG-VM701": ["LG", "Optimus Slider"],
          "LG-VS660": ["LG", "Vortex"],
          "LG-VS700": ["LG", "Enlighten"],
          "LG-VS740": ["LG", "Ally"],
          "LG-VS840": ["LG", "Connect 4G"],
          "LG-VS910": ["LG", "Revolution"],
          "lgp-970": ["LG", "Optimus Black"],
          E900: ["LG", "Optimus 7"],
          GT540: ["LG", "Optimus GT540"],
          GW620: ["LG", "GW620"],
          KU9500: ["LG", "Optimus Z"],
          LGC660: ["LG", "Optimus Pro"],
          LGL45C: ["LG", "Optimus Net"],
          LGL55C: ["LG", "Optimus Q"],
          LU2300: ["LG", "Optimus Q"],
          LS670: ["LG", "Optimus S"],
          P940: ["LG", "PRADA 3.0"],
          P990: ["LG", "Optimus 2X Speed"],
          "USCC-US730": ["LG", "US730"],
          "USCC-US760": ["LG", "Genesis"],
          VM670: ["LG", "Optimus V"],
          "VS840 4G": ["LG", "Connect 4G"],
          "VS900-4G": ["LG", "VS900"],
          "VS910 4G": ["LG", "Revolution 4G"],
          "VS920 4G": ["LG", "Spectrum 4G"],
          "VS930 4G": ["LG", "VS930"],
          "VS950 4G": ["LG", "VS950"],
          "L-01D": ["LG", "Optimus LTE"],
          "L-02D": ["LG", "PRADA phone"],
          "L-04C": ["LG", "Optimus Chat"],
          "L-05D": ["LG", "Optimus it"],
          "L-06C": ["LG", "Optimus Pad", "tablet"],
          "L-06D": ["LG", "Optimus Vu"],
          "L-07C": ["LG", "Optimus Bright"],
          "LG-Eve": ["LG", "Eve"],
          "LG-Optimus One P500": ["LG", "Optimus One"],
          "LG-Optimus 2X": ["LG", "Optimus 2X"],
          "LG-GT540 Optimus": ["LG", "Optimus"],
          "LG-Optimus Black": ["LG", "Optimus Black"],
          Ally: ["LG", "Ally"],
          Optimus: ["LG", "Optimus"],
          "Optimus Me": ["LG", "Optimus Me"],
          "optimus me p350": ["LG", "Optimus Me"],
          "Optimus 2X": ["LG", "Optimus 2X"],
          "Optimus 2x": ["LG", "Optimus 2X"],
          IS11LG: ["LG", "Optimus X"],
          Vortex: ["LG", "Vortex"],
          "LDK-ICK v1.4": ["LG", "Esteem"],
          T6: ["Malata", "Zpad T6", "tablet"],
          "Malata SMBA1002": ["Malata", "Tablet SMB-A1002", "tablet"],
          STM712HCZ: ["Mediacom", "SmartPad 712c", "tablet"],
          STM803HC: ["Mediacom", "SmartPad 810c", "tablet"],
          "Mediacom 810C": ["Mediacom", "SmartPad 810c", "tablet"],
          Smartpad810c: ["Mediacom", "SmartPad 810c", "tablet"],
          SmartPad810c: ["Mediacom", "SmartPad 810c", "tablet"],
          MP810C: ["Mediacom", "SmartPad 810c", "tablet"],
          MP907C: ["Mediacom", "SmartPad 907c", "tablet"],
          MTK6516: ["Mediatek", "MTK6516"],
          "LIFETAB S9512": ["Medion", "Lifetab S9512", "tablet"],
          "LIFETAB P9514": ["Medion", "Lifetab P9514", "tablet"],
          "MD LIFETAB P9516": ["Medion", "Lifetab P9516", "tablet"],
          "MEDION LIFE P4310": ["Medion", "Life P4310"],
          M8: ["Meizu", "M8"],
          M9: ["Meizu", "M9"],
          M040: ["Meizu", "M040"],
          "M9-unlocked": ["Meizu", "M9"],
          "meizu m9": ["Meizu", "M9"],
          "MEIZU M9": ["Meizu", "M9"],
          "MEIZU MX": ["Meizu", "MX"],
          M030: ["Meizu", "MX M030"],
          M031: ["Meizu", "MX M031"],
          M032: ["Meizu", "MX M032"],
          Slidepad: ["Memup", "Slidepad", "tablet"],
          A45: ["Micromax", "A45 Punk"],
          "Micromax A50": ["Micromax", "A50 Ninja"],
          "Micromax A60": ["Micromax", "Andro A60"],
          "Micromax A70": ["Micromax", "Andro A70"],
          "P300(Funbook)": ["Micromax", "Funbook P300", "tablet"],
          AT735: ["Moinstone", "AT735", "tablet"],
          A853: ["Motorola", "Milestone"],
          A953: ["Motorola", "Milestone 2"],
          A1680: ["Motorola", "MOTO A1680"],
          ET1: ["Motorola", "ET1 Enterprise Tablet", "tablet"],
          MB200: ["Motorola", "CLIQ"],
          MB300: ["Motorola", "BACKFLIP"],
          MB501: ["Motorola", "CLIQ XT"],
          MB502: ["Motorola", "CHARM"],
          MB511: ["Motorola", "FLIPOUT"],
          MB520: ["Motorola", "BRAVO"],
          MB525: ["Motorola", "DEFY"],
          "MB525+": ["Motorola", "DEFY"],
          "MB525 for me": ["Motorola", "DEFY"],
          MB526: ["Motorola", "DEFY+"],
          MB611: ["Motorola", "CLIQ 2"],
          MB612: ["Motorola", "XPRT"],
          MB632: ["Motorola", "PRO+"],
          MB855: ["Motorola", "PHOTON 4G"],
          MB860: ["Motorola", "ATRIX"],
          MB861: ["Motorola", "ATRIX"],
          mb861: ["Motorola", "ATRIX"],
          MB865: ["Motorola", "ATRIX 2"],
          MB870: ["Motorola", "Droid X2"],
          MB886: ["Motorola", "DINARA"],
          ME501: ["Motorola", "CLIQ XT"],
          ME511: ["Motorola", "FLIPOUT"],
          me525: ["Motorola", "MOTO ME525"],
          Me525: ["Motorola", "MOTO ME525"],
          ME525: ["Motorola", "MOTO ME525"],
          "ME525+": ["Motorola", "MOTO ME525"],
          ME600: ["Motorola", "BACKFLIP"],
          ME632: ["Motorola", "PRO+"],
          ME722: ["Motorola", "Milestone 2"],
          ME811: ["Motorola", "Droid X"],
          ME860: ["Motorola", "ATRIX"],
          ME863: ["Motorola", "Milestone 3"],
          ME865: ["Motorola", "ATRIX 2"],
          MT620: ["Motorola", "MOTO MT620"],
          MT620t: ["Motorola", "MOTO MT620"],
          MT716: ["Motorola", "MOTO MT716"],
          MT810: ["Motorola", "MOTO MT810"],
          MT870: ["Motorola", "MOTO MT870"],
          MT917: ["Motorola", "MT917"],
          MZ505: ["Motorola", "XOOM Family Edition", "tablet"],
          MZ600: ["Motorola", "XOOM 4G LTE", "tablet"],
          MZ601: ["Motorola", "XOOM 3G", "tablet"],
          MZ602: ["Motorola", "XOOM 4G LTE", "tablet"],
          MZ603: ["Motorola", "XOOM 3G", "tablet"],
          MZ604: ["Motorola", "XOOM WiFi", "tablet"],
          MZ605: ["Motorola", "XOOM 3G", "tablet"],
          MZ606: ["Motorola", "XOOM WiFi", "tablet"],
          MZ607: ["Motorola", "XOOM 2 WiFi Media Edition", "tablet"],
          MZ609: ["Motorola", "Droid XYBOARD 8.2", "tablet"],
          "MZ609 4G": ["Motorola", "Droid XYBOARD 8.2", "tablet"],
          MZ615: ["Motorola", "XOOM 2 WiFi", "tablet"],
          MZ617: ["Motorola", "Droid XYBOARD 10.1", "tablet"],
          "MZ617 4G": ["Motorola", "Droid XYBOARD 10.1", "tablet"],
          WX435: ["Motorola", "TRIUMPH WX435"],
          WX445: ["Motorola", "CITRUS WX445"],
          XT300: ["Motorola", "SPICE"],
          XT301: ["Motorola", "MOTO XT301"],
          XT311: ["Motorola", "FIRE"],
          XT316: ["Motorola", "MOTO XT316"],
          XT319: ["Motorola", "MOTO XT319"],
          XT390: ["Motorola", "MOTO XT390"],
          XT320: ["Motorola", "DEFY Mini"],
          XT321: ["Motorola", "DEFY Mini"],
          XT500: ["Motorola", "MOTO XT500"],
          "xt-500": ["Motorola", "MOTO XT500"],
          XT502: ["Motorola", "QUENCH XT5"],
          XT530: ["Motorola", "FIRE XT"],
          XT531: ["Motorola", "FIRE XT"],
          XT532: ["Motorola", "XT532"],
          XT535: ["Motorola", "DEFY"],
          XT550: ["Motorola", "XT550"],
          XT556: ["Motorola", "XT556"],
          XT603: ["Motorola", "ADMIRAL"],
          XT610: ["Motorola", "Droid Pro"],
          XT615: ["Motorola", "MOTO XT615"],
          XT626: ["Motorola", "MOTO XT626"],
          XT681: ["Motorola", "MOTO XT681"],
          XT682: ["Motorola", "Droid 3"],
          XT685: ["Motorola", "MOTO XT685"],
          XT687: ["Motorola", "ATRIX TV"],
          XT701: ["Motorola", "XT701"],
          XT702: ["Motorola", "MOTO XT702"],
          XT711: ["Motorola", "MOTO XT711"],
          XT720: ["Motorola", "Milestone"],
          XT875: ["Motorola", "Droid Bionic"],
          XT800: ["Motorola", "MOTO XT800"],
          "XT800+": ["Motorola", "MOTO XT800"],
          XT800W: ["Motorola", "MOTO Glam"],
          XT806: ["Motorola", "MOTO XT806"],
          XT860: ["Motorola", "Milestone 3"],
          XT862: ["Motorola", "Droid 3"],
          XT882: ["Motorola", "MOTO XT882"],
          XT883: ["Motorola", "Milestone 3"],
          XT889: ["Motorola", "XT889"],
          XT897: ["Motorola", "Droid 4"],
          XT901: ["Motorola", "RAZR"],
          XT910: ["Motorola", "RAZR"],
          XT910K: ["Motorola", "RAZR"],
          XT910S: ["Motorola", "RAZR"],
          "XT910 4G": ["Motorola", "RAZR"],
          XT912: ["Motorola", "Droid RAZR"],
          XT923: ["Motorola", "Droid RAZR HD"],
          XT925: ["Motorola", "Droid RAZR HD"],
          XT926: ["Motorola", "Droid RAZR"],
          "XT926 4G": ["Motorola", "Droid RAZR"],
          XT928: ["Motorola", "XT928"],
          "Atrix 2": ["Motorola", "ATRIX 2"],
          "Atrix 4g": ["Motorola", "ATRIX 4G"],
          "Atrix 4G": ["Motorola", "ATRIX 4G"],
          "Atrix 4G ME860": ["Motorola", "ATRIX 4G"],
          CLIQ: ["Motorola", "CLIQ"],
          "CLIQ XT": ["Motorola", "CLIQ XT"],
          CLIQ2: ["Motorola", "CLIQ 2"],
          Corvair: ["Motorola", "Corvair", "tablet"],
          DEFY: ["Motorola", "DEFY"],
          "Defy+": ["Motorola", "DEFY+"],
          "Defy Plus": ["Motorola", "DEFY+"],
          Devour: ["Motorola", "Devour"],
          Dext: ["Motorola", "Dext"],
          Droid: ["Motorola", "Droid"],
          DROID: ["Motorola", "Droid"],
          DROID2: ["Motorola", "Droid 2"],
          "DROID2 GLOBAL": ["Motorola", "Droid 2"],
          "DROID2 Global": ["Motorola", "Droid 2"],
          Droid2Global: ["Motorola", "Droid 2"],
          "DROID 2": ["Motorola", "Droid 2"],
          DROID3: ["Motorola", "Droid 3"],
          DROID4: ["Motorola", "Droid 4"],
          "DROID4 4G": ["Motorola", "Droid 4"],
          "DROID Pro": ["Motorola", "Droid Pro"],
          "DROID BIONIC": ["Motorola", "Droid Bionic"],
          "DROID BIONIC 4G": ["Motorola", "Droid Bionic"],
          "DROID BIONIC XT875 4G": ["Motorola", "Droid Bionic"],
          DROIDRAZR: ["Motorola", "Droid RAZR"],
          "Droid Razr": ["Motorola", "Droid RAZR"],
          "DROID RAZR": ["Motorola", "Droid RAZR"],
          "DROID RAZR 4G": ["Motorola", "Droid RAZR"],
          "DROID SPYDER": ["Motorola", "Droid RAZR"],
          "DROID RAZR HD": ["Motorola", "Droid RAZR HD"],
          "DROID RAZR HD 4G": ["Motorola", "Droid RAZR HD"],
          DroidX: ["Motorola", "Droid X"],
          DROIDX: ["Motorola", "Droid X"],
          "droid x": ["Motorola", "Droid X"],
          "Droid X": ["Motorola", "Droid X"],
          "DROID X": ["Motorola", "Droid X"],
          "DROID X2": ["Motorola", "Droid X2"],
          Electrify: ["Motorola", "Electrify"],
          "Milestone XT720": ["Motorola", "Milestone"],
          "Milestone Xt720": ["Motorola", "Milestone"],
          Milestone: ["Motorola", "Milestone"],
          "A853 Milestone": ["Motorola", "Milestone"],
          "Milestone X": ["Motorola", "Milestone X"],
          "Milestone X2": ["Motorola", "Milestone X2"],
          MotoroiX: ["Motorola", "Droid X"],
          "Moto Backflip": ["Motorola", "BACKFLIP"],
          RAZR: ["Motorola", "RAZR"],
          Triumph: ["Motorola", "TRIUMPH"],
          "Opus One": ["Motorola", "i1"],
          Photon: ["Motorola", "PHOTON"],
          "Photon 4G": ["Motorola", "PHOTON 4G"],
          XOOM: ["Motorola", "XOOM", "tablet"],
          Xoom: ["Motorola", "XOOM", "tablet"],
          "XOOM 2": ["Motorola", "XOOM 2", "tablet"],
          "XOOM 2 ME": ["Motorola", "XOOM 2", "tablet"],
          "XOOM MZ606": ["Motorola", "XOOM WiFi", "tablet"],
          ISW11M: ["Motorola", "PHOTON"],
          IS12M: ["Motorola", "RAZR"],
          MOTWX435KT: ["Motorola", "TRIUMPH"],
          "X3-Ice MIUI XT720 Memorila Classics": ["Motorola", "Milestone"],
          "NABI-A": ["Nabi", "Kids tablet", "tablet"],
          Newpad: ["Newsmy", "Newpad", "tablet"],
          "Newpad-K97": ["Newsmy", "Newpad K97", "tablet"],
          "Newpad P9": ["Newsmy", "Newpad P9", "tablet"],
          "M-PAD N8": ["Newsmy", "M-pad N8", "tablet"],
          "LT-NA7": ["NEC", "LT-NA7"],
          "N-01D": ["NEC", "MEDIAS PP N-01D"],
          "N-04C": ["NEC", "MEDIAS N-04C"],
          "N-04D": ["NEC", "MEDIAS LTE N-04D"],
          "N-05D": ["NEC", "MEDIAS ES N-05D"],
          "N-06C": ["NEC", "MEDIAS WP N-06C"],
          "N-06D": ["NEC", "MEDIAS Tab N-06D", "tablet"],
          "N-07D": ["NEC", "MEDIAS X N-07D"],
          "101N": ["NEC", "MEDIAS CH Softbank 101N"],
          IS11N: ["NEC", "MEDIAS BR IS11N"],
          "Nexian NX-A890": ["Nexian", "Journey"],
          "NX-A891": ["Nexian", "Ultra Journey"],
          M726HC: ["Nextbook", "Premium 7", "ereader"],
          NXM726HN: ["Nextbook", "Premium 7", "ereader"],
          NXM803HD: ["Nextbook", "Premium 8", "ereader"],
          DATAM803HC: ["Nextbook", "Premium 8", "ereader"],
          NXM901: ["Nextbook", "Next 3", "ereader"],
          "NGM Vanity Smart": ["NGM", "Vanity Smart"],
          "Nokia N9": ["Nokia", "N9"],
          "Nokia N900": ["Nokia", "N900"],
          Lumia800: ["Nokia", "Lumia 800"],
          "Lumia 900": ["Nokia", "Lumia 900"],
          "Notion Ink ADAM": ["Notion Ink", "ADAM", "tablet"],
          "P4D SIRIUS": ["Nvsbl", "P4D SIRIUS", "tablet"],
          "P4D Sirius": ["Nvsbl", "P4D SIRIUS", "tablet"],
          EFM710A: ["Oblio", "Mint 7x", "tablet"],
          "ODYS-Xpress": ["Odys", "Xpress", "tablet"],
          "Olivetti Olipad 100": ["Olivetti", "Olipad 100", "tablet"],
          OP110: ["Olivetti", "Olipad 110", "tablet"],
          "ONDA MID": ["Onda", "MID", "tablet"],
          VX580A: ["Onda", "VX580A", "tablet"],
          VX610A: ["Onda", "VX610A", "tablet"],
          TQ150: ["Onda", "TQ150"],
          N2T: ["ONN", "N2T", "tablet"],
          Renesas: ["Opad", "Renesas", "tablet"],
          "renesas emev": ["Opad", "Renesas", "tablet"],
          X903: ["Oppo", "Find Me X903"],
          X905: ["Oppo", "Find 3 X905"],
          R805: ["Oppo", "R805"],
          R801: ["Oppo", "R801"],
          R811: ["Oppo", "R811"],
          X909: ["Oppo", "X909"],
          OPPOR801: ["Oppo", "R801"],
          OPPOX905: ["Oppo", "Find 3 X905"],
          OPPOX907: ["Oppo", "Find 3 X907"],
          X907: ["Oppo", "Find 3 X907"],
          X9015: ["Oppo", "Find X9015"],
          OPPOX9017: ["Oppo", "Finder X9017"],
          OPPOU701: ["Oppo", "OPPOU701"],
          OPPOR807: ["Oppo", "Real R807"],
          OPPOR805: ["Oppo", "Real R805"],
          R807: ["Oppo", "Real R807"],
          OPPOT703: ["Oppo", "T703"],
          "P-01D": ["Panasonic", "P-01D"],
          "P-02D": ["Panasonic", "Lumix Phone"],
          "P-04D": ["Panasonic", "Eluga"],
          "P-07C": ["Panasonic", "P-07C"],
          dL1: ["Panasonic", "Eluga dL1"],
          "101P": ["Panasonic", "Lumix Phone"],
          "JT-H580VT": ["Panasonic", "BizPad 7", "tablet"],
          "JT-H581VT": ["Panasonic", "BizPad 10", "tablet"],
          "FZ-A1A": ["Panasonic", "Toughpad", "tablet"],
          pandigital9hr: ["Pandigital", "9HR", "tablet"],
          pandigital9hr2: ["Pandigital", "9HR2", "tablet"],
          pandigitalopc1: ["Pandigital", "OPC1", "tablet"],
          pandigitalopp1: ["Pandigital", "OPP1", "tablet"],
          pandigitalp1hr: ["Pandigital", "p1hr", "tablet"],
          "IM-A600S": ["Pantech", "SIRIUS Ã�Â±"],
          "IM-A630K": ["Pantech", "SKY Izar"],
          "IM-A690L": ["Pantech", "SKY"],
          "IM-A690S": ["Pantech", "SKY"],
          "IM-A710K": ["Pantech", "SKY Vega Xpress"],
          "IM-A720L": ["Pantech", "SKY Vega Xpress"],
          "IM-A725L": ["Pantech", "SKY Vega X+"],
          "IM-A730s": ["Pantech", "SKY Vega S"],
          "IM-A730S": ["Pantech", "SKY Vega S"],
          "IM-A750K": ["Pantech", "SKY Mirach A"],
          "IM-A760S": ["Pantech", "SKY Vega Racer"],
          "IM-A770K": ["Pantech", "SKY Vega Racer"],
          "IM-A780L": ["Pantech", "SKY Vega Racer"],
          "IM-A800S": ["Pantech", "SKY Vega LTE"],
          "IM-A810K": ["Pantech", "SKY Vega LTE M"],
          "IM-A810S": ["Pantech", "SKY Vega LTE M"],
          "IM-A820L": ["Pantech", "SKY Vega LTE EX"],
          "IM-A830K": ["Pantech", "SKY Vega Racer 2"],
          "IM-A830L": ["Pantech", "SKY Vega Racer 2"],
          "IM-A830S": ["Pantech", "SKY Vega Racer 2"],
          "IM-A840S": ["Pantech", "SKY Vega S5"],
          "IM-A850K": ["Pantech", "IM-A850K"],
          "IM-T100K": ["Pantech", "SKY Vega No. 5", "tablet"],
          IS06: ["Pantech", "SIRIUS Ã�Â±"],
          ADR8995: ["Pantech", "Breakout"],
          "ADR8995 4G": ["Pantech", "Breakout"],
          "ADR910L 4G": ["Pantech", "ADR910L"],
          PantechP4100: ["Pantech", "Element", "tablet"],
          PantechP8000: ["Pantech", "Crossover"],
          PantechP8010: ["Pantech", "P8010"],
          PantechP9060: ["Pantech", "Pocket"],
          PantechP9070: ["Pantech", "Burst"],
          "SKY IM-A600S": ["Pantech", "SIRIUS Ã�Â±"],
          "SKY IM-A630K": ["Pantech", "SKY Izar"],
          "SKY IM-A650S": ["Pantech", "SKY Vega"],
          IS11PT: ["Pantech", "Mirach IS11PT"],
          PAT712W: ["Perfeo", "PAT712W", "tablet"],
          X7G: ["Pearl", "Touchlet X7G", "tablet"],
          FWS810: ["PHICOMM", "FWS810"],
          "Philips PI5000": ["Philips", "PI5000", "tablet"],
          PI7000: ["Philips", "PI7000", "tablet"],
          "Philips W626": ["Philips", "W626"],
          "Philips W632": ["Philips", "W632"],
          MOMO: ["Ployer", "MOMO", "tablet"],
          MOMO15: ["Ployer", "MOMO15", "tablet"],
          "PocketBook A7": ["PocketBook", "A7", "tablet"],
          "PocketBook A10": ["PocketBook", "A10", "tablet"],
          "Mobii 7": ["Point Of View", "Mobii 7", "tablet"],
          PMP3384BRU: ["Prestigio", "Multipad 3384", "tablet"],
          TB07FTA: ["Positivo", "TB07FTA", "tablet"],
          "QW TB-1207": ["Qware", "Pro3", "tablet"],
          "W6HD ICS": ["Ramos", "W6HD", "tablet"],
          w10: ["Ramos", "W10", "tablet"],
          W10: ["Ramos", "W10", "tablet"],
          "w10 v2.0": ["Ramos", "W10 v2.0", "tablet"],
          "W10 V2.0": ["Ramos", "W10 v2.0", "tablet"],
          T11AD: ["Ramos", "T11AD", "tablet"],
          "T11AD.FE": ["Ramos", "T11AD", "tablet"],
          PlayBook: ["RIM", "BlackBerry PlayBook", "tablet"],
          "RBK-490": ["Ritmix", "RBK-490", "tablet"],
          A8HD: ["Saayi", "Dropad A8HD", "tablet"],
          "GT-S7568": ["Samsung", "S7568"],
          "Galaxy Nexus": ["Samsung", "Galaxy Nexus"],
          "GT-B5330": ["Samsung", "GT-B5330"],
          "GT-B5510": ["Samsung", "Galaxy Y Pro"],
          "GT-B5510B": ["Samsung", "Galaxy Y Pro"],
          "GT-B5510L": ["Samsung", "Galaxy Y Pro"],
          "GT-B5512": ["Samsung", "Galaxy Y Pro Duos"],
          "GT-B7510": ["Samsung", "Galaxy Pro"],
          "GT-B7510L": ["Samsung", "Galaxy Pro"],
          "GT-I5500": ["Samsung", "Galaxy 5"],
          "GT-I5500B": ["Samsung", "Galaxy 5"],
          "GT-I5500L": ["Samsung", "Galaxy 5"],
          "GT-I5500M": ["Samsung", "Galaxy 5"],
          "GT-I5500-MR3": ["Samsung", "Galaxy 5"],
          "GT-I5503": ["Samsung", "Galaxy 5"],
          "GT-I5508": ["Samsung", "Galaxy 5"],
          "GT-I5510": ["Samsung", "Galaxy 551"],
          "GT-I5510L": ["Samsung", "Galaxy 551"],
          "GT-I5510M": ["Samsung", "Galaxy 551"],
          "GT-I5510T": ["Samsung", "Galaxy 551"],
          "GT-I5700": ["Samsung", "Galaxy Spica"],
          "GT-I5700L": ["Samsung", "Galaxy Spica"],
          "GT-I5800": ["Samsung", "Galaxy Apollo"],
          "GT-I5800D": ["Samsung", "Galaxy Apollo"],
          "GT-I5800L": ["Samsung", "Galaxy Apollo"],
          "GT-I5801": ["Samsung", "Galaxy Apollo"],
          "GT-I6500U": ["Samsung", "Saturn"],
          "GT-I8000": ["Samsung", "Omnia 2"],
          "GT-I8150": ["Samsung", "Galaxy W"],
          "GT-I8150B": ["Samsung", "Galaxy W"],
          "GT-I8160": ["Samsung", "Galaxy Ace 2"],
          "GT-I8160L": ["Samsung", "Galaxy Ace 2"],
          "GT-I8160P": ["Samsung", "Galaxy Ace 2"],
          "GT-I8320": ["Samsung", "H1"],
          "GT-I8520": ["Samsung", "Galaxy Beam"],
          "GT-I8530": ["Samsung", "Galaxy Beam"],
          "GT-I8250": ["Samsung", "Galaxy Beam"],
          "GT-i9000": ["Samsung", "Galaxy S"],
          "GT-I9000": ["Samsung", "Galaxy S"],
          "GT-I9000B": ["Samsung", "Galaxy S"],
          "GT-I9000M": ["Samsung", "Galaxy S Vibrant"],
          "GT-I9000T": ["Samsung", "Galaxy S"],
          "GT-I9001": ["Samsung", "Galaxy S Plus"],
          "GT-I9003": ["Samsung", "Galaxy SL"],
          "GT-I9003L": ["Samsung", "Galaxy SL"],
          "GT-I9008": ["Samsung", "Galaxy S"],
          "GT-I9008L": ["Samsung", "Galaxy S"],
          "GT-I9010": ["Samsung", "Galaxy S Giorgio Armani"],
          "GT-I9018": ["Samsung", "Galaxy GT-I9018"],
          "GT-I9070": ["Samsung", "Galaxy S Advance"],
          "GT-I9070P": ["Samsung", "Galaxy S Advance"],
          "GT-I9082": ["Samsung", "Galaxy Grand DUOS"],
          "GT-I9088": ["Samsung", "Galaxy S"],
          "GT-i9100": ["Samsung", "Galaxy S II"],
          "GT-I9100": ["Samsung", "Galaxy S II"],
          "GT-I9100G": ["Samsung", "Galaxy S II"],
          "GT-I9100M": ["Samsung", "Galaxy S II"],
          "GT-I9100T": ["Samsung", "Galaxy S II"],
          "GT-I9100P": ["Samsung", "Galaxy S II"],
          "GT-I9103": ["Samsung", "Galaxy R"],
          "GT-I9108": ["Samsung", "Galaxy S II"],
          "GT-I9210": ["Samsung", "Galaxy S II LTE"],
          "GT-I9210T": ["Samsung", "Galaxy S II LTE"],
          "GT-I9220": ["Samsung", "Galaxy Note"],
          "GT-I9228": ["Samsung", "Galaxy Note"],
          "GT-I9250": ["Samsung", "Galaxy Nexus"],
          "GT-I9250 EUR XX": ["Samsung", "Galaxy Nexus"],
          "GT-I9260": ["Samsung", "Galaxy Premier"],
          "GT-I9300": ["Samsung", "Galaxy S III"],
          "GT-I9300T": ["Samsung", "Galaxy S III"],
          "GT-I9303T": ["Samsung", "Galaxy S III"],
          "GT-I9308": ["Samsung", "Galaxy S III"],
          "GT-I9500": ["Samsung", "Galaxy GT-I9500"],
          "GT-I9800": ["Samsung", "Galaxy GT-I9800"],
          "GT-N7000": ["Samsung", "Galaxy Note"],
          "GT-N7000B": ["Samsung", "Galaxy Note"],
          "GT-N7100": ["Samsung", "Galaxy Note II"],
          "GT-N7102": ["Samsung", "Galaxy Note II"],
          "GT-N8000": ["Samsung", "Galaxy Note 10.1"],
          "GT-N8010": ["Samsung", "Galaxy Note 10.1"],
          "GT-P1000": ["Samsung", "Galaxy Tab", "tablet"],
          "GT-P1000L": ["Samsung", "Galaxy Tab", "tablet"],
          "GT-P1000M": ["Samsung", "Galaxy Tab", "tablet"],
          "GT-P1000N": ["Samsung", "Galaxy Tab", "tablet"],
          "GT-P1000T": ["Samsung", "Galaxy Tab", "tablet"],
          "GT-P1000 Tablet": ["Samsung", "Galaxy Tab", "tablet"],
          "GT-P1010": ["Samsung", "Galaxy Tab", "tablet"],
          "GT-P3100": ["Samsung", "Galaxy Tab 2 (7.0)", "tablet"],
          "GT-P3100B": ["Samsung", "Galaxy Tab 2 (7.0)", "tablet"],
          "GT-P3110": ["Samsung", "Galaxy Tab 2 (7.0)", "tablet"],
          "GT-P3113": ["Samsung", "Galaxy Tab 2 (7.0)", "tablet"],
          "GT-P5100": ["Samsung", "Galaxy Tab 2 (10.1)", "tablet"],
          "GT-P5110": ["Samsung", "Galaxy Tab 2 (10.1)", "tablet"],
          "GT-P5113": ["Samsung", "Galaxy Tab 2 (10.1)", "tablet"],
          "GT-P6200": ["Samsung", "Galaxy Tab 7.0 Plus", "tablet"],
          "GT-P6200L": ["Samsung", "Galaxy Tab 7.0 Plus", "tablet"],
          "GT-P6201": ["Samsung", "Galaxy Tab 7.0 Plus N", "tablet"],
          "GT-P6210": ["Samsung", "Galaxy Tab 7.0 Plus", "tablet"],
          "GT-P6211": ["Samsung", "Galaxy Tab 7.0 Plus N", "tablet"],
          "GT-P6800": ["Samsung", "Galaxy Tab 7.7", "tablet"],
          "GT-P6810": ["Samsung", "Galaxy Tab 7.7", "tablet"],
          "GT-P7100": ["Samsung", "Galaxy Tab 10.1V", "tablet"],
          "GT-P7300": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "GT-P7300B": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "GT-P7310": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "GT-P7320": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "GT-P7320T": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "GT-P7500": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "GT-P7500D": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "GT-P7500R": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "GT-P7500V": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "GT-P7501": ["Samsung", "Galaxy Tab 10.1N", "tablet"],
          "GT-P7510": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "GT-P7511": ["Samsung", "Galaxy Tab 10.1N", "tablet"],
          "GT-S5300": ["Samsung", "Galaxy Pocket"],
          "GT-S5360": ["Samsung", "Galaxy Y"],
          "GT-S5360B": ["Samsung", "Galaxy Y"],
          "GT-S5360L": ["Samsung", "Galaxy Y"],
          "GT-S5363": ["Samsung", "Galaxy Y"],
          "GT-S5367": ["Samsung", "Galaxy Y TV"],
          "GT-S5368": ["Samsung", "GT-S5368"],
          "GT-S5369": ["Samsung", "Galaxy Y"],
          "GT-S5570": ["Samsung", "Galaxy Mini"],
          "GT-S5570B": ["Samsung", "Galaxy Mini"],
          "GT-S5570I": ["Samsung", "Galaxy Mini"],
          "GT-S5570L": ["Samsung", "Galaxy Mini"],
          "GT-S5578": ["Samsung", "Galaxy Mini"],
          "GT-S5660": ["Samsung", "Galaxy Gio"],
          "GT-S5660M": ["Samsung", "Galaxy Gio"],
          "GT-S5660V": ["Samsung", "Galaxy Gio"],
          "GT-S5670": ["Samsung", "Galaxy Fit"],
          "GT-S5670B": ["Samsung", "Galaxy Fit"],
          "GT-S5670L": ["Samsung", "Galaxy Fit"],
          "GT-S5690": ["Samsung", "Galaxy Xcover"],
          "GT-S5690L": ["Samsung", "Galaxy Xcover"],
          "GT-S5820": ["Samsung", "Galaxy Ace"],
          "GT-S5830": ["Samsung", "Galaxy Ace"],
          "GT-S5830B": ["Samsung", "Galaxy Ace"],
          "GT-S5830C": ["Samsung", "Galaxy Ace"],
          "GT-S5830D": ["Samsung", "Galaxy Ace"],
          "GT-S5830D-parrot": ["Samsung", "Galaxy Ace"],
          "GT-S5830i": ["Samsung", "Galaxy Ace"],
          "GT-S5830L": ["Samsung", "Galaxy Ace"],
          "GT-S5830M": ["Samsung", "Galaxy Ace"],
          "GT-S5830T": ["Samsung", "Galaxy Ace"],
          "GT-S5838": ["Samsung", "Galaxy Ace"],
          "GT-S5839i": ["Samsung", "Galaxy Ace"],
          "GT-S6102": ["Samsung", "Galaxy Y Duos"],
          "GT-S6102B": ["Samsung", "Galaxy Y Duos"],
          "GT-S6500": ["Samsung", "Galaxy Mini 2"],
          "GT-S6500D": ["Samsung", "Galaxy Mini 2"],
          "GT-S6702": ["Samsung", "GT-S6702"],
          "GT-S6802": ["Samsung", "Galaxy Ace Duos"],
          "GT-S7500": ["Samsung", "Galaxy Ace Plus"],
          "GT-S7500L": ["Samsung", "Galaxy Ace Plus"],
          "GT-S7500W": ["Samsung", "Galaxy Ace Plus"],
          "GT-T959": ["Samsung", "Galaxy S Vibrant"],
          "SCH-i509": ["Samsung", "Galaxy Y"],
          "SCH-i559": ["Samsung", "Galaxy Pop"],
          "SCH-i569": ["Samsung", "Galaxy Gio"],
          "SCH-i579": ["Samsung", "Galaxy Ace"],
          "SCH-i589": ["Samsung", "Galaxy Ace Duos"],
          "SCH-i705 4G": ["Samsung", "Galaxy Tab 2 (7.0)", "tablet"],
          "SCH-i809": ["Samsung", "SCH-i809"],
          "SCH-i889": ["Samsung", "Galaxy Note"],
          "SCH-i909": ["Samsung", "Galaxy S"],
          "SCH-i919": ["Samsung", "SCH-i919"],
          "SCH-i929": ["Samsung", "SCH-i929"],
          "SCH-I100": ["Samsung", "Gem"],
          "SCH-I110": ["Samsung", "Illusion"],
          "SCH-I400": ["Samsung", "Continuum"],
          "SCH-I405": ["Samsung", "Stratosphere"],
          "SCH-I405 4G": ["Samsung", "Stratosphere"],
          "SCH-I500": ["Samsung", "Fascinate"],
          "SCH-I510": ["Samsung", "Stealth V"],
          "SCH-I510 4G": ["Samsung", "Droid Charge"],
          "SCH-I515": ["Samsung", "Galaxy Nexus"],
          "SCH-I535": ["Samsung", "Galaxy S III"],
          "SCH-I535 4G": ["Samsung", "Galaxy S III"],
          "SCH-I619": ["Samsung", "SCH-I619"],
          "SCH-I699": ["Samsung", "SCH-I699"],
          "SCH-I779": ["Samsung", "SCH-I779"],
          "SCH-I800": ["Samsung", "Galaxy Tab 7.0", "tablet"],
          "SCH-I815": ["Samsung", "Galaxy Tab 7.7", "tablet"],
          "SCH-I815 4G": ["Samsung", "Galaxy Tab 7.7", "tablet"],
          "SCH-I905": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "SCH-I905 4G": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "SCH-I909": ["Samsung", "Galaxy S"],
          "SCH-I915": ["Samsung", "SCH-I915"],
          "SCH-I939": ["Samsung", "Galaxy S III"],
          "SCH-M828C": ["Samsung", "Galaxy Precedent"],
          "SCH-M828Carray(9096483449)": ["Samsung", "Galaxy Precedent"],
          "SCH-R530U": ["Samsung", "Galaxy S III"],
          "SCH-R680": ["Samsung", "Repp"],
          "SCH-R720": ["Samsung", "Admire"],
          "SCH-R730": ["Samsung", "Transfix"],
          "SCH-R760": ["Samsung", "Galaxy S II"],
          "SCH-R820": ["Samsung", "SCH-R820"],
          "SCH-R880": ["Samsung", "Acclaim"],
          "SCH-R910": ["Samsung", "Galaxy Indulge 4G"],
          "SCH-R915": ["Samsung", "Galaxy Indulge"],
          "SCH-R920": ["Samsung", "Galaxy Attain 4G"],
          "SCH-R930": ["Samsung", "Galaxy S Aviator"],
          "SCH-R940": ["Samsung", "Galaxy S Lightray"],
          "SCH-S720C": ["Samsung", "Galaxy Proclaim"],
          "SCH-S735C": ["Samsung", "SCH-S735"],
          "SCH-W899": ["Samsung", "SCH-W899"],
          "SCH-W999": ["Samsung", "SCH-W999"],
          "SGH-I547": ["Samsung", "SGH-I547"],
          "SGH-I717": ["Samsung", "Galaxy Note"],
          "SGH-I717D": ["Samsung", "Galaxy Note"],
          "SGH-I717M": ["Samsung", "Galaxy Note"],
          "SGH-I717R": ["Samsung", "Galaxy Note"],
          "SGH-I727": ["Samsung", "Galaxy S II Skyrocket"],
          "SGH-i727R": ["Samsung", "Galaxy S II"],
          "SGH-I727R": ["Samsung", "Galaxy S II"],
          "SGH-I747": ["Samsung", "Galaxy S III"],
          "SGH-I747M": ["Samsung", "Galaxy S III"],
          "SGH-I748": ["Samsung", "Galaxy S III"],
          "SGH-I757": ["Samsung", "Galaxy S II Skyrocket HD"],
          "SGH-I777": ["Samsung", "Galaxy S II"],
          "SGH-I9777": ["Samsung", "Galaxy S II"],
          "SGH-I896": ["Samsung", "Captivate"],
          "SGH-I897": ["Samsung", "Captivate"],
          "SGH-I927": ["Samsung", "Captivate Glide"],
          "SGH-I927R": ["Samsung", "Captivate Glide"],
          "SGH-I957": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "SGH-I957D": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "SGH-I957M": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "SGH-I957R": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "SGH-I987": ["Samsung", "Galaxy Tab 7.0", "tablet"],
          "SGH-I997": ["Samsung", "Infuse 4G"],
          "SGH-I997R": ["Samsung", "Infuse 4G"],
          "SGH-I9000": ["Samsung", "Galaxy S"],
          "SGH-S730G": ["Samsung", "SGH-S730"],
          "SGH-T499": ["Samsung", "Dart"],
          "SGH-T499V": ["Samsung", "Galaxy Mini"],
          "SGH-T499Y": ["Samsung", "Galaxy Mini"],
          "SGH-T589": ["Samsung", "Gravity Smart"],
          "SGH-T589R": ["Samsung", "Gravity Smart"],
          "SGH-T679": ["Samsung", "Exhibit II 4G"],
          "SGH-T679M": ["Samsung", "Exhibit II 4G"],
          "SGH-T759": ["Samsung", "Exhibit 4G"],
          "SGH-T769": ["Samsung", "Galaxy S Blaze 4G"],
          "SGH-T839": ["Samsung", "T-Mobile Sidekick"],
          "SGH-T849": ["Samsung", "Galaxy Tab 7.0", "tablet"],
          "SGH-T859": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "SGH-T869": ["Samsung", "Galaxy Tab 7.0 Plus", "tablet"],
          "SGH-T879": ["Samsung", "Galaxy Note"],
          "SGH-T959": ["Samsung", "Vibrant"],
          "SGH-T959D": ["Samsung", "Galaxy S Fascinate 3G+"],
          "SGH-T959P": ["Samsung", "Galaxy S Fascinate 4G"],
          "SGH-T959V": ["Samsung", "Galaxy S 4G"],
          "SGH-T989": ["Samsung", "Galaxy S II"],
          "SGH-T989D": ["Samsung", "Galaxy S II X"],
          "SGH-T999": ["Samsung", "Galaxy S Blaze 4G"],
          "SGH-T999V": ["Samsung", "Galaxy S Blaze 4G"],
          "SHV-E120K": ["Samsung", "Galaxy S II HD LTE"],
          "SHV-E120L": ["Samsung", "Galaxy S II HD LTE"],
          "SHV-E120S": ["Samsung", "Galaxy S II HD LTE"],
          "SHV-E110S": ["Samsung", "Galaxy S II LTE"],
          "SHV-E140S": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "SHV-E150S": ["Samsung", "Galaxy Tab 7.7", "tablet"],
          "SHV-E160K": ["Samsung", "Galaxy Note"],
          "SHV-E160L": ["Samsung", "Galaxy Note LTE"],
          "SHV-E160S": ["Samsung", "Galaxy Note LTE"],
          "SHV-E170K": ["Samsung", "SHV-E170K"],
          "SHV-E170L": ["Samsung", "SHV-E170L"],
          "SHV-E210K": ["Samsung", "Galaxy S III"],
          "SHV-E210L": ["Samsung", "Galaxy S III"],
          "SHV-E210S": ["Samsung", "Galaxy S III"],
          "SHW-M100S": ["Samsung", "Galaxy A"],
          "SHW-M110S": ["Samsung", "Galaxy S"],
          "SHW-M130L": ["Samsung", "Galaxy U"],
          "SHW-M130K": ["Samsung", "Galaxy K"],
          "SHW-M180K": ["Samsung", "Galaxy Tab", "tablet"],
          "SHW-M180L": ["Samsung", "Galaxy Tab", "tablet"],
          "SHW-M180S": ["Samsung", "Galaxy Tab", "tablet"],
          "SHW-M180W": ["Samsung", "Galaxy Tab", "tablet"],
          "SHW-M185S": ["Samsung", "Galaxy Tab", "tablet"],
          "SHW-M190S": ["Samsung", "Galaxy S Hoppin"],
          "SHW-M220L": ["Samsung", "Galaxy Neo"],
          "SHW-M240S": ["Samsung", "Galaxy Ace"],
          "SHW-M250K": ["Samsung", "Galaxy S II"],
          "SHW-M250L": ["Samsung", "Galaxy S II"],
          "SHW-M250S": ["Samsung", "Galaxy S II"],
          "SHW-M300W": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "SHW-M305W": ["Samsung", "Galaxy Tab 8.9", "tablet"],
          "SHW-M340S": ["Samsung", "Galaxy M Style"],
          "SHW-M380K": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "SHW-M380S": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "SHW-M380W": ["Samsung", "Galaxy Tab 10.1", "tablet"],
          "SHW-M440S": ["Samsung", "Galaxy S III"],
          "SMT-i9100": ["Samsung", "SMT-I9100", "tablet"],
          "SPH-D600": ["Samsung", "Conquer 4G"],
          "SPH-D700": ["Samsung", "Epic 4G"],
          "SPH-D705": ["Samsung", "Epic 4G 2"],
          "SPH-D710": ["Samsung", "Epic 4G Touch"],
          "SPH-L700": ["Samsung", "Galaxy Nexus"],
          "SPH-L710": ["Samsung", "Galaxy S III"],
          "SPH-M820": ["Samsung", "Galaxy Prevail"],
          "SPH-M820-BST": ["Samsung", "Galaxy Prevail"],
          "SPH-M580": ["Samsung", "Replenish"],
          "SPH-M900": ["Samsung", "Moment"],
          "SPH-M910": ["Samsung", "Intercept"],
          "SPH-M920": ["Samsung", "Transform"],
          "SPH-M930": ["Samsung", "Transform Ultra"],
          "SPH-M930BST": ["Samsung", "Transform Ultra"],
          "SPH-P100": ["Samsung", "Galaxy Tab", "tablet"],
          "YP-GB1": ["Samsung", "Galaxy Player", "media"],
          "YP-GB70": ["Samsung", "Galaxy Player 70", "media"],
          "YP-GB70D": ["Samsung", "Galaxy Player 70 Plus", "media"],
          "YP-GS1": ["Samsung", "Galaxy S WiFi 3.6", "media"],
          "YP-G1": ["Samsung", "Galaxy S WiFi 4.0", "media"],
          "YP-GI1": ["Samsung", "Galaxy S WiFi 4.2", "media"],
          "YP-G50": ["Samsung", "Galaxy Player", "media"],
          "YP-G70": ["Samsung", "Galaxy S WiFi 5.0", "media"],
          GT9100: ["Samsung", "Galaxy S II"],
          I897: ["Samsung", "Captivate"],
          I7500: ["Samsung", "Galaxy"],
          I9000: ["Samsung", "Galaxy S"],
          T959: ["Samsung", "Galaxy S Vibrant"],
          "Captivate-I897": ["Samsung", "Captivate"],
          Galaxy: ["Samsung", "Galaxy"],
          "Galaxy Note": ["Samsung", "Galaxy Note"],
          GalaxyS: ["Samsung", "Galaxy S"],
          "Galaxy S II": ["Samsung", "Galaxy S II"],
          "Galaxy X": ["Samsung", "Galaxy X"],
          "Galaxy Spica": ["Samsung", "Galaxy Spica"],
          "GALAXY Tab": ["Samsung", "Galaxy Tab", "tablet"],
          "GALAXY NEXUS": ["Samsung", "Galaxy Nexus"],
          Vibrantmtd: ["Samsung", "Vibrant"],
          "SC-01C": ["Samsung", "Galaxy Tab", "tablet"],
          "SC-01D": ["Samsung", "Galaxy Tab 10.1 LTE", "tablet"],
          "SC-02B": ["Samsung", "Galaxy S"],
          "SC-02C": ["Samsung", "Galaxy S II"],
          "SC-02D": ["Samsung", "Galaxy Tab 7.0 Plus", "tablet"],
          "SC-03D": ["Samsung", "Galaxy S II LTE"],
          "SC-04D": ["Samsung", "Galaxy Nexus"],
          "SC-05D": ["Samsung", "Galaxy Note LTE"],
          "SC-06D": ["Samsung", "Galaxy S III"],
          ISW11SC: ["Samsung", "Galaxy S II WiMAX"],
          "GT-S7562": ["Samsung", "GT-S7562"],
          "GT-S7562i": ["Samsung", "GT-S7562i"],
          A01SH: ["Sharp", "A01SH"],
          IS01: ["Sharp", "IS01"],
          IS03: ["Sharp", "IS03"],
          IS05: ["Sharp", "IS05"],
          IS11SH: ["Sharp", "Aquos IS11SH"],
          IS12SH: ["Sharp", "Aquos IS12SH"],
          IS13SH: ["Sharp", "Aquos IS13SH"],
          IS14SH: ["Sharp", "Aquos IS14SH"],
          ISW16SH: ["Sharp", "Aquos ISW16SH"],
          "EB-W51GJ": ["Sharp", "EB-W51GJ"],
          SBM003SH: ["Sharp", "Galapagos"],
          SBM005SH: ["Sharp", "Galapagos"],
          SBM006SH: ["Sharp", "Aquos"],
          SBM007SH: ["Sharp", "Aquos 007SH"],
          SBM009SH: ["Sharp", "Aquos 009SH"],
          SBM102SH: ["Sharp", "Aquos 102SH"],
          SBM103SH: ["Sharp", "Aquos 103SH"],
          SBM104SH: ["Sharp", "Aquos 104SH"],
          SBM107SH: ["Sharp", "Aquos 107SH"],
          SBM107SHB: ["Sharp", "Aquos 107SH"],
          "SH-01D": ["Sharp", "Aquos SH-01D"],
          "SH-02D": ["Sharp", "Aquos slider SH-02D"],
          "SH-03C": ["Sharp", "Lynx 3D"],
          "SH-06D": ["Sharp", "Aquos SH-06D"],
          "SH-09D": ["Sharp", "Aquos Zeta SH-09D"],
          "SH-10B": ["Sharp", "Lynx"],
          "SH-12C": ["Sharp", "Aquos"],
          "SH-13C": ["Sharp", "Aquos f SH-13C"],
          SH80F: ["Sharp", "Aquos SH80F"],
          SH72x8U: ["Sharp", "SH72x8U"],
          SH8118U: ["Sharp", "SH8118U"],
          SH8128U: ["Sharp", "SH8128U"],
          SH8158U: ["Sharp", "SH8158U"],
          SH8188U: ["Sharp", "SH8188U"],
          SH8268U: ["Sharp", "SH8268U"],
          "INFOBAR C01": ["Sharp", "INFOBAR C01"],
          "SPX-5": ["Simvalley", "SPX-5"],
          "SPX-5 3G": ["Simvalley", "SPX-5 3G"],
          "SmartQ G7": ["SmartQ", "G7", "tablet"],
          SmartQT7: ["SmartQ", "T7", "tablet"],
          SmartQT10: ["SmartQ", "T10", "tablet"],
          SmartQT15: ["SmartQ", "T15", "tablet"],
          SmartQT19: ["SmartQ", "T19", "tablet"],
          SmartQT20: ["SmartQ", "T20", "tablet"],
          "OMS1 6": ["Sony Ericsson", "A8i"],
          E10a: ["Sony Ericsson", "Xperia X10 Mini"],
          E10i: ["Sony Ericsson", "Xperia X10 Mini"],
          E10iv: ["Sony Ericsson", "Xperia X10 Mini"],
          E15: ["Sony Ericsson", "Xperia X8"],
          E15a: ["Sony Ericsson", "Xperia X8"],
          E15i: ["Sony Ericsson", "Xperia X8"],
          E15iv: ["Sony Ericsson", "Xperia X8"],
          "E15i-o": ["Sony Ericsson", "Xperia X8"],
          E16i: ["Sony Ericsson", "W8 Walkman"],
          LT11i: ["Sony Ericsson", "Xperia Neo V"],
          LT15: ["Sony Ericsson", "Xperia Arc"],
          LT15a: ["Sony Ericsson", "Xperia Arc"],
          LT15i: ["Sony Ericsson", "Xperia Arc"],
          LT15iv: ["Sony Ericsson", "Xperia Arc"],
          "LT15i-o": ["Sony Ericsson", "Xperia Arc"],
          LT18a: ["Sony Ericsson", "Xperia Arc S"],
          LT18i: ["Sony Ericsson", "Xperia Arc S"],
          LT18iv: ["Sony Ericsson", "Xperia Arc S"],
          "LT18i-o": ["Sony Ericsson", "Xperia Arc S"],
          LT22i: ["Sony", "Xperia P"],
          LT26i: ["Sony", "Xperia S"],
          LT26ii: ["Sony", "Xperia S"],
          "LT26i-o": ["Sony", "Xperia S"],
          LT28at: ["Sony", "Xperia Ion"],
          LT28h: ["Sony", "Xperia Ion"],
          LT28i: ["Sony", "Xperia Ion"],
          LT29i: ["Sony", "Xperia GX"],
          SonyLT29i: ["Sony", "Xperia GX"],
          SonyLT30a: ["Sony", "Xperia Mint"],
          SonyLT30p: ["Sony", "Xperia Mint"],
          MK16a: ["Sony Ericsson", "Xperia Pro"],
          MK16i: ["Sony Ericsson", "Xperia Pro"],
          MT11a: ["Sony Ericsson", "Xperia Neo V"],
          MT11i: ["Sony Ericsson", "Xperia Neo V"],
          MT11iv: ["Sony Ericsson", "Xperia Neo V"],
          "MT11i-o": ["Sony Ericsson", "Xperia Neo V"],
          MT15a: ["Sony Ericsson", "Xperia Neo"],
          MT15i: ["Sony Ericsson", "Xperia Neo"],
          MT15iv: ["Sony Ericsson", "Xperia Neo"],
          "MT15i-o": ["Sony Ericsson", "Xperia Neo"],
          MT25i: ["Sony", "Xperia Neo L"],
          MT27i: ["Sony", "Xperia Sola"],
          R800a: ["Sony Ericsson", "Xperia Play"],
          R800i: ["Sony Ericsson", "Xperia Play"],
          R800iv: ["Sony Ericsson", "Xperia Play"],
          R800at: ["Sony Ericsson", "Xperia Play"],
          R800x: ["Sony Ericsson", "Xperia Play"],
          SK17a: ["Sony Ericsson", "Xperia Mini Pro"],
          SK17i: ["Sony Ericsson", "Xperia Mini Pro"],
          SK17iv: ["Sony Ericsson", "Xperia Mini Pro"],
          "SK17i-o": ["Sony Ericsson", "Xperia Mini Pro"],
          ST15a: ["Sony Ericsson", "Xperia Mini"],
          ST15i: ["Sony Ericsson", "Xperia Mini"],
          ST17a: ["Sony Ericsson", "Xperia Active"],
          ST17i: ["Sony Ericsson", "Xperia Active"],
          ST18a: ["Sony Ericsson", "Xperia Ray"],
          ST18i: ["Sony Ericsson", "Xperia Ray"],
          ST18iv: ["Sony Ericsson", "Xperia Ray"],
          ST18av: ["Sony Ericsson", "Xperia Ray"],
          SonyST21: ["Sony", "'Tapioca'"],
          SonyST21i: ["Sony", "'Tapioca'"],
          SonyST21a2: ["Sony", "'Tapioca'"],
          ST21: ["Sony", "'Tapioca'"],
          ST21i: ["Sony", "'Tapioca'"],
          SonyST23i: ["Sony", "'Tapioca DS'"],
          ST25i: ["Sony", "Xperia U"],
          ST27i: ["Sony", "Xperia Go"],
          U20a: ["Sony Ericsson", "Xperia X10 Mini Pro"],
          U20i: ["Sony Ericsson", "Xperia X10 Mini Pro"],
          U20iv: ["Sony Ericsson", "Xperia X10 Mini Pro"],
          WT13i: ["Sony Ericsson", "Mix Walkman"],
          WT18i: ["Sony Ericsson", "Walkman"],
          WT19a: ["Sony Ericsson", "Live with Walkman"],
          WT19i: ["Sony Ericsson", "Live with Walkman"],
          WT19iv: ["Sony Ericsson", "Live with Walkman"],
          X8: ["Sony Ericsson", "Xperia X8"],
          X10: ["Sony Ericsson", "Xperia X10"],
          X10a: ["Sony Ericsson", "Xperia X10"],
          X10i: ["Sony Ericsson", "Xperia X10"],
          X10iv: ["Sony Ericsson", "Xperia X10"],
          X10S: ["Sony Ericsson", "Xperia X10"],
          X10mini: ["Sony Ericsson", "Xperia X10 Mini"],
          "X10 Mini": ["Sony Ericsson", "Xperia X10 Mini"],
          "X10 Mini Pro": ["Sony Ericsson", "Xperia X10 Mini Pro"],
          Z1i: ["Sony Ericsson", "Xperia Play"],
          S51SE: ["Sony Ericsson", "Xperia Mini"],
          IS11S: ["Sony Ericsson", "Xperia Acro"],
          IS12S: ["Sony Ericsson", "Xperia Acro HD"],
          "SO-01B": ["Sony Ericsson", "Xperia X10"],
          "SO-01C": ["Sony Ericsson", "Xperia Arc"],
          "SO-01D": ["Sony Ericsson", "Xperia Play"],
          "SO-02C": ["Sony Ericsson", "Xperia Acro"],
          "SO-02D": ["Sony Ericsson", "Xperia NX"],
          "SO-03C": ["Sony Ericsson", "Xperia Ray"],
          "SO-03D": ["Sony Ericsson", "Xperia Acro HD"],
          "SO-04D": ["Sony", "Xperia GX"],
          "SO-05D": ["Sony", "Xperia SX"],
          "XPERIA X8": ["Sony Ericsson", "Xperia X8"],
          "Xperia X8": ["Sony Ericsson", "Xperia X8"],
          "Xperia X10": ["Sony Ericsson", "Xperia X10"],
          "Xperia ray": ["Sony Ericsson", "Xperia Ray"],
          "Xperia Ray": ["Sony Ericsson", "Xperia Ray"],
          "Xperia Arc": ["Sony Ericsson", "Xperia Arc"],
          "Xperia Mini": ["Sony Ericsson", "Xperia Mini"],
          "Xperia neo": ["Sony Ericsson", "Xperia Neo"],
          "Xperia Neo": ["Sony Ericsson", "Xperia Neo"],
          "XPERIA NEO": ["Sony Ericsson", "Xperia Neo"],
          "Xperia NeoV": ["Sony Ericsson", "Xperia Neo V"],
          "Xperia Neo V": ["Sony Ericsson", "Xperia Neo V"],
          "Xperia Play": ["Sony Ericsson", "Xperia Play"],
          "Sony Ericsson Xperia X1": ["Sony Ericsson", "Xperia X1"],
          SonyHayabusa: ["Sony", "Xperia Ion"],
          Hayabusa: ["Sony", "Xperia Ion"],
          nozomi: ["Sony", "Xperia S"],
          "Sony Tablet P": ["Sony", "Tablet P", "tablet"],
          "Sony Tablet S": ["Sony", "Tablet S", "tablet"],
          "NWZ-Z1000Series": ["Sony", "Walkman Z", "media"],
          "NW-Z1000Series": ["Sony", "Walkman Z", "media"],
          "Spice Mi280": ["Spice", "Mi-280"],
          "Spice Mi300": ["Spice", "Mi-300"],
          "Spice Mi-310": ["Spice", "Mi-310"],
          "Spice Mi-425": ["Spice", "Mi-425"],
          "SPICE Mi-720": ["Spice", "Mi-720"],
          "A7272+": ["Star", "A7272+"],
          "e1109 v73 gq1002 ctp": ["Star", "X18i"],
          TS1004T: ["Surf 3Q", "TS1004T", "tablet"],
          "SYTABEX7-2": ["Sylvania", "SYTABEX7", "tablet"],
          "TCL A860": ["TCL", "A860"],
          "TCL A906": ["TCL", "A906"],
          "TCL A909": ["TCL", "A909"],
          "TCL A919": ["TCL", "A919"],
          "TCL A990": ["TCL", "A990"],
          "TCL A996": ["TCL", "A996"],
          "TCL A998": ["TCL", "A998"],
          "TCL GENESEE E708": ["TCL", "Genesee E708"],
          "A10t(5DM3)": ["Teclast", "A10T", "tablet"],
          P72: ["Teclast", "P72", "tablet"],
          P76TI: ["Teclast", "P76Ti", "tablet"],
          P81HD: ["Teclast", "P81HD", "tablet"],
          "P85(R8A1)": ["Teclast", "P85", "tablet"],
          "T720 SE": ["Teclast", "T720", "tablet"],
          "T760 from moage.com": ["Teclast", "T760", "tablet"],
          tegav2: ["Tegatech", "TEGA v2", "tablet"],
          "TM-7025": ["teXet", "TM-7025", "tablet"],
          MoFing: ["Thomson", "MoFing", "tablet"],
          Ultimate10: ["Tomtec", "Ultimate10", "tablet"],
          "Thl V7": ["THL", "V7"],
          "ThL V7": ["THL", "V7"],
          "ThL V8": ["THL", "V8"],
          "ThL V9": ["THL", "V9"],
          "ThL V11": ["THL", "V11"],
          "TSB CLOUD COMPANION;TOSHIBA AC AND AZ": ["Toshiba", "Dynabook AZ", "desktop"],
          "TOSHIBA AC AND AZ": ["Toshiba", "Dynabook AZ", "desktop"],
          "TOSHIBA FOLIO AND A": ["Toshiba", "Folio 100", "tablet"],
          "T-01C": ["Toshiba", "Regza T-01C"],
          "T-01D": ["Toshiba", "Regza T-01D"],
          IS04: ["Toshiba", "Regza IS04"],
          IS11T: ["Toshiba", "Regza IS11T"],
          AT1S0: ["Toshiba", "Regza AT1S0"],
          Tostab03: ["Toshiba", "Regza AT100", "tablet"],
          AT100: ["Toshiba", "Regza AT100", "tablet"],
          AT200: ["Toshiba", "Regza AT200", "tablet"],
          AT470: ["Toshiba", "Regza AT470", "tablet"],
          AT570: ["Toshiba", "Regza AT570", "tablet"],
          AT830: ["Toshiba", "Regza AT830", "tablet"],
          "Folio 100": ["Toshiba", "Folio 100", "tablet"],
          folio100: ["Toshiba", "Folio 100", "tablet"],
          THRiVE: ["Toshiba", "THRiVE", "tablet"],
          "Fantastic T3": ["TWM", "Fantastic T3"],
          M70014: ["United Star Technology", "M70014", "tablet"],
          PS47: ["Velocity Micro", "Cruz PS47", "tablet"],
          T301: ["Velocity Micro", "Cruz T301", "tablet"],
          "Vibo-A688": ["FIH", "Vibo A688"],
          "Videocon-V7500": ["Videocon", "V7500"],
          GTablet: ["ViewSonic", "gTablet", "tablet"],
          GtabComb: ["ViewSonic", "gTablet", "tablet"],
          "TeamDRH ICS for GTablet": ["ViewSonic", "gTablet", "tablet"],
          ViewPad7: ["ViewSonic", "ViewPad 7", "tablet"],
          "ViewPad 10e": ["ViewSonic", "ViewPad 10e", "tablet"],
          VTAB1008: ["Vizio", "VTAB1008", "tablet"],
          VTAB3010: ["Vizio", "VTAB3010", "tablet"],
          "VOTO W5300": ["VOTO", "W5300"],
          "xPAD-70": ["WayteQ", "xPAD-70", "tablet"],
          "xTAB-70": ["WayteQ", "xTAB-70", "tablet"],
          "WellcoM-A99": ["WellcoM", "A99"],
          N12: ["Window", "N12", "tablet"],
          N12R: ["Window", "N12R", "tablet"],
          N50: ["Window", "N50", "tablet"],
          N50DT: ["Window", "N50DT", "tablet"],
          N50GT: ["Window", "N50GT", "tablet"],
          "N50GT A": ["Window", "N50GT-A", "tablet"],
          N70: ["Window", "N70", "tablet"],
          "N70 DUAL CORE": ["Window", "N70 Dual Core", "tablet"],
          N80: ["Window", "N80", "tablet"],
          N90: ["Window", "N90", "tablet"],
          "N90 DUAL CORE2 V12": ["Window", "N90 Dual Core", "tablet"],
          N612: ["Wishway", "N612"],
          "AT-AS43D": ["Wolfgang", "AT-AS43D"],
          M12: ["Wopad", "M12", "tablet"],
          WM8650: ["WonderMedia", "WM8650", "tablet"],
          "MI-ONE": ["Xiaomi", "MI-ONE"],
          "MI-ONE C1": ["Xiaomi", "MI-ONE C1"],
          "MI-ONE Plus": ["Xiaomi", "MI-ONE Plus"],
          "MI 1S": ["Xiaomi", "MI-ONE Plus"],
          "MI 1SC": ["Xiaomi", "MI-ONE 1SC"],
          "mione plus": ["Xiaomi", "MI-ONE Plus"],
          "MI-TWO": ["Xiaomi", "MI-TWO"],
          "MI 2": ["Xiaomi", "MI-TWO"],
          "MI 2S": ["Xiaomi", "MI-TWO Plus"],
          "MI 2SC": ["Xiaomi", "MI-TWO Plus"],
          Q07CL01: ["XVision", "Q07", "tablet"],
          N6: ["Yarvik", "210 Tablet", "tablet"],
          EMR1879: ["Yidong", "EMR1879", "tablet"],
          "yusun W702": ["Yusun", "W702"],
          "YX-YUSUN E80": ["Yusun", "E80"],
          zt180: ["Zenithink", "ZT-180", "tablet"],
          Jaguar7: ["ZiiLabs", "Jaguar 7", "tablet"],
          "Ziss Ranger HD": ["Ziss", "Ranger HD"],
          "ZTE Libra": ["ZTE", "Libra"],
          "ZTE-T T9": ["ZTE", "Light Tab T9", "tablet"],
          V9: ["ZTE", "Light Tab V9", "tablet"],
          "V9e+": ["ZTE", "Light Tab 2", "tablet"],
          V9A: ["ZTE", "Light Tab 2", "tablet"],
          "Light Tab 2W": ["ZTE", "Light Tab 2", "tablet"],
          "Light Tab 2": ["ZTE", "Light Tab 2", "tablet"],
          V9C: ["ZTE", "Light Tab 3", "tablet"],
          V55: ["ZTE", "Optik", "tablet"],
          Acqua: ["ZTE", "Acqua"],
          Blade: ["ZTE", "Blade"],
          "Blade-V880": ["ZTE", "Blade"],
          "ZTE-U V880": ["ZTE", "Blade"],
          "Blade-opda": ["ZTE", "Blade"],
          "ZTE-BLADE": ["ZTE", "Blade"],
          "ZTE Blade": ["ZTE", "Blade"],
          "ZTE V880": ["ZTE", "Blade"],
          "ZTE-U(V)880+": ["ZTE", "Blade"],
          V880: ["ZTE", "Blade"],
          a5: ["ZTE", "Blade"],
          Blade2: ["ZTE", "Blade 2"],
          "Blade S": ["ZTE", "Blade S"],
          X500: ["ZTE", "Score"],
          "ZTE-X500": ["ZTE", "Score"],
          Skate: ["ZTE", "Skate"],
          "ZTE Skate": ["ZTE", "Skate"],
          "ZTE-Skate": ["ZTE", "Skate"],
          "ZTE-SKATE": ["ZTE", "Skate"],
          "ZTE-V960": ["ZTE", "Skate"],
          "ZTE-U V960": ["ZTE", "Skate"],
          "ZTE Racer": ["ZTE", "Racer"],
          "ZTE-RACER": ["ZTE", "Racer"],
          "MTC 916": ["ZTE", "Racer"],
          Racer: ["ZTE", "Racer"],
          RacerII: ["ZTE", "Racer 2"],
          RACERII: ["ZTE", "Racer 2"],
          "ZTE Roamer": ["ZTE", "Roamer"],
          N860: ["ZTE", "Warp"],
          N880: ["ZTE", "Blade"],
          "ZTE-T U802": ["ZTE", "T-U802"],
          "ZTE-T U806": ["ZTE", "T-U806"],
          "ZTE-T U812": ["ZTE", "T-U812"],
          "ZTE-T U830": ["ZTE", "T-U830"],
          "ZTE-T U880": ["ZTE", "T-U880"],
          "ZTE T U880": ["ZTE", "T-U880"],
          "ZTE-TU880": ["ZTE", "T-U880"],
          "ZTE-TU900": ["ZTE", "T-U900"],
          "ZTE-T U960": ["ZTE", "T-U960"],
          "ZTE-TU960s": ["ZTE", "T-U960"],
          "ZTE-T U960s": ["ZTE", "T-U960"],
          "ZTE U N720": ["ZTE", "U-N720"],
          "ZTE-U V856": ["ZTE", "U-V856"],
          "ZTE-U V857": ["ZTE", "U-V857"],
          "ZTE-U V881": ["ZTE", "U-V881"],
          "ZTE-U X850": ["ZTE", "U-X850"],
          "ZTE-U X876": ["ZTE", "U-X876"],
          "ZTE-X876": ["ZTE", "U-X876"],
          "ZTE-C R750": ["ZTE", "C-R750"],
          "ZTE-C N600": ["ZTE", "C-N600"],
          "ZTE-C N600+": ["ZTE", "C-N600"],
          "ZTE-C N606": ["ZTE", "C-N606"],
          "ZTE-C N700": ["ZTE", "C-N700"],
          "ZTE-C N760": ["ZTE", "C-N760"],
          "ZTE-C N880": ["ZTE", "C-N880"],
          "ZTE-C N880S": ["ZTE", "C-N880"],
          "ZTE-C N880s": ["ZTE", "C-N880"],
          "ZTE-C X500": ["ZTE", "C-X500"],
          "ZTE-C X920": ["ZTE", "C-X920"],
          "ZXY-ZTE-C X920": ["ZTE", "C-X920"],
          "ZTE GV821": ["ZTE", "G-V821"],
          "ZTE N880E": ["ZTE", "N880E"],
          "ZTE-N880E": ["ZTE", "N880E"],
          "MIUI N880S": ["ZTE", "N880S"],
          "ZTE N882E": ["ZTE", "N882E"],
          "ZTE N855D": ["ZTE", "N855D"],
          "ZTE-N910": ["ZTE", "N910"],
          E810: ["ZTE", "E810"],
          u880: ["ZTE", "U880"],
          "ZTE U880E": ["ZTE", "U880E"],
          U880: ["ZTE", "U880"],
          "ZTE U970": ["ZTE", "U970"],
          "ZTE V768": ["ZTE", "V768"],
          "ZTE-V856": ["ZTE", "V856"],
          "ZTE V877b": ["ZTE", "V877"],
          "ZTE V889D": ["ZTE", "V889"],
          "ZTE-Z990": ["ZTE", "Z990"],
          ZTEU790: ["ZTE", "U790"],
          "003Z": ["ZTE", "Softbank 003Z"],
          "008Z": ["ZTE", "Softbank 008Z"],
          "009Z": ["ZTE", "Softbank Star7"],
          "i-mobile i691": ["i-Mobile", "i691"],
          "i-mobile i695": ["i-Mobile", "i695"],
          "i-mobile i858": ["i-Mobile", "i858"],
          "i-mobile 3G 8500": ["i-Mobile", "3G 8500"],
          "i-mobile I-Note": ["i-Mobile", "i-Note", "tablet"],
          "Optimus Boston": ["Optimus", "Boston"],
          "Optimus San Francisco": ["Optimus", "San Francisco"],
          "Optimus Monte Carlo": ["Optimus", "Monte Carlo"],
          "Orange Boston": ["Orange", "Boston"],
          "Orange Monte Carlo": ["Orange", "Monte Carlo"],
          "San Francisco": ["Orange", "San Francisco"],
          "San Francisco for Orange": ["Orange", "San Francisco"],
          "Orange San Francisco": ["Orange", "San Francisco"],
          MOVE: ["T-Mobile", "MOVE"],
          "T-Mobile G1": ["T-Mobile", "G1"],
          "T-Mobile G2": ["T-Mobile", "G2"],
          "T-Mobile G2 Touch": ["T-Mobile", "G2"],
          "LG-P999": ["T-Mobile", "G2x"],
          "LG-E739": ["T-Mobile", "myTouch"],
          "T-Mobile myTouch 3G": ["T-Mobile", "myTouch 3G"],
          "T-Mobile myTouch 3G Slide": ["T-Mobile", "myTouch 3G Slide"],
          "T-Mobile Espresso": ["T-Mobile", "myTouch 3G Slide"],
          "HTC myTouch 3G Slide": ["T-Mobile", "myTouch 3G Slide"],
          "T-Mobile myTouch 4G": ["T-Mobile", "myTouch 4G"],
          "HTC Glacier": ["T-Mobile", "myTouch 4G"],
          "HTC Panache": ["T-Mobile", "myTouch 4G"],
          myTouch4G: ["T-Mobile", "myTouch 4G"],
          "My Touch 4G": ["T-Mobile", "myTouch 4G"],
          "HTC Mytouch 4G": ["T-Mobile", "myTouch 4G"],
          "HTC My Touch 4G": ["T-Mobile", "myTouch 4G"],
          "HTC mytouch4g": ["T-Mobile", "myTouch 4G"],
          "HTC myTouch 4G Slide": ["T-Mobile", "myTouch 4G Slide"],
          "myTouch 4G Slide": ["T-Mobile", "myTouch 4G Slide"],
          "T-Mobile myTouch Q": ["T-Mobile", "myTouch Q"],
          "LG-C800": ["T-Mobile", "myTouch Q"],
          "Pulse Mini": ["T-Mobile", "Pulse Mini"],
          "Vodafone 845": ["Vodafone", "845 Nova"],
          "Vodafone 858": ["Vodafone", "858 Smart"],
          "Vodafone 945": ["Vodafone", "945"],
          "Vodafone Smart II": ["Vodafone", "Smart II"],
          SmartTab10: ["Vodafone", "SmartTab 10", "tablet"],
          "SCH-N719": ["Samsung", "Galaxy Note II"],
          "Coolpad 8190": ["Coolpad", "8190"],
          U705T: ["Oppo", "Ulike2"],
          "Coolpad 8020+": ["Coolpad", "8020"],
          "Huawei Y310-5000": ["Huawei", "Y310"],
          "GT-S7572": ["Samsung", "Galaxy Trend Duos II"],
          "Lenovo A278t": ["Lenovo", "A278t"],
          "Lenovo A690": ["Lenovo", "A690"],
          "GT-I8262D": ["Samsung", "LePhone I8262D"]
        }, "Lenovo A278t", ["Lenovo", "A278t"]), Ao(e, "MI 2C", ["Xiaomi", "MI-TWO"]), Ao(e, "Coolpad 8070", ["Coolpad", "8070"]), Ao(e, "R813T", ["Oppo", "R813T"]), Ao(e, "ZTE U930", ["ZTE", "U930"]), Ao(e, "Lenovo A360", ["Lenovo", "LePhone A360"]), Ao(e, "SCH-N719", ["Samsung", "Galaxy Note II"]), Ao(e, "Coolpad 8010", ["Coolpad", "8010"]), Ao(e, "LENOVO-Lenovo-A288t", ["Lenovo", "A288t"]), Ao(e, "U701T", ["Oppo", "U701T"]), Ao(e, "ZTEU795", ["Coolpad", "U795"]), Ao(e, "Haier-HT-I617", ["Haier", "I617"]), Ao(e, "ZTEU880s", ["ZTE", "T-U880"]), Ao(e, "GT-S6352", ["Samsung", "GT-S6352"]), Ao(e, "GT-S7568", ["Samsung", "GT-S7568"]), Ao(e, "K-Touch T619+", ["K-Touch", "T619"]), Ao(e, "MI 2A", ["Xiaomi", "MI-TWO A"]), Ao(e, "GT-N7108", ["Samsung", "Galaxy Note II"]), Ao(e, "K-Touch T621", ["K-Touch", "T621"]), Ao(e, "LENOVO-Lenovo-A298t", ["Lenovo", "A298"]), Ao(e, "Coolpad 8150", ["Coolpad", "8150"]), Ao(e, "5860S", ["Coolpad", "5860"]), Ao(e, "ZTEU807", ["ZTE", "U807"]), Ao(e, "SCH-I739", ["Samsung", "SCH-I739"]), Ao(e, "SCH-I829", ["Samsung", "SCH-I829"]), Ao(e, "HS-E830", ["Hisense", "E830"]), Ao(e, "HS-E920", ["Hisense", "E920"]), Ao(e, "Lenovo S720", ["Lenovo", "S720"]), Ao(e, "MI 2C", ["Xiaomi", "MI-TWO"]), Ao(e, "OPPO R813T", ["Oppo", "R813"]), Ao(e, "SCH-I879", ["Samsung", "Galaxy Note"]), Ao(e, "GT-S6102E", ["Samsung", "Galaxy Y Duos"]), e),
        p = {
          9600: "Bold",
          9650: "Bold",
          9700: "Bold",
          9780: "Bold",
          9790: "Bold",
          9900: "Bold",
          9930: "Bold",
          8300: "Curve",
          8310: "Curve",
          8320: "Curve",
          8330: "Curve",
          "8350i": "Curve",
          8520: "Curve",
          8530: "Curve",
          8900: "Curve",
          9220: "Curve",
          9300: "Curve",
          9330: "Curve",
          9350: "Curve",
          9360: "Curve",
          9370: "Curve",
          9380: "Curve",
          8100: "Pearl",
          8110: "Pearl",
          8120: "Pearl",
          8130: "Pearl",
          8220: "Pearl",
          8230: "Pearl",
          9100: "Pearl",
          9105: "Pearl",
          9530: "Storm",
          9550: "Storm",
          9670: "Style",
          9800: "Torch",
          9810: "Torch",
          9850: "Torch",
          9860: "Torch",
          9630: "Tour",
          9981: "Porsche P"
        },
        T = function T() {
          this.initialize.apply(this, Array.prototype.slice.call(arguments));
        };
      T.prototype = {
        initialize: function initialize(e) {
          this.original = e.value || null, this.alias = e.alias || null;
        }
      };
      var v = function v() {
        this.initialize.apply(this, arguments);
      };
      function f(e) {
        return e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = void 0 === e ? "" : e).replace(/_TD$/, "")).replace(/_CMCC$/, "")).replace(/_/g, " ")).replace(/^\s+|\s+$/g, "")).replace(/\/[^/]+$/, "")).replace(/\/[^/]+ Android\/.*/, "")).replace(/^tita on /, "")).replace(/^Android on /, "")).replace(/^Android for /, "")).replace(/^ICS AOSP on /, "")).replace(/^Full AOSP on /, "")).replace(/^Full Android on /, "")).replace(/^Full Cappuccino on /, "")).replace(/^Full MIPS Android on /, "")).replace(/^Full Android/, "")).replace(/^Acer ?/i, "")).replace(/^Iconia /, "")).replace(/^Ainol /, "")).replace(/^Coolpad ?/i, "Coolpad ")).replace(/^ALCATEL /, "")).replace(/^Alcatel OT-(.*)/, "one touch $1")).replace(/^YL-/, "")).replace(/^Novo7 ?/i, "Novo7 ")).replace(/^GIONEE /, "")).replace(/^HW-/, "")).replace(/^Huawei[ -]/i, "Huawei ")).replace(/^SAMSUNG[ -]/i, "")).replace(/^SonyEricsson/, "")).replace(/^Lenovo Lenovo/, "Lenovo")).replace(/^LNV-Lenovo/, "Lenovo")).replace(/^Lenovo-/, "Lenovo ")).replace(/^(LG)[ _\/]/, "$1-")).replace(/^(HTC.*)\s(?:v|V)?[0-9.]+$/, "$1")).replace(/^(HTC)[-\/]/, "$1 ")).replace(/^(HTC)([A-Z][0-9][0-9][0-9])/, "$1 $2")).replace(/^(Motorola[\s|-])/, "")).replace(/^(Moto|MOT-)/, "")).replace(/-?(orange(-ls)?|vodafone|bouygues)$/i, "")).replace(/http:\/\/.+$/i, "")).replace(/^\s+|\s+$/g, "");
      }
      function b(e) {
        var t = (e = e.toString()).split("."),
          i = t.shift();
        return parseFloat(i + "." + t.join(""));
      }
      return v.prototype = {
        initialize: function initialize(e, t) {
          this.options = {
            useFeatures: t && t.useFeatures || !1,
            detectCamouflage: t && t.detectCamouflage || !0
          }, this.browser = {
            stock: !0,
            hidden: !1,
            channel: ""
          }, this.engine = {}, this.os = {}, this.device = {
            type: "desktop",
            identified: !1
          }, this.camouflage = !1, this.features = [], this.detect(e);
        },
        detect: function detect(e) {
          var n = null;
          if (e.match("Unix") && (this.os.name = "Unix"), e.match("FreeBSD") && (this.os.name = "FreeBSD"), e.match("OpenBSD") && (this.os.name = "OpenBSD"), e.match("NetBSD") && (this.os.name = "NetBSD"), e.match("SunOS") && (this.os.name = "Solaris"), e.match("Linux") && (this.os.name = "Linux", e.match("CentOS") && (this.os.name = "CentOS", (n = /CentOS\/[0-9\.\-]+el([0-9_]+)/.exec(e)) && (this.os.version = new T({
            value: n[1].replace(/_/g, ".")
          }))), e.match("Debian") && (this.os.name = "Debian"), e.match("Fedora") && (this.os.name = "Fedora", (n = /Fedora\/[0-9\.\-]+fc([0-9]+)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          }))), e.match("Gentoo") && (this.os.name = "Gentoo"), e.match("Kubuntu") && (this.os.name = "Kubuntu"), e.match("Mandriva Linux") && (this.os.name = "Mandriva", (n = /Mandriva Linux\/[0-9\.\-]+mdv([0-9]+)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          }))), e.match("Mageia") && (this.os.name = "Mageia", (n = /Mageia\/[0-9\.\-]+mga([0-9]+)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          }))), e.match("Red Hat") && (this.os.name = "Red Hat", (n = /Red Hat[^\/]*\/[0-9\.\-]+el([0-9_]+)/.exec(e)) && (this.os.version = new T({
            value: n[1].replace(/_/g, ".")
          }))), e.match("Slackware") && (this.os.name = "Slackware"), e.match("SUSE") && (this.os.name = "SUSE"), e.match("Turbolinux") && (this.os.name = "Turbolinux"), e.match("Ubuntu") && (this.os.name = "Ubuntu", (n = /Ubuntu\/([0-9.]*)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          })))), e.match("iPhone( Simulator)?;") || e.match("iPad;") || e.match("iPod;") || e.match(/iPhone\s*\d*s?[cp]?;/i) ? (this.os.name = "iOS", this.os.version = new T({
            value: "1.0"
          }), (n = /OS (.*) like Mac OS X/.exec(e)) && (this.os.version = new T({
            value: n[1].replace(/_/g, ".")
          })), e.match("iPhone Simulator;") ? this.device.type = "emulator" : e.match("iPod;") ? (this.device.type = "media", this.device.manufacturer = "Apple", this.device.model = "iPod Touch") : e.match("iPhone;") || e.match(/iPhone\s*\d*s?[cp]?;/i) ? (this.device.type = "mobile", this.device.manufacturer = "Apple", this.device.model = "iPhone") : (this.device.type = "tablet", this.device.manufacturer = "Apple", this.device.model = "iPad"), this.device.identified = !0) : e.match("Mac OS X") && (this.os.name = "Mac OS X", (n = /Mac OS X (10[0-9\._]*)/.exec(e)) && (this.os.version = new T({
            value: n[1].replace(/_/g, ".")
          }))), e.match("Windows")) {
            if (this.os.name = "Windows", n = /Windows NT ([0-9]\.[0-9])/.exec(e)) switch (this.os.version = b(n[1]), n[1]) {
              case "6.2":
                this.os.version = new T({
                  value: n[1],
                  alias: "8"
                });
                break;
              case "6.1":
                this.os.version = new T({
                  value: n[1],
                  alias: "7"
                });
                break;
              case "6.0":
                this.os.version = new T({
                  value: n[1],
                  alias: "Vista"
                });
                break;
              case "5.2":
                this.os.version = new T({
                  value: n[1],
                  alias: "Server 2003"
                });
                break;
              case "5.1":
                this.os.version = new T({
                  value: n[1],
                  alias: "XP"
                });
                break;
              case "5.0":
                this.os.version = new T({
                  value: n[1],
                  alias: "2000"
                });
                break;
              default:
                this.os.version = new T({
                  value: n[1],
                  alias: "NT " + this.os.version
                });
            }
            if ((e.match("Windows 95") || e.match("Win95") || e.match("Win 9x 4.00")) && (this.os.version = new T({
              value: "4.0",
              alias: "95"
            })), (e.match("Windows 98") || e.match("Win98") || e.match("Win 9x 4.10")) && (this.os.version = new T({
              value: "4.1",
              alias: "98"
            })), (e.match("Windows ME") || e.match("WinME") || e.match("Win 9x 4.90")) && (this.os.version = new T({
              value: "4.9",
              alias: "ME"
            })), (e.match("Windows XP") || e.match("WinXP")) && (this.os.name = new T({
              value: "5.1",
              alias: "XP"
            })), e.match("WP7") && (this.os.name = "Windows Phone", this.os.version = new T({
              value: "7.0",
              details: 2
            }), this.device.type = "mobile", this.browser.mode = "desktop"), (e.match("Windows CE") || e.match("WinCE") || e.match("WindowsCE")) && (e.match(" IEMobile") ? (this.os.name = "Windows Mobile", e.match(" IEMobile 8") && (this.os.version = new T({
              value: "6.5",
              details: 2
            })), e.match(" IEMobile 7") && (this.os.version = new T({
              value: "6.1",
              details: 2
            })), e.match(" IEMobile 6") && (this.os.version = new T({
              value: "6.0",
              details: 2
            }))) : (this.os.name = "Windows CE", (n = /WindowsCEOS\/([0-9.]*)/.exec(e)) && (this.os.version = new T({
              value: n[1],
              details: 2
            })), (n = /Windows CE ([0-9.]*)/.exec(e)) && (this.os.version = new T({
              value: n[1],
              details: 2
            }))), this.device.type = "mobile"), e.match("Windows Mobile") && (this.os.name = "Windows Mobile", this.device.type = "mobile"), (n = /WindowsMobile\/([0-9.]*)/.exec(e)) && (this.os.name = "Windows Mobile", this.os.version = new T({
              value: n[1],
              details: 2
            }), this.device.type = "mobile"), e.match("Windows Phone [0-9]") && (this.os.name = "Windows Mobile", this.os.version = new T({
              value: e.match(/Windows Phone ([0-9.]*)/)[1],
              details: 2
            }), this.device.type = "mobile"), e.match("Windows Phone OS")) {
              this.os.name = "Windows Phone", this.os.version = new T({
                value: e.match(/Windows Phone OS ([0-9.]*)/)[1],
                details: 2
              }), this.os.version < 7 && (this.os.name = "Windows Mobile"), (n = /IEMobile\/[^;]+; ([^;]+); ([^;]+)[;|\)]/.exec(e)) && (this.device.manufacturer = n[1], this.device.model = n[2]), this.device.type = "mobile";
              var s = this.device.manufacturer,
                v = f(this.device.model);
              void 0 !== m[s] && void 0 !== m[s][v] && (this.device.manufacturer = m[s][v][0], this.device.model = m[s][v][1], this.device.identified = !0), "Microsoft" === s && "XDeviceEmulator" === v && (this.device.manufacturer = null, this.device.model = null, this.device.type = "emulator", this.device.identified = !0);
            }
          }
          if (e.match("Android")) {
            if (this.os.name = "Android", this.os.version = null, (n = /Android(?: )?(?:AllPhone_|CyanogenMod_)?(?:\/)?v?([0-9.]+)/.exec(e.replace("-update", "."))) && (this.os.version = new T({
              value: n[1],
              details: 3
            })), e.match("Android Eclair") && (this.os.version = new T({
              value: "2.0",
              details: 3
            })), this.device.type = "mobile", this.os.version >= 3 && (this.device.type = "tablet"), this.os.version >= 4 && e.match("Mobile") && (this.device.type = "mobile"), (n = /Eclair; (?:[a-zA-Z][a-zA-Z](?:[-_][a-zA-Z][a-zA-Z])?) Build\/([^\/]*)\//.exec(e)) || (n = /; ([^;]*[^;\s])\s+Build/.exec(e)) || (n = /[a-zA-Z][a-zA-Z](?:[-_][a-zA-Z][a-zA-Z])?; ([^;]*[^;\s]);\s+Build/.exec(e)) || (n = /\(([^;]+);U;Android\/[^;]+;[0-9]+\*[0-9]+;CTC\/2.0\)/.exec(e)) || (n = /;\s?([^;]+);\s?[0-9]+\*[0-9]+;\s?CTC\/2.0/.exec(e)) || (n = /zh-cn;\s*(.*?)(\/|build)/i.exec(e)) ? this.device.model = n[1] : (n = /Android [^;]+; (?:[a-zA-Z][a-zA-Z](?:[-_][a-zA-Z][a-zA-Z])?; )?([^)]+)\)/.exec(e)) ? e.match(/[a-zA-Z][a-zA-Z](?:[-_][a-zA-Z][a-zA-Z])?/) || (this.device.model = n[1]) : (n = /^(.+?)\/\S+/i.exec(e)) && (this.device.model = n[1]), this.device.model && "Android" === this.device.model.substring(0, 7) && (this.device.model = null), this.device.model) {
              v = f(this.device.model);
              void 0 !== S[v] && (this.device.manufacturer = S[v][0], this.device.model = S[v][1], void 0 !== S[v][2] && (this.device.type = S[v][2]), this.device.identified = !0), "Emulator" !== v && "x86 Emulator" !== v && "x86 VirtualBox" !== v && "vm" !== v || (this.device.manufacturer = null, this.device.model = null, this.device.type = "emulator", this.device.identified = !0);
            }
            e.match("HP eStation") && (this.device.manufacturer = "HP", this.device.model = "eStation", this.device.type = "tablet", this.device.identified = !0), e.match("Pre/1.0") && (this.device.manufacturer = "Palm", this.device.model = "Pre", this.device.identified = !0), e.match("Pre/1.1") && (this.device.manufacturer = "Palm", this.device.model = "Pre Plus", this.device.identified = !0), e.match("Pre/1.2") && (this.device.manufacturer = "Palm", this.device.model = "Pre 2", this.device.identified = !0), e.match("Pre/3.0") && (this.device.manufacturer = "HP", this.device.model = "Pre 3", this.device.identified = !0), e.match("Pixi/1.0") && (this.device.manufacturer = "Palm", this.device.model = "Pixi", this.device.identified = !0), e.match("Pixi/1.1") && (this.device.manufacturer = "Palm", this.device.model = "Pixi Plus", this.device.identified = !0), e.match("P160UN?A?/1.0") && (this.device.manufacturer = "HP", this.device.model = "Veer", this.device.identified = !0);
          }
          if (e.match("GoogleTV") && (this.os.name = "Google TV", e.match("Chrome/5.") && (this.os.version = new T({
            value: "1"
          })), e.match("Chrome/11.") && (this.os.version = new T({
            value: "2"
          })), this.device.type = "television"), e.match("WoPhone") && (this.os.name = "WoPhone", (n = /WoPhone\/([0-9\.]*)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          })), this.device.type = "mobile"), e.match("BlackBerry") && (this.os.name = "BlackBerry OS", e.match("Opera") ? this.device.model = "BlackBerry" : ((n = /BlackBerry([0-9]*)\/([0-9.]*)/.exec(e)) && (this.device.model = n[1], this.os.version = new T({
            value: n[2],
            details: 2
          })), (n = /; BlackBerry ([0-9]*);/.exec(e)) && (this.device.model = n[1]), (n = /Version\/([0-9.]*)/.exec(e)) && (this.os.version = new T({
            value: n[1],
            details: 2
          })), this.os.version >= 10 && (this.os.name = "BlackBerry"), void 0 !== this.device.model ? void 0 !== p[this.device.model] ? this.device.model = "BlackBerry " + p[this.device.model] + " " + this.device.model : this.device.model = "BlackBerry " + this.device.model : this.device.model = "BlackBerry"), this.device.manufacturer = "RIM", this.device.type = "mobile", this.device.identified = !0), e.match("RIM Tablet OS") ? (this.os.name = "BlackBerry Tablet OS", this.os.version = new T({
            value: e.match(/RIM Tablet OS ([0-9.]*)/)[1],
            details: 2
          }), this.device.manufacturer = "RIM", this.device.model = "BlackBerry PlayBook", this.device.type = "tablet", this.device.identified = !0) : e.match("PlayBook") && (n = /Version\/(10[0-9.]*)/.exec(e)) && (this.os.name = "BlackBerry", this.os.version = new T({
            value: n[1],
            details: 2
          }), this.device.manufacturer = "RIM", this.device.model = "BlackBerry PlayBook", this.device.type = "tablet", this.device.identified = !0), e.match("(?:web|hpw)OS") && (this.os.name = "webOS", this.os.version = new T({
            value: e.match(/(?:web|hpw)OS\/([0-9.]*)/)[1]
          }), e.match("tablet") ? this.device.type = "tablet" : this.device.type = "mobile", this.device.manufacturer = e.match("hpwOS") ? "HP" : "Palm", e.match("Pre/1.0") && (this.device.model = "Pre"), e.match("Pre/1.1") && (this.device.model = "Pre Plus"), e.match("Pre/1.2") && (this.device.model = "Pre2"), e.match("Pre/3.0") && (this.device.model = "Pre3"), e.match("Pixi/1.0") && (this.device.model = "Pixi"), e.match("Pixi/1.1") && (this.device.model = "Pixi Plus"), e.match("P160UN?A?/1.0") && (this.device.model = "Veer"), e.match("TouchPad/1.0") && (this.device.model = "TouchPad"), (e.match("Emulator/") || e.match("Desktop/")) && (this.device.type = "emulator", this.device.manufacturer = null, this.device.model = null), this.device.identified = !0), (e.match("Symbian") || e.match("Series[ ]?60") || e.match("S60")) && (this.os.name = "Series60", e.match("SymbianOS/9.1") && !e.match("Series60") && (this.os.version = new T({
            value: "3.0"
          })), (n = /Series60\/([0-9.]*)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          })), (n = /Nokia([^\/;]+)[\/|;]/.exec(e)) && "Browser" !== n[1] && (this.device.manufacturer = "Nokia", this.device.model = n[1], this.device.identified = !0), (n = /Vertu([^\/;]+)[\/|;]/.exec(e)) && (this.device.manufacturer = "Vertu", this.device.model = n[1], this.device.identified = !0), (n = /Symbian; U; ([^;]+); [a-z][a-z]\-[a-z][a-z]/i.exec(e)) && (this.device.manufacturer = "Nokia", this.device.model = n[1], this.device.identified = !0), (n = /Samsung\/([^;]*);/.exec(e)) && (this.device.manufacturer = t, this.device.model = n[1], this.device.identified = !0), this.device.type = "mobile"), e.match("Series40") && (this.os.name = "Series40", (n = /Nokia([^\/]+)\//.exec(e)) && (this.device.manufacturer = "Nokia", this.device.model = n[1], this.device.identified = !0), this.device.type = "mobile"), e.match("MeeGo") && (this.os.name = "MeeGo", this.device.type = "mobile", (n = /Nokia([^\)]+)\)/.exec(e)) && (this.device.manufacturer = "Nokia", this.device.model = n[1], this.device.identified = !0)), e.match("Maemo") && (this.os.name = "Maemo", this.device.type = "mobile", (n = /(N[0-9]+)/.exec(e)) && (this.device.manufacturer = "Nokia", this.device.model = n[1], this.device.identified = !0)), e.match("Tizen") && (this.os.name = "Tizen", (n = /Tizen[\/ ]([0-9.]*)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          })), this.device.type = "mobile", (n = /\(([^;]+); ([^\/]+)\//.exec(e)) && "Linux" !== n[1] && (this.device.manufacturer = n[1], this.device.model = n[2], void 0 !== u[this.device.manufacturer] && void 0 !== u[this.device.manufacturer][this.device.model]))) {
            s = this.device.manufacturer, v = f(this.device.model);
            this.device.manufacturer = u[s][v][0], this.device.model = u[s][v][1], this.device.identified = !0;
          }
          if (e.match("[b|B]ada") && (this.os.name = "Bada", (n = /[b|B]ada\/([0-9.]*)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          })), this.device.type = "mobile", (n = /\(([^;]+); ([^\/]+)\//.exec(e)) && (this.device.manufacturer = n[1], this.device.model = f(n[2])), void 0 !== l[this.device.manufacturer] && void 0 !== l[this.device.manufacturer][this.device.model])) {
            s = this.device.manufacturer, v = f(this.device.model);
            this.device.manufacturer = l[s][v][0], this.device.model = l[s][v][1], this.device.identified = !0;
          }
          if ((e.match(/BREW/i) || e.match("BMP; U")) && (this.os.name = "Brew", this.device.type = "mobile", ((n = /BREW; U; ([0-9.]*)/i.exec(e)) || (n = /;BREW\/([0-9.]*)/i.exec(e))) && (this.os.version = new T({
            value: n[1]
          })), (n = /\(([^;]+);U;REX\/[^;]+;BREW\/[^;]+;(?:.*;)?[0-9]+\*[0-9]+;CTC\/2.0\)/.exec(e)) && (this.device.model = n[1]), this.device.model)) {
            v = f(this.device.model);
            void 0 !== d[v] && (this.device.manufacturer = d[v][0], this.device.model = d[v][1], this.device.identified = !0);
          }
          if (e.match(/\(MTK;/) && (this.os.name = "MTK", this.device.type = "mobile"), e.match("CrOS") && (this.os.name = "Chrome OS", this.device.type = "desktop"), e.match("Joli OS") && (this.os.name = "Joli OS", this.device.type = "desktop", (n = /Joli OS\/([0-9.]*)/i.exec(e)) && (this.os.version = new T({
            value: n[1]
          }))), e.match("Haiku") && (this.os.name = "Haiku", this.device.type = "desktop"), e.match("QNX") && (this.os.name = "QNX", this.device.type = "mobile"), e.match("OS/2; Warp") && (this.os.name = "OS/2 Warp", this.device.type = "desktop", (n = /OS\/2; Warp ([0-9.]*)/i.exec(e)) && (this.os.version = new T({
            value: n[1]
          }))), e.match("Grid OS") && (this.os.name = "Grid OS", this.device.type = "tablet", (n = /Grid OS ([0-9.]*)/i.exec(e)) && (this.os.version = new T({
            value: n[1]
          }))), e.match(/AmigaOS/i) && (this.os.name = "AmigaOS", this.device.type = "desktop", (n = /AmigaOS ([0-9.]*)/i.exec(e)) && (this.os.version = new T({
            value: n[1]
          }))), e.match(/MorphOS/i) && (this.os.name = "MorphOS", this.device.type = "desktop", (n = /MorphOS ([0-9.]*)/i.exec(e)) && (this.os.version = new T({
            value: n[1]
          }))), e.match("Kindle") && !e.match("Fire") && (this.os.name = "", this.device.manufacturer = "Amazon", this.device.model = "Kindle", this.device.type = "ereader", e.match("Kindle/2.0") && (this.device.model = "Kindle 2"), e.match("Kindle/3.0") && (this.device.model = "Kindle 3 or later"), this.device.identified = !0), e.match("nook browser") && (this.os.name = "Android", this.device.manufacturer = "Barnes & Noble", this.device.model = "NOOK", this.device.type = "ereader", this.device.identified = !0), e.match("bookeen/cybook") && (this.os.name = "", this.device.manufacturer = "Bookeen", this.device.model = "Cybook", this.device.type = "ereader", e.match("Orizon") && (this.device.model = "Cybook Orizon"), this.device.identified = !0), e.match("EBRD1101") && (this.os.name = "", this.device.manufacturer = "Sony", this.device.model = "Reader", this.device.type = "ereader", this.device.identified = !0), e.match("Iriver ;") && (this.os.name = "", this.device.manufacturer = "iRiver", this.device.model = "Story", this.device.type = "ereader", e.match("EB07") && (this.device.model = "Story HD EB07"), this.device.identified = !0), e.match("Nintendo Wii") && (this.os.name = "", this.device.manufacturer = "Nintendo", this.device.model = "Wii", this.device.type = "gaming", this.device.identified = !0), e.match("Nintendo DSi") && (this.os.name = "", this.device.manufacturer = "Nintendo", this.device.model = "DSi", this.device.type = "gaming", this.device.identified = !0), e.match("Nintendo 3DS") && (this.os.name = "", this.device.manufacturer = "Nintendo", this.device.model = "3DS", this.device.type = "gaming", (n = /Version\/([0-9.]*)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          })), this.device.identified = !0), e.match("PlayStation Portable") && (this.os.name = "", this.device.manufacturer = "Sony", this.device.model = "Playstation Portable", this.device.type = "gaming", this.device.identified = !0), e.match("PlayStation Vita") && (this.os.name = "", (n = /PlayStation Vita ([0-9.]*)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          })), this.device.manufacturer = "Sony", this.device.model = "PlayStation Vita", this.device.type = "gaming", this.device.identified = !0), e.match(/PlayStation 3/i) && (this.os.name = "", (n = /PLAYSTATION 3;? ([0-9.]*)/.exec(e)) && (this.os.version = new T({
            value: n[1]
          })), this.device.manufacturer = "Sony", this.device.model = "Playstation 3", this.device.type = "gaming", this.device.identified = !0), e.match("Viera") && (this.os.name = "", this.device.manufacturer = "Panasonic", this.device.model = "Smart Viera", this.device.type = "television", this.device.identified = !0), (e.match("AQUOSBrowser") || e.match("AQUOS-AS")) && (this.os.name = "", this.device.manufacturer = "Sharp", this.device.model = "Aquos TV", this.device.type = "television", this.device.identified = !0), e.match("SMART-TV") && (this.os.name = "", this.device.manufacturer = t, this.device.model = "Smart TV", this.device.type = "television", this.device.identified = !0, (n = /Maple([0-9]*)/.exec(e)) && (this.device.model += " " + n[1])), e.match("SonyDTV|SonyBDP|SonyCEBrowser") && (this.os.name = "", this.device.manufacturer = "Sony", this.device.model = "Internet TV", this.device.type = "television", this.device.identified = !0), e.match("NETTV/") && (this.os.name = "", this.device.manufacturer = "Philips", this.device.model = "Net TV", this.device.type = "television", this.device.identified = !0), (n = /LG NetCast\.(?:TV|Media)-([0-9]*)/.exec(e)) && (this.os.name = "", this.device.manufacturer = o, this.device.model = "NetCast TV " + n[1], this.device.type = "television", this.device.identified = !0), (n = /LGSmartTV/.exec(e)) && (this.os.name = "", this.device.manufacturer = o, this.device.model = "Smart TV", this.device.type = "television", this.device.identified = !0), (e.match("Toshiba_?TP/") || e.match("TSBNetTV/")) && (this.os.name = "", this.device.manufacturer = "Toshiba", this.device.model = "Smart TV", this.device.type = "television", this.device.identified = !0), (n = /mbxtWebKit\/([0-9.]*)/.exec(e)) && (this.os.name = "", this.browser.name = "MachBlue XT", this.browser.version = new T({
            value: n[1],
            details: 2
          }), this.device.type = "television"), (n = /\(ADB; ([^\)]+)\)/.exec(e)) && (this.os.name = "", this.device.manufacturer = "ADB", this.device.model = ("Unknown" !== n[1] ? n[1].replace("ADB", "") + " " : "") + "IPTV receiver", this.device.type = "television", this.device.identified = !0), e.match(/Mstar;OWB/) && (this.os.name = "", this.device.manufacturer = "MStar", this.device.model = "PVR", this.device.type = "television", this.device.identified = !0, this.browser.name = "Origyn Web Browser"), (n = /\TechniSat ([^;]+);/.exec(e)) && (this.os.name = "", this.device.manufacturer = "TechniSat", this.device.model = n[1], this.device.type = "television", this.device.identified = !0), (n = /\Technicolor_([^;]+);/.exec(e)) && (this.os.name = "", this.device.manufacturer = "Technicolor", this.device.model = n[1], this.device.type = "television", this.device.identified = !0), (n = /Winbox Evo2/.exec(e)) && (this.os.name = "", this.device.manufacturer = "Winbox", this.device.model = "Evo2", this.device.type = "television", this.device.identified = !0), n = /^Roku\/DVP-([0-9]+)/.exec(e)) {
            switch (this.device.manufacturer = "Roku", this.device.type = "television", n[1]) {
              case "2000":
                this.device.model = "HD";
                break;
              case "2050":
                this.device.model = "XD";
                break;
              case "2100":
                this.device.model = "XDS";
                break;
              case "2400":
                this.device.model = "LT";
                break;
              case "3000":
                this.device.model = "2 HD";
                break;
              case "3050":
                this.device.model = "2 XD";
                break;
              case "3100":
                this.device.model = "2 XS";
            }
            this.device.identified = !0;
          }
          if (n = /HbbTV\/1.1.1 \([^;]*;\s*([^;]*)\s*;\s*([^;]*)\s*;/.exec(e)) {
            var g = n[1].trim(),
              y = n[2].trim();
            if (!this.device.manufacturer && "" !== g && "vendorName" !== g) {
              switch (g) {
                case "LGE":
                  this.device.manufacturer = "LG";
                  break;
                case "TOSHIBA":
                  this.device.manufacturer = "Toshiba";
                  break;
                case "smart":
                  this.device.manufacturer = "Smart";
                  break;
                case "tv2n":
                  this.device.manufacturer = "TV2N";
                  break;
                default:
                  this.device.manufacturer = g;
              }
              if (!this.device.model && "" !== y && "modelName" !== y) {
                switch (y) {
                  case "GLOBAL_PLAT3":
                    this.device.model = "NetCast TV";
                    break;
                  case "SmartTV2012":
                    this.device.model = "Smart TV 2012";
                    break;
                  case "videoweb":
                    this.device.model = "Videoweb";
                    break;
                  default:
                    this.device.model = y;
                }
                "Humax" === g && (this.device.model = this.device.model.toUpperCase()), this.device.identified = !0, this.os.name = "";
              }
            }
            this.device.type = "television";
          }
          if (e.match("InettvBrowser") && (this.device.type = "television"), e.match("MIDP") && (this.device.type = "mobile"), !this.device.model && !this.device.manufacturer) {
            var C = [];
            e.match(/^(Mozilla|Opera)/) || (n = /^(?:MQQBrowser\/[0-9\.]+\/)?([^\s]+)/.exec(e)) && (n[1] = n[1].replace(/_TD$/, ""), n[1] = n[1].replace(/_CMCC$/, ""), n[1] = n[1].replace(/[_ ]Mozilla$/, ""), n[1] = n[1].replace(/ Linux$/, ""), n[1] = n[1].replace(/ Opera$/, ""), n[1] = n[1].replace(/\/[0-9].*$/, ""), C.push(n[1])), (n = /[0-9]+x[0-9]+; ([^;]+)/.exec(e)) && C.push(n[1]), (n = /[0-9]+X[0-9]+ ([^;\/\(\)]+)/.exec(e)) && C.push(n[1]), (n = /Windows NT 5.1; ([^;]+); Windows Phone/.exec(e)) && C.push(n[1]), (n = /\) PPC; (?:[0-9]+x[0-9]+; )?([^;\/\(\)]+)/.exec(e)) && C.push(n[1]), (n = /\(([^;]+); U; Windows Mobile/.exec(e)) && C.push(n[1]), (n = /Vodafone\/1.0\/([^\/]+)/.exec(e)) && C.push(n[1]), (n = /\ ([^\s]+)$/.exec(e)) && C.push(n[1]);
            for (var G = 0; G < C.length; G++) {
              if (!this.device.model && !this.device.manufacturer) {
                v = f(C[G]);
                var H = !1;
                "Android" === this.os.name && void 0 !== S[v] && (this.device.manufacturer = S[v][0], this.device.model = S[v][1], void 0 !== S[v][2] && (this.device.type = S[v][2]), this.device.identified = !0, H = !0), this.os.name && "Windows" !== this.os.name && "Windows Mobile" !== this.os.name && "Windows CE" !== this.os.name || void 0 !== h[v] && (this.device.manufacturer = h[v][0], this.device.model = h[v][1], this.device.type = "mobile", this.device.identified = !0, "Windows Mobile" !== this.os.name && (this.os.name = "Windows Mobile", this.os.version = null), H = !0);
              }
              if (!H && ((n = /^GIONEE-([^\s]+)/.exec(C[G])) && (this.device.manufacturer = "Gionee", this.device.model = f(n[1]), this.device.type = "mobile", this.device.identified = !0), (n = /^HTC_?([^\/_]+)(?:\/|_|$)/.exec(C[G])) && (this.device.manufacturer = r, this.device.model = f(n[1]), this.device.type = "mobile", this.device.identified = !0), (n = /^HUAWEI-([^\/]*)/.exec(C[G])) && (this.device.manufacturer = "Huawei", this.device.model = f(n[1]), this.device.type = "mobile", this.device.identified = !0), (n = /(?:^|\()LGE?(?:\/|-|_|\s)([^\s]*)/.exec(C[G])) && (this.device.manufacturer = o, this.device.model = f(n[1]), this.device.type = "mobile", this.device.identified = !0), (n = /^MOT-([^\/_]+)(?:\/|_|$)/.exec(C[G])) && (this.device.manufacturer = a, this.device.model = f(n[1]), this.device.type = "mobile", this.device.identified = !0), (n = /^Motorola_([^\/_]+)(?:\/|_|$)/.exec(C[G])) && (this.device.manufacturer = a, this.device.model = f(n[1]), this.device.type = "mobile", this.device.identified = !0), (n = /^Nokia([^\/]+)(?:\/|$)/.exec(C[G])) && (this.device.manufacturer = "Nokia", this.device.model = f(n[1]), this.device.type = "mobile", this.device.identified = !0, this.os.name || (this.os.name = "Series40")), (n = /^SonyEricsson([^\/_]+)(?:\/|_|$)/.exec(C[G])) && (this.device.manufacturer = i, this.device.model = f(n[1]), this.device.type = "mobile", this.device.identified = !0), n = /^SAMSUNG-([^\/_]+)(?:\/|_|$)/.exec(C[G]))) if (this.device.manufacturer = t, this.device.model = f(n[1]), this.device.type = "mobile", "Bada" === this.os.name) {
                s = "SAMSUNG", v = f(this.device.model);
                void 0 !== l[s] && void 0 !== l[s][v] && (this.device.manufacturer = l[s][v][0], this.device.model = l[s][v][1], this.device.identified = !0);
              } else if (n = /Jasmine\/([0-9.]*)/.exec(e)) {
                var w = n[1];
                s = "SAMSUNG", v = f(this.device.model);
                void 0 !== c[s] && void 0 !== c[s][v] && (this.device.manufacturer = c[s][v][0], this.device.model = c[s][v][1], this.device.identified = !0, this.os.name = "Touchwiz", this.os.version = new T({
                  value: "2.0"
                }));
              } else if (n = /Dolfin\/([0-9.]*)/.exec(e)) {
                var w = n[1];
                s = "SAMSUNG", v = f(this.device.model);
                if (void 0 !== l[s] && void 0 !== l[s][v]) switch (this.device.manufacturer = l[s][v][0], this.device.model = l[s][v][1], this.device.identified = !0, this.os.name = "Bada", w) {
                  case "2.0":
                    this.os.version = new T({
                      value: "1.0"
                    });
                    break;
                  case "2.2":
                    this.os.version = new T({
                      value: "1.2"
                    });
                    break;
                  case "3.0":
                    this.os.version = new T({
                      value: "2.0"
                    });
                }
                if (void 0 !== c[s] && void 0 !== c[s][v]) switch (this.device.manufacturer = c[s][v][0], this.device.model = c[s][v][1], this.device.identified = !0, this.os.name = "Touchwiz", w) {
                  case "1.0":
                    this.os.version = new T({
                      value: "1.0"
                    });
                    break;
                  case "1.5":
                    this.os.version = new T({
                      value: "2.0"
                    });
                    break;
                  case "2.0":
                    this.os.version = new T({
                      value: "3.0"
                    });
                }
              }
            }
          }
          if ((n = /\((?:LG[-|\/])(.*) (?:Browser\/)?AppleWebkit/.exec(e)) && (this.device.manufacturer = o, this.device.model = n[1], this.device.type = "mobile", this.device.identified = !0), (n = /^Mozilla\/5.0 \((?:Nokia|NOKIA)(?:\s?)([^\)]+)\)UC AppleWebkit\(like Gecko\) Safari\/530$/.exec(e)) && (this.device.manufacturer = "Nokia", this.device.model = n[1], this.device.type = "mobile", this.device.identified = !0, this.os.name = "Series60"), e.match("Safari") && ("iOS" === this.os.name && (this.browser.stock = !0, this.browser.hidden = !0, this.browser.name = "Safari", this.browser.version = null), "Mac OS X" !== this.os.name && "Windows" !== this.os.name || (this.browser.name = "Safari", this.browser.stock = "Mac OS X" === this.os.name, (n = /Version\/([0-9\.]+)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          })), e.match(/AppleWebKit\/[0-9\.]+\+/) && (this.browser.name = "WebKit Nightly Build", this.browser.version = null))), e.match("MSIE") && (this.browser.name = "Internet Explorer", (e.match("IEMobile") || e.match("Windows CE") || e.match("Windows Phone") || e.match("WP7")) && (this.browser.name = "Mobile Internet Explorer"), (n = /MSIE ([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), e.match(/Opera/i) && (this.browser.stock = !1, this.browser.name = "Opera", (n = /Opera[\/| ]([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          })), (n = /Version\/([0-9.]*)/.exec(e)) && (parseFloat(n[1]) >= 10 ? this.browser.version = new T({
            value: n[1]
          }) : this.browser.version = null), this.browser.version && e.match("Edition Labs") && (this.browser.version.type = "alpha", this.browser.channel = "Labs"), this.browser.version && e.match("Edition Next") && (this.browser.version.type = "alpha", this.browser.channel = "Next"), e.match("Opera Tablet") && (this.browser.name = "Opera Mobile", this.device.type = "tablet"), e.match("Opera Mobi") && (this.browser.name = "Opera Mobile", this.device.type = "mobile"), (n = /Opera Mini;/.exec(e)) && (this.browser.name = "Opera Mini", this.browser.version = null, this.browser.mode = "proxy", this.device.type = "mobile"), (n = /Opera Mini\/(?:att\/)?([0-9.]*)/.exec(e)) && (this.browser.name = "Opera Mini", this.browser.version = new T({
            value: n[1],
            details: -1
          }), this.browser.mode = "proxy", this.device.type = "mobile"), "Opera" === this.browser.name && "mobile" === this.device.type && (this.browser.name = "Opera Mobile", e.match(/BER/) && (this.browser.name = "Opera Mini", this.browser.version = null)), e.match("InettvBrowser") && (this.device.type = "television"), (e.match("Opera TV") || e.match("Opera-TV")) && (this.browser.name = "Opera", this.device.type = "television"), e.match("Linux zbov") && (this.browser.name = "Opera Mobile", this.browser.mode = "desktop", this.device.type = "mobile", this.os.name = null, this.os.version = null), e.match("Linux zvav") && (this.browser.name = "Opera Mini", this.browser.version = null, this.browser.mode = "desktop", this.device.type = "mobile", this.os.name = null, this.os.version = null)), e.match("Firefox") && (this.browser.stock = !1, this.browser.name = "Firefox", (n = /Firefox\/([0-9ab.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          })), "alpha" === this.browser.version.type && (this.browser.channel = "Aurora"), "beta" === this.browser.version.type && (this.browser.channel = "Beta"), e.match("Fennec") && (this.device.type = "mobile"), e.match("Mobile; rv") && (this.device.type = "mobile"), e.match("Tablet; rv") && (this.device.type = "tablet"), "mobile" !== this.device.type && "tablet" !== this.device.type || (this.browser.name = "Firefox Mobile")), e.match("Namoroka") && (this.browser.stock = !1, this.browser.name = "Firefox", (n = /Namoroka\/([0-9ab.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          })), this.browser.channel = "Namoroka"), e.match("Shiretoko") && (this.browser.stock = !1, this.browser.name = "Firefox", (n = /Shiretoko\/([0-9ab.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          })), this.browser.channel = "Shiretoko"), e.match("Minefield") && (this.browser.stock = !1, this.browser.name = "Firefox", (n = /Minefield\/([0-9ab.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          })), this.browser.channel = "Minefield"), e.match("Firebird") && (this.browser.stock = !1, this.browser.name = "Firebird", (n = /Firebird\/([0-9ab.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), e.match("SeaMonkey") && (this.browser.stock = !1, this.browser.name = "SeaMonkey", (n = /SeaMonkey\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), e.match("Netscape") && (this.browser.stock = !1, this.browser.name = "Netscape", (n = /Netscape[0-9]?\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), e.match("[k|K]onqueror/") && (this.browser.name = "Konqueror", (n = /[k|K]onqueror\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), n = /(?:Chrome|CrMo|CriOS)\/([0-9.]*)/.exec(e)) if (this.browser.stock = !1, this.browser.name = "Chrome", this.browser.version = new T({
            value: n[1]
          }), "Android" === this.os.name) switch (n[1].split(".", 3).join(".")) {
            case "16.0.912":
              this.browser.channel = "Beta";
              break;
            case "18.0.1025":
              this.browser.version.details = 1;
              break;
            default:
              this.browser.channel = "Nightly";
          } else switch (n[1].split(".", 3).join(".")) {
            case "0.2.149":
            case "0.3.154":
            case "0.4.154":
            case "1.0.154":
            case "2.0.172":
            case "3.0.195":
            case "4.0.249":
            case "4.1.249":
            case "5.0.375":
            case "6.0.472":
            case "7.0.517":
            case "8.0.552":
            case "9.0.597":
            case "10.0.648":
            case "11.0.696":
            case "12.0.742":
            case "13.0.782":
            case "14.0.835":
            case "15.0.874":
            case "16.0.912":
            case "17.0.963":
            case "18.0.1025":
            case "19.0.1084":
            case "20.0.1132":
            case "21.0.1180":
              0 === this.browser.version.minor ? this.browser.version.details = 1 : this.browser.version.details = 2;
              break;
            default:
              this.browser.channel = "Nightly";
          }
          if (e.match("chromeframe") && (this.browser.stock = !1, this.browser.name = "Chrome Frame", (n = /chromeframe\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), e.match("Chromium") && (this.browser.stock = !1, this.browser.channel = "", this.browser.name = "Chromium", (n = /Chromium\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), e.match("BrowserNG") && (this.browser.name = "Nokia Browser", (n = /BrowserNG\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1],
            details: 3,
            builds: !1
          }))), e.match("NokiaBrowser") && (this.browser.name = "Nokia Browser", (n = /NokiaBrowser\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1],
            details: 3
          }))), e.match("Maemo[ |_]Browser") && (this.browser.name = "MicroB", (n = /Maemo[ |_]Browser[ |_]([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1],
            details: 3
          }))), e.match("NetFront") && (this.browser.name = "NetFront", this.device.type = "mobile", (n = /NetFront\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          })), e.match("InettvBrowser") && (this.device.type = "television")), e.match("Silk") && e.match("Silk-Accelerated") && (this.browser.name = "Silk", (n = /Silk\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1],
            details: 2
          })), this.device.manufacturer = "Amazon", this.device.model = "Kindle Fire", this.device.type = "tablet", this.device.identified = !0, "Android" !== this.os.name && (this.os.name = "Android", this.os.version = null)), e.match("Dolfin") && (this.browser.name = "Dolfin", (n = /Dolfin\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), e.match("Iris") && (this.browser.name = "Iris", this.device.type = "mobile", this.device.model = null, this.device.manufacturer = null, this.os.name = "Windows Mobile", this.os.version = null, (n = /Iris\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          })), (n = / WM([0-9]) /.exec(e)) ? this.os.version = new T({
            value: n[1] + ".0"
          }) : this.browser.mode = "desktop"), e.match("Jasmine") && (this.browser.name = "Jasmine", (n = /Jasmine\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), e.match("Boxee") && (this.browser.name = "Boxee", this.device.type = "television", (n = /Boxee\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), e.match("Espial") && (this.browser.name = "Espial", this.os.name = "", this.os.version = null, "television" !== this.device.type && (this.device.type = "television", this.device.model = null, this.device.manufacturer = null), (n = /Espial\/([0-9.]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1]
          }))), (n = /ANTGalio\/([0-9.]*)/.exec(e)) && (this.browser.name = "ANT Galio", this.browser.version = new T({
            value: n[1],
            details: 3
          }), this.device.type = "television"), (n = /NX\/([0-9.]*)/.exec(e)) && (this.browser.name = "NetFront NX", this.browser.version = new T({
            value: n[1],
            details: 2
          }), (n = /DTV/i.exec(e)) ? this.device.type = "television" : (n = /mobile/i.exec(e)) ? this.device.type = "mobile" : this.device.type = "desktop", this.os.name = null, this.os.version = null), e.match(/Obigo/i) && (this.browser.name = "Obigo", (n = /Obigo\/([0-9.]*)/i.exec(e)) && (this.browser.version = new T({
            value: n[1]
          })), (n = /Obigo\/([A-Z])([0-9.]*)/i.exec(e)) && (this.browser.name = "Obigo " + n[1], this.browser.version = new T({
            value: n[2]
          })), (n = /Obigo-([A-Z])([0-9.]*)\//i.exec(e)) && (this.browser.name = "Obigo " + n[1], this.browser.version = new T({
            value: n[2]
          }))), e.match("UCWEB") && (this.browser.stock = !1, this.browser.name = "UC Browser", (n = /UCWEB([0-9]*[.][0-9]*)/.exec(e)) && (this.browser.version = new T({
            value: n[1],
            details: 3
          })), "Linux" === this.os.name && (this.os.name = ""), this.device.type = "mobile", (n = /^IUC \(U;\s?iOS ([0-9\.]+);/.exec(e)) && (this.os.name = "iOS", this.os.version = new T({
            value: n[1]
          })), n = /^JUC \(Linux; U; ([0-9\.]+)[^;]*; [^;]+; ([^;]*[^\s])\s*; [0-9]+\*[0-9]+\)/.exec(e))) {
            v = f(n[2]);
            this.os.name = "Android", this.os.version = new T({
              value: n[1]
            }), void 0 !== S[v] && (this.device.manufacturer = S[v][0], this.device.model = S[v][1], void 0 !== S[v][2] && (this.device.type = S[v][2]), this.device.identified = !0);
          }
          (e.match(/\) UC /) && (this.browser.stock = !1, this.browser.name = "UC Browser"), (n = /UCBrowser\/([0-9.]*)/.exec(e)) && (this.browser.stock = !1, this.browser.name = "UC Browser", this.browser.version = new T({
            value: n[1],
            details: 2
          })), (n = /Ninesky(?:-android-mobile(?:-cn)?)?\/([0-9.]*)/.exec(e)) && (this.browser.name = "NineSky", this.browser.version = new T({
            value: n[1]
          }), "Android" !== this.os.name && (this.os.name = "Android", this.os.version = null, this.device.manufacturer = null, this.device.model = null)), (n = /Skyfire\/([0-9.]*)/.exec(e)) && (this.browser.name = "Skyfire", this.browser.version = new T({
            value: n[1]
          }), this.device.type = "mobile", this.os.name = "Android", this.os.version = null), (n = /DolphinHDCN\/([0-9.]*)/.exec(e)) && (this.browser.name = "Dolphin", this.browser.version = new T({
            value: n[1]
          }), this.device.type = "mobile", "Android" !== this.os.name && (this.os.name = "Android", this.os.version = null)), (n = /Dolphin\/INT/.exec(e)) && (this.browser.name = "Dolphin", this.device.type = "mobile"), n = /(M?QQBrowser)\/([0-9.]*)/.exec(e)) && (this.browser.name = "QQ Browser", (w = n[2]).match(/^[0-9][0-9]$/) && (w = w[0] + "." + w[1]), this.browser.version = new T({
            value: w,
            details: 2
          }), this.browser.channel = "", this.os.name || "QQBrowser" !== n[1] || (this.os.name = "Windows"));
          (n = /(iBrowser)\/([0-9.]*)/.exec(e)) && (this.browser.name = "iBrowser", (w = n[2]).match(/[0-9][0-9]/) && (w = w[0] + "." + w[1]), this.browser.version = new T({
            value: w,
            details: 2
          }), this.browser.channel = "");
          (n = /Puffin\/([0-9.]*)/.exec(e)) && (this.browser.name = "Puffin", this.browser.version = new T({
            value: n[1],
            details: 2
          }), this.device.type = "mobile", "Linux" === this.os.name && (this.os.name = null, this.os.version = null)), e.match("360EE") && (this.browser.stock = !1, this.browser.name = "360 Extreme Explorer", this.browser.version = null), (n = /Midori\/([0-9.]*)/.exec(e)) && (this.browser.name = "Midori", this.browser.version = new T({
            value: n[1]
          }), "Linux" !== this.os.name && (this.os.name = "Linux", this.os.version = null), this.device.manufacturer = null, this.device.model = null, this.device.type = "desktop");
          for (var A = [{
              name: "AdobeAIR",
              regexp: /AdobeAIR\/([0-9.]*)/
            }, {
              name: "Awesomium",
              regexp: /Awesomium\/([0-9.]*)/
            }, {
              name: "Canvace",
              regexp: /Canvace Standalone\/([0-9.]*)/
            }, {
              name: "Ekioh",
              regexp: /Ekioh\/([0-9.]*)/
            }, {
              name: "JavaFX",
              regexp: /JavaFX\/([0-9.]*)/
            }, {
              name: "GFXe",
              regexp: /GFXe\/([0-9.]*)/
            }, {
              name: "LuaKit",
              regexp: /luakit/
            }, {
              name: "Titanium",
              regexp: /Titanium\/([0-9.]*)/
            }, {
              name: "OpenWebKitSharp",
              regexp: /OpenWebKitSharp/
            }, {
              name: "Prism",
              regexp: /Prism\/([0-9.]*)/
            }, {
              name: "Qt",
              regexp: /Qt\/([0-9.]*)/
            }, {
              name: "QtEmbedded",
              regexp: /QtEmbedded/
            }, {
              name: "QtEmbedded",
              regexp: /QtEmbedded.*Qt\/([0-9.]*)/
            }, {
              name: "RhoSimulator",
              regexp: /RhoSimulator/
            }, {
              name: "UWebKit",
              regexp: /UWebKit\/([0-9.]*)/
            }, {
              name: "PhantomJS",
              regexp: /PhantomJS\/([0-9.]*)/
            }, {
              name: "Google Web Preview",
              regexp: /Google Web Preview/
            }, {
              name: "Google Earth",
              regexp: /Google Earth\/([0-9.]*)/
            }, {
              name: "EA Origin",
              regexp: /Origin\/([0-9.]*)/
            }, {
              name: "SecondLife",
              regexp: /SecondLife\/([0-9.]*)/
            }, {
              name: "Valve Steam",
              regexp: /Valve Steam/
            }, {
              name: "Songbird",
              regexp: /Songbird\/([0-9.]*)/
            }, {
              name: "Thunderbird",
              regexp: /Thunderbird\/([0-9.]*)/
            }, {
              name: "Abrowser",
              regexp: /Abrowser\/([0-9.]*)/
            }, {
              name: "arora",
              regexp: /[Aa]rora\/([0-9.]*)/
            }, {
              name: "Baidu Browser",
              regexp: /M?BaiduBrowser\/([0-9.]*)/i
            }, {
              name: "Camino",
              regexp: /Camino\/([0-9.]*)/
            }, {
              name: "Canure",
              regexp: /Canure\/([0-9.]*)/,
              details: 3
            }, {
              name: "CometBird",
              regexp: /CometBird\/([0-9.]*)/
            }, {
              name: "Comodo Dragon",
              regexp: /Comodo_Dragon\/([0-9.]*)/,
              details: 2
            }, {
              name: "Conkeror",
              regexp: /[Cc]onkeror\/([0-9.]*)/
            }, {
              name: "CoolNovo",
              regexp: /(?:CoolNovo|CoolNovoChromePlus)\/([0-9.]*)/,
              details: 3
            }, {
              name: "ChromePlus",
              regexp: /ChromePlus(?:\/([0-9.]*))?$/,
              details: 3
            }, {
              name: "Daedalus",
              regexp: /Daedalus ([0-9.]*)/,
              details: 2
            }, {
              name: "Demobrowser",
              regexp: /demobrowser\/([0-9.]*)/
            }, {
              name: "Dooble",
              regexp: /Dooble(?:\/([0-9.]*))?/
            }, {
              name: "DWB",
              regexp: /dwb(?:-hg)?(?:\/([0-9.]*))?/
            }, {
              name: "Epiphany",
              regexp: /Epiphany\/([0-9.]*)/
            }, {
              name: "FireWeb",
              regexp: /FireWeb\/([0-9.]*)/
            }, {
              name: "Flock",
              regexp: /Flock\/([0-9.]*)/,
              details: 3
            }, {
              name: "Galeon",
              regexp: /Galeon\/([0-9.]*)/,
              details: 3
            }, {
              name: "Helium",
              regexp: /HeliumMobileBrowser\/([0-9.]*)/
            }, {
              name: "iCab",
              regexp: /iCab\/([0-9.]*)/
            }, {
              name: "Iceape",
              regexp: /Iceape\/([0-9.]*)/
            }, {
              name: "IceCat",
              regexp: /IceCat ([0-9.]*)/
            }, {
              name: "Iceweasel",
              regexp: /Iceweasel\/([0-9.]*)/
            }, {
              name: "InternetSurfboard",
              regexp: /InternetSurfboard\/([0-9.]*)/
            }, {
              name: "Iron",
              regexp: /Iron\/([0-9.]*)/,
              details: 2
            }, {
              name: "Isis",
              regexp: /BrowserServer/
            }, {
              name: "Jumanji",
              regexp: /jumanji/
            }, {
              name: "Kazehakase",
              regexp: /Kazehakase\/([0-9.]*)/
            }, {
              name: "KChrome",
              regexp: /KChrome\/([0-9.]*)/,
              details: 3
            }, {
              name: "K-Meleon",
              regexp: /K-Meleon\/([0-9.]*)/
            }, {
              name: "Leechcraft",
              regexp: /Leechcraft(?:\/([0-9.]*))?/,
              details: 2
            }, {
              name: "Lightning",
              regexp: /Lightning\/([0-9.]*)/
            }, {
              name: "Lunascape",
              regexp: /Lunascape[\/| ]([0-9.]*)/,
              details: 3
            }, {
              name: "iLunascape",
              regexp: /iLunascape\/([0-9.]*)/,
              details: 3
            }, {
              name: "Maxthon",
              regexp: /Maxthon[\/ ]([0-9.]*)/,
              details: 3
            }, {
              name: "MiniBrowser",
              regexp: /MiniBr?owserM\/([0-9.]*)/
            }, {
              name: "MiniBrowser",
              regexp: /MiniBrowserMobile\/([0-9.]*)/
            }, {
              name: "MixShark",
              regexp: /MixShark\/([0-9.]*)/
            }, {
              name: "Motorola WebKit",
              regexp: /MotorolaWebKit\/([0-9.]*)/,
              details: 3
            }, {
              name: "NetFront LifeBrowser",
              regexp: /NetFrontLifeBrowser\/([0-9.]*)/
            }, {
              name: "Netscape Navigator",
              regexp: /Navigator\/([0-9.]*)/,
              details: 3
            }, {
              name: "Odyssey",
              regexp: /OWB\/([0-9.]*)/
            }, {
              name: "OmniWeb",
              regexp: /OmniWeb/
            }, {
              name: "Orca",
              regexp: /Orca\/([0-9.]*)/
            }, {
              name: "Origyn",
              regexp: /Origyn Web Browser/
            }, {
              name: "Palemoon",
              regexp: /Pale[mM]oon\/([0-9.]*)/
            }, {
              name: "Phantom",
              regexp: /Phantom\/V([0-9.]*)/
            }, {
              name: "Polaris",
              regexp: /Polaris\/v?([0-9.]*)/i,
              details: 2
            }, {
              name: "QtCreator",
              regexp: /QtCreator\/([0-9.]*)/
            }, {
              name: "QtQmlViewer",
              regexp: /QtQmlViewer/
            }, {
              name: "QtTestBrowser",
              regexp: /QtTestBrowser\/([0-9.]*)/
            }, {
              name: "QtWeb",
              regexp: /QtWeb Internet Browser\/([0-9.]*)/
            }, {
              name: "QupZilla",
              regexp: /QupZilla\/([0-9.]*)/
            }, {
              name: "Roccat",
              regexp: /Roccat\/([0-9]\.[0-9.]*)/
            }, {
              name: "Raven for Mac",
              regexp: /Raven for Mac\/([0-9.]*)/
            }, {
              name: "rekonq",
              regexp: /rekonq/
            }, {
              name: "RockMelt",
              regexp: /RockMelt\/([0-9.]*)/,
              details: 2
            }, {
              name: "Sleipnir",
              regexp: /Sleipnir\/([0-9.]*)/,
              details: 3
            }, {
              name: "SMBrowser",
              regexp: /SMBrowser/
            }, {
              name: "Sogou Explorer",
              regexp: /SE 2.X MetaSr/
            }, {
              name: "Snowshoe",
              regexp: /Snowshoe\/([0-9.]*)/,
              details: 2
            }, {
              name: "Sputnik",
              regexp: /Sputnik\/([0-9.]*)/i,
              details: 3
            }, {
              name: "Stainless",
              regexp: /Stainless\/([0-9.]*)/
            }, {
              name: "SunChrome",
              regexp: /SunChrome\/([0-9.]*)/
            }, {
              name: "Surf",
              regexp: /Surf\/([0-9.]*)/
            }, {
              name: "TaoBrowser",
              regexp: /TaoBrowser\/([0-9.]*)/,
              details: 2
            }, {
              name: "TaomeeBrowser",
              regexp: /TaomeeBrowser\/([0-9.]*)/,
              details: 2
            }, {
              name: "TazWeb",
              regexp: /TazWeb/
            }, {
              name: "Viera",
              regexp: /Viera\/([0-9.]*)/
            }, {
              name: "Villanova",
              regexp: /Villanova\/([0-9.]*)/,
              details: 3
            }, {
              name: "Wavelink Velocity",
              regexp: /Wavelink Velocity Browser\/([0-9.]*)/,
              details: 2
            }, {
              name: "WebPositive",
              regexp: /WebPositive/
            }, {
              name: "WebRender",
              regexp: /WebRender/
            }, {
              name: "Wyzo",
              regexp: /Wyzo\/([0-9.]*)/,
              details: 3
            }, {
              name: "Zetakey",
              regexp: /Zetakey Webkit\/([0-9.]*)/
            }, {
              name: "Zetakey",
              regexp: /Zetakey\/([0-9.]*)/
            }], M = 0; M < A.length; M++) {
            (n = A[M].regexp.exec(e)) && (this.browser.name = A[M].name, this.browser.channel = "", this.browser.stock = !1, n[1] ? this.browser.version = new T({
              value: n[1],
              details: A[M].details || null
            }) : this.browser.version = null);
          }
          if ((n = /WebKit\/([0-9.]*)/i.exec(e)) && (this.engine.name = "Webkit", this.engine.version = new T({
            value: n[1]
          })), (n = /Browser\/AppleWebKit([0-9.]*)/i.exec(e)) && (this.engine.name = "Webkit", this.engine.version = new T({
            value: n[1]
          })), (n = /KHTML\/([0-9.]*)/.exec(e)) && (this.engine.name = "KHTML", this.engine.version = new T({
            value: n[1]
          })), /Gecko/.exec(e) && !/like Gecko/i.exec(e) && (this.engine.name = "Gecko", (n = /; rv:([^\)]+)\)/.exec(e)) && (this.engine.version = new T({
            value: n[1]
          }))), (n = /Presto\/([0-9.]*)/.exec(e)) && (this.engine.name = "Presto", this.engine.version = new T({
            value: n[1]
          })), (n = /Trident\/([0-9.]*)/.exec(e)) && (this.engine.name = "Trident", this.engine.version = new T({
            value: n[1]
          }), "Internet Explorer" === this.browser.name && (6 === b(this.engine.version) && parseFloat(this.browser.version) < 10 && (this.browser.version = new T({
            value: "10.0"
          }), this.browser.mode = "compat"), 5 === b(this.engine.version) && parseFloat(this.browser.version) < 9 && (this.browser.version = new T({
            value: "9.0"
          }), this.browser.mode = "compat"), 4 === b(this.engine.version) && parseFloat(this.browser.version) < 8 && (this.browser.version = new T({
            value: "8.0"
          }), this.browser.mode = "compat")), "Windows Phone" === this.os.name && 5 === b(this.engine.version) && parseFloat(this.os.version) < 7.5 && (this.os.version = new T({
            value: "7.5"
          }))), "Android" === this.os.name && this.browser.stock && (this.browser.hidden = !0), "iOS" === this.os.name && "Opera Mini" === this.browser.name && (this.os.version = null), "Midori" === this.browser.name && "Webkit" !== this.engine.name && (this.engine.name = "Webkit", this.engine.version = null), "television" === this.device.type && "Opera" === this.browser.name) {
            switch (this.browser.name = "Opera Devices", !0) {
              case this.engine.version.is("2.10"):
                this.browser.version = new T({
                  value: 3.2
                });
                break;
              case this.engine.version.is("2.9"):
                this.browser.version = new T({
                  value: 3.1
                });
                break;
              case this.engine.version.is("2.8"):
                this.browser.version = new T({
                  value: 3
                });
                break;
              case this.engine.version.is("2.7"):
                this.browser.version = new T({
                  value: 2.9
                });
                break;
              case this.engine.version.is("2.6"):
                this.browser.version = new T({
                  value: 2.8
                });
                break;
              case this.engine.version.is("2.4"):
                this.browser.version = new T({
                  value: 10.3
                });
                break;
              case this.engine.version.is("2.3"):
                this.browser.version = new T({
                  value: 10
                });
                break;
              case this.engine.version.is("2.2"):
                this.browser.version = new T({
                  value: 9.7
                });
                break;
              case this.engine.version.is("2.1"):
                this.browser.version = new T({
                  value: 9.6
                });
                break;
              default:
                this.browser.version = null;
            }
            this.os.name = null, this.os.version = null;
          }
          if (this.options.detectCamouflage) {
            if (n = /Mac OS X 10_6_3; ([^;]+); [a-z]{2}-(?:[a-z]{2})?\)/.exec(e)) {
              this.browser.name = "", this.browser.version = null, this.browser.mode = "desktop", this.os.name = "Android", this.os.version = null, this.engine.name = "Webkit", this.engine.version = null, this.device.model = n[1], this.device.type = "mobile";
              v = f(this.device.model);
              void 0 !== S[v] && (this.device.manufacturer = S[v][0], this.device.model = S[v][1], void 0 !== S[v][2] && (this.device.type = S[v][2]), this.device.identified = !0), this.features.push("foundDevice");
            }
            if (n = /Linux Ventana; [a-z]{2}-[a-z]{2}; (.+) Build/.exec(e)) {
              this.browser.name = "", this.browser.version = null, this.browser.mode = "desktop", this.os.name = "Android", this.os.version = null, this.engine.name = "Webkit", this.engine.version = null, this.device.model = n[1], this.device.type = "mobile";
              v = f(this.device.model);
              void 0 !== S[v] && (this.device.manufacturer = S[v][0], this.device.model = S[v][1], void 0 !== S[v][2] && (this.device.type = S[v][2]), this.device.identified = !0), this.features.push("foundDevice");
            }
            "Safari" === this.browser.name && ("iOS" !== this.os.name && /AppleWebKit\/([0-9]+.[0-9]+)/i.exec(e)[1] !== /Safari\/([0-9]+.[0-9]+)/i.exec(e)[1] && (this.features.push("safariMismatch"), this.camouflage = !0), "iOS" !== this.os.name || e.match(/^Mozilla/) || (this.features.push("noMozillaPrefix"), this.camouflage = !0), /Version\/[0-9\.]+/.exec(e) || (this.features.push("noVersion"), this.camouflage = !0)), "Chrome" === this.browser.name && (/(?:Chrome|CrMo|CriOS)\/([0-9]{1,2}\.[0-9]\.[0-9]{3,4}\.[0-9]+)/.exec(e) || (this.features.push("wrongVersion"), this.camouflage = !0)), this.options.useFeatures && (window.ActiveXObject && (this.features.push("trident"), void 0 !== this.engine.name && "Trident" !== this.engine.name && (this.camouflage = void 0 === this.browser.name || "Maxthon" !== this.browser.name)), window.opera && (this.features.push("presto"), void 0 !== this.engine.name && "Presto" !== this.engine.name && (this.camouflage = !0), "Internet Explorer" === this.browser.name && (this.camouflage = !0)), ("getBoxObjectFor" in document || "mozInnerScreenX" in window) && (this.features.push("gecko"), void 0 !== this.engine.name && "Gecko" !== this.engine.name && (this.camouflage = !0), "Internet Explorer" === this.browser.name && (this.camouflage = !0)), ("WebKitCSSMatrix" in window || "WebKitPoint" in window || "webkitStorageInfo" in window || "webkitURL" in window) && (this.features.push("webkit"), void 0 !== this.engine.name && "Webkit" !== this.engine.name && (this.camouflage = !0), "Internet Explorer" === this.browser.name && (this.camouflage = !0)), "Webkit" === this.engine.name && -1 === {}.toString.toString().indexOf("\n") && (this.features.push("v8"), null !== this.browser && "Safari" === this.browser.name && (this.camouflage = !0)), "iPad" === this.device.model && 0 !== screen.width && 0 !== screen.height && 768 !== screen.width && 1024 !== screen.height && 1024 !== screen.width && 768 !== screen.height && (this.features.push("sizeMismatch"), this.camouflage = !0), "iPhone" !== this.device.model && "iPod" !== this.device.model || 0 !== screen.width && 0 !== screen.height && 320 !== screen.width && 480 !== screen.height && 480 !== screen.width && 320 !== screen.height && (this.features.push("sizeMismatch"), this.camouflage = !0), "iOS" === this.os.name && this.os.version && (this.os.version.isOlder("4.0") && "sandbox" in document.createElement("iframe") && (this.features.push("foundSandbox"), this.camouflage = !0), this.os.version.isOlder("4.2") && "WebSocket" in window && (this.features.push("foundSockets"), this.camouflage = !0), this.os.version.isOlder("5.0") && window.Worker && (this.features.push("foundWorker"), this.camouflage = !0), this.os.version.isNewer("2.1") && !window.applicationCache && (this.features.push("noAppCache"), this.camouflage = !0)), "iOS" !== this.os.name && "Safari" === this.browser.name && this.browser.version && (this.browser.version.isOlder("4.0") && window.applicationCache && (this.features.push("foundAppCache"), this.camouflage = !0), this.browser.version.isOlder("4.1") && window.history && history.pushState && (this.features.push("foundHistory"), this.camouflage = !0), this.browser.version.isOlder("5.1") && document.documentElement.webkitRequestFullScreen && (this.features.push("foundFullscreen"), this.camouflage = !0), this.browser.version.isOlder("5.2") && "FileReader" in window && (this.features.push("foundFileReader"), this.camouflage = !0)));
          }
        }
      }, v;
    }(),
    or = function or(e) {
      var t,
        i,
        a = new ar(e);
      if ("mobile" === a.device.type || "tablet" === a.device.type) {
        if ((t = e.match(/(ZTE|Samsung|Motorola|HTC|Coolpad|Huawei|Lenovo|LG|Sony Ericsson|Oppo|TCL|Vivo|Sony|Meizu|Nokia)/i)) && (a.device.manufacturer = t[1], a.device.model && a.device.model.indexOf(t[1]) >= 0 && (a.device.model = a.device.model.replace(t[1], ""))), t = e.match(/(iPod|iPad|iPhone)/i)) a.device.manufacturer = "Apple", a.device.model = t[1];else if (t = e.match(/[-\s](Galaxy[\s-_]nexus|Galaxy[\s-_]\w*[\s-_]\w*|Galaxy[\s-_]\w*|SM-\w*|GT-\w*|s[cgp]h-\w*|shw-\w*|ATIV|i9070|omnia|s7568|A3000|A3009|A5000|A5009|A7000|A7009|A8000|C101|C1116|C1158|E400|E500F|E7000|E7009|G3139D|G3502|G3502i|G3508|G3508J|G3508i|G3509|G3509i|G3558|G3559|G3568V|G3586V|G3589W|G3606|G3608|G3609|G3812|G388F|G5108|G5108Q|G5109|G5306W|G5308W|G5309W|G550|G600|G7106|G7108|G7108V|G7109|G7200|G720NO|G7508Q|G7509|G8508S|G8509V|G9006V|G9006W|G9008V|G9008W|G9009D|G9009W|G9198|G9200|G9208|G9209|G9250|G9280|I535|I679|I739|I8190N|I8262|I879|I879E|I889|I9000|I9060|I9082|I9082C|I9082i|I9100|I9100G|I9108|I9128|I9128E|I9128i|I9152|I9152P|I9158|I9158P|I9158V|I9168|I9168i|I9190|I9192|I9195|I9195I|I9200|I9208|I9220|I9228|I9260|I9268|I9300|I9300i|I9305|I9308|I9308i|I939|I939D|I939i|I9500|I9502|I9505|I9507V|I9508|I9508V|I959|J100|J110|J5008|J7008|N7100|N7102|N7105|N7108|N7108D|N719|N750|N7505|N7506V|N7508V|N7509V|N900|N9002|N9005|N9006|N9008|N9008S|N9008V|N9009|N9100|N9106W|N9108V|N9109W|N9150|N916|N9200|P709|P709E|P729|S6358|S7278|S7278U|S7562C|S7562i|S7898i|b9388)[\s\)]/i)) a.device.manufacturer = "Samsung", a.device.model = t[1].replace(/Galaxy S VI/i, "Galaxy S6").replace(/Galaxy S V/i, "Galaxy S5").replace(/Galaxy S IV/i, "Galaxy S4").replace(/Galaxy s III/i, "Galaxy S3").replace(/Galaxy S II/i, "Galaxy S2").replace(/Galaxy S I/i, "Galaxy S1").replace(/([a-z]+[0-9]{3})[0-9]?[a-z]*/i, "$1");else if (a.device.manufacturer && "samsung" === a.device.manufacturer.toLowerCase() && a.device.model) a.device.model = a.device.model.replace(/Galaxy S VI/i, "Galaxy S6").replace(/Galaxy S V/i, "Galaxy S5").replace(/Galaxy S IV/i, "Galaxy S4").replace(/Galaxy s III/i, "Galaxy S3").replace(/Galaxy S II/i, "Galaxy S2").replace(/Galaxy S I/i, "Galaxy S1").replace(/([a-z]+[0-9]{3})[0-9]?[a-z]*/i, "$1");else if (t = e.match(/(Huawei[\s-_](\w*[-_]?\w*)|\s(7D-\w*|ALE-\w*|ATH-\w*|CHE-\w*|CHM-\w*|Che1-\w*|Che2-\w*|D2-\w*|G616-\w*|G620S-\w*|G621-\w*|G660-\w*|G750-\w*|GRA-\w*|Hol-\w*|MT2-\w*|MT7-\w*|PE-\w*|PLK-\w*|SC-\w*|SCL-\w*|H60-\w*|H30-\w*)[\s\)])/i)) a.device.manufacturer = "Huawei", t[2] ? a.device.model = t[2] : t[3] && (a.device.model = t[3]), (t = a.device.model.match(/(\w*)[\s-_]+[a-z0-9]+/i)) && (a.device.model = t[1]);else if (t = e.match(/;\s(mi|m1|m2|m3|m4|hm)(\s*\w*)[\s\)]/i)) (i = e.match(/(meitu|MediaPad)/i)) ? (a.device.manufacturer = i[1], a.device.model = "") : t[2].length > 0 && !/\s/.test(t[2]) ? (i = t[2].match(/(\d)/i)) && (a.device.model = t[1] + "-" + i[1]) : (a.device.manufacturer = "Xiaomi", t[2] && t[2].length > 0 ? (t[2] = t[2].replace(/\s/, ""), a.device.model = (t[1].substr(t[1].length - 2) + "-" + t[2]).replace(/m(\d)-/i, "MI-$1")) : a.device.model = t[1].substr(t[1].length - 2).replace(/m(\d)/i, "MI-$1"), /(mi|hm)(-\d)/i.test(a.device.model) && ((t = a.device.model.match(/(mi|hm)(-\ds)/i)) ? a.device.model = t[1] + t[2] : (t = a.device.model.match(/(mi|hm)(-\d{2})/i)) ? a.device.model = t[1] : (t = a.device.model.match(/(mi|hm)(-\d)[A-Z]/i)) && (a.device.model = t[1] + t[2])), (t = a.device.model.match(/(mi|hm)(-\dg)/i)) && (a.device.model = t[1]));else if (/build\/HM\d{0,7}\)/i.test(e)) a.device.manufacturer = "Xiaomi", a.device.model = "HM";else if (t = e.match(/redmi\s?(\d+)?/i)) a.device.manufacturer = "Xiaomi", a.device.model = "HM-" + t[1];else if (a.device.manufacturer && "xiaomi" === a.device.manufacturer.toLowerCase() && a.device.model) (t = a.device.model.match(/mi-one/i)) ? a.device.model = "MI-1" : (t = a.device.model.match(/mi-two/i)) ? a.device.model = "MI-2" : (t = a.device.model.match(/\d{6}/i)) ? a.device.model = "" : (t = a.device.model.match(/redmi/i)) ? a.device.model = a.device.model.toUpperCase().replace(/redmi/i, "HM") : (t = a.device.model.match(/(m\d)[\s-_](s?)/i)) ? a.device.model = t[1].replace(/m/, "MI-") + t[2] : (t = a.device.model.match(/(hm|mi)[\s-_](\d?)[a-rt-z]/i)) ? (i = a.device.model.match(/(mi|hm)[\s-_](note|pad)(\d?s?)/i)) ? a.device.model = i[1] + "-" + i[2] + i[3] : a.device.model = t[2] ? t[1] + "-" + t[2] : t[1] : (t = a.device.model.match(/hm/i)) && ((t = a.device.model.match(/(hm)[\s-_](\d{2})/i)) ? a.device.model = "HM" : (t = a.device.model.match(/(hm)[\s-_](\ds)/i)) || (t = a.device.model.match(/(hm)[\s-_](\d)[a-z]/i)) ? a.device.model = "HM-" + t[2] : a.device.model = "HM", /hm-\dg/.test(a.device.model) && (a.device.model = "HM"));else if (t = e.match(/(vivo[\s-_](\w*)|\s(E1\w?|E3\w?|E5\w?|V1\w?|V2\w?|S11\w?|S12\w?|S1\w?|S3\w?|S6\w?|S7\w?|S9\w?|X1\w?|X3\w?|X520\w?|X5\w?|X5Max|X5Max+|X5Pro|X5SL|X710F|X710L|Xplay|Xshot|Xpaly3S|Y11\w?|Y11i\w?|Y11i\w?|Y13\w?|Y15\w?|Y17\w?|Y18\w?|Y19\w?|Y1\w?|Y20\w?|Y22\w?|Y22i\w?|Y23\w?|Y27\w?|Y28\w?|Y29\w?|Y33\w?|Y37\w?|Y3\w?|Y613\w?|Y622\w?|Y627\w?|Y913\w?|Y923\w?|Y927\w?|Y928\w?|Y929\w?|Y937\w?)[\s\)])/i)) a.device.manufacturer = "Vivo", a.device.model = t[1], a.device.model = a.device.model.replace(/(viv[\s-_]|vivo[\s-_]|bbg[\s-_])/i, ""), (t = a.device.model.match(/([a-z]+[0-9]+)i?[a-z]?[\s-_]?/i)) && (a.device.model = t[1]);else if (t = e.match(/(Oppo[\s-_](\w*)|\s(1100|1105|1107|3000|3005|3007|6607|A100|A103|A105|A105K|A109|A109K|A11|A113|A115|A115K|A121|A125|A127|A129|A201|A203|A209|A31|A31c|A31t|A31u|A51kc|A520|A613|A615|A617|E21W|Find|Mirror|N5110|N5117|N5207|N5209|R2010|R2017|R6007|R7005|R7007|R7c|R7t|R8000|R8007|R801|R805|R807|R809T|R8107|R8109|R811|R811W|R813T|R815T|R815W|R817|R819T|R8200|R8205|R8207|R821T|R823T|R827T|R830|R830S|R831S|R831T|R833T|R850|Real|T703|U2S|U521|U525|U529|U539|U701|U701T|U705T|U705W|X9000|X9007|X903|X905|X9070|X9077|X909|Z101|R829T)[\s\)])/i)) a.device.manufacturer = "Oppo", t[2] ? a.device.model = t[2] : t[3] && (a.device.model = t[3]), (t = a.device.model.match(/([a-z]+[0-9]+)-?(plus)/i)) ? a.device.model = t[1] + "-" + t[2] : (t = a.device.model.match(/(\w*-?[a-z]+[0-9]+)/i)) && (a.device.model = t[1]);else if (a.device.manufacturer && "oppo" === a.device.manufacturer.toLowerCase() && a.device.model) (t = a.device.model.match(/([a-z]+[0-9]+)-?(plus)/i)) ? a.device.model = t[1] + "-" + t[2] : (t = a.device.model.match(/(\w*-?[a-z]+[0-9]+)/i)) && (a.device.model = t[1]);else if (t = e.match(/(Lenovo[\s-_](\w*[-_]?\w*)|\s(A3580|A3860|A5500|A5600|A5860|A7600|A806|A800|A808T|A808T-I|A936|A938t|A788t|K30-E|K30-T|K30-W|K50-T3s|K50-T5|K80M|K910|K910e|K920|S90-e|S90-t|S90-u|S968T|X2-CU|X2-TO|Z90-3|Z90-7)[\s\)])/i)) a.device.manufacturer = "Lenovo", t[2] ? a.device.model = t[2] : t[3] && (a.device.model = t[3]), (t = a.device.model.match(/([a-z]+[0-9]+)/i)) && (a.device.model = t[1]);else if (t = e.match(/(Coolpad[\s-_](\w*)|\s(7295C|7298A|7620L|8908|8085|8970L|9190L|Y80D)[\s\)])/i)) a.device.manufacturer = "Coolpad", t[2] ? a.device.model = t[2] : t[3] && (a.device.model = t[3]), (t = a.device.model.match(/([a-z]?[0-9]+)/i)) && (a.device.model = t[1]);else if (a.device.manufacturer && "coolpad" === a.device.manufacturer.toLowerCase() && a.device.model) (t = a.device.model.match(/([a-z]?[0-9]+)/i)) && (a.device.model = t[1]);else if (t = e.match(/\s(mx\d*\w*|mz-(\w*))\s(\w*)\s*\w*\s*build/i)) {
          a.device.manufacturer = "Meizu";
          var o = t[2] ? t[2] : t[1];
          t[3] ? a.device.model = o + "-" + t[3] : a.device.model = o + "";
        } else (t = e.match(/M463C|M35\d/i)) ? (a.device.manufacturer = "Meizu", a.device.model = t[1]) : (t = e.match(/(Htc[-_\s](\w*)|\s(601e|606w|608t|609d|610t|6160|619d|620G|626d|626s|626t|626w|709d|801e|802d|802t|802w|809D|816d|816e|816t|816v|816w|826d|826s|826t|826w|828w|901e|919d|A310e|A50AML|A510e|A620d|A620e|A620t|A810e|A9191|Aero|C620d|C620e|C620t|D316d|D516d|D516t|D516w|D820mt|D820mu|D820t|D820ts|D820u|D820us|E9pt|E9pw|E9sw|E9t|HD7S|M8Et|M8Sd|M8St|M8Sw|M8d|M8e|M8s|M8si|M8t|M8w|M9W|M9ew|Phablet|S510b|S510e|S610d|S710d|S710e|S720e|S720t|T327t|T328d|T328t|T328w|T329d|T329t|T329w|T528d|T528t|T528w|T8698|WF5w|X315e|X710e|X715e|X720d|X920e|Z560e|Z710e|Z710t|Z715e)[\s\)])/)) ? (a.device.manufacturer = "Htc", a.device.model = t[1]) : (t = e.match(/(Gionee[\s-_](\w*)|\s(GN\d+\w*)[\s\)])/i)) ? (a.device.manufacturer = "Gionee", t[2] ? a.device.model = t[2] : t[3] && (a.device.model = t[3])) : (t = e.match(/(LG[-_](\w*)|\s(D728|D729|D802|D855|D856|D857|D858|D859|E985T|F100L|F460|H778|H818|H819|P895|VW820)[\s\)])/i)) ? (a.device.manufacturer = "Lg", t[2] ? a.device.model = t[2] : t[3] && (a.device.model = t[3])) : (t = e.match(/(Tcl[\s-_](\w*)|\s(H916T|P588L|P618L|P620M|P728M)[\s\)])/)) ? (a.device.manufacturer = "Tcl", a.device.model = t[1]) : (t = e.match(/(V9180|N918)/i)) ? (a.device.manufacturer = "Zte", a.device.model = t[1]) : a.device.manufacturer && "zte" === a.device.manufacturer.toLowerCase() && a.device.model ? (t = a.device.model.match(/([a-z]?[0-9]+)/i)) && (a.device.model = t[1]) : (t = e.match(/(UIMI\w*|umi\w*)[\s-_](\w*)\s*\w*\s*build/i)) ? (a.device.manufacturer = "Uimi", t[2] ? a.device.model = t[1] + "-" + t[2] : a.device.model = t[1] + "") : (t = e.match(/eton[\s-_](\w*)/i)) ? (a.device.manufacturer = "Eton", a.device.model = t[1]) : (t = e.match(/(SM705|SM701|YQ601|YQ603)/i)) ? (a.device.manufacturer = "Smartisan", a.device.model = {
          SM705: "T1",
          SM701: "T1",
          YQ601: "U1",
          YQ603: "U1"
        }[t[1]] || t[1]) : (t = e.match(/(Asus[\s-_](\w*)|\s(A500CG|A500KL|A501CG|A600CG|PF400CG|PF500KL|T001|X002|X003|ZC500TG|ZE550ML|ZE551ML)[\s\)])/i)) ? (a.device.manufacturer = "Asus", t[2] ? a.device.model = t[2] : t[3] && (a.device.model = t[3])) : (t = e.match(/(Nubia[-_\s](\w*)|(NX501|NX505J|NX506J|NX507J|NX503A|nx\d+\w*)[\s\)])/i)) ? (a.device.manufacturer = "Nubia", t[2] ? a.device.model = t[2] : t[3] && (a.device.model = t[3])) : (t = e.match(/(HT-\w*)|Haier[\s-_](\w*-?\w*)/i)) ? (a.device.manufacturer = "Haier", t[1] ? a.device.model = t[1] : t[2] && (a.device.model = t[2])) : (t = e.match(/K-Touch[\s-_](tou\s?ch\s?(\d)|\w*)/i)) ? (a.device.manufacturer = "K-Touch", t[2] ? a.device.model = "Ktouch" + t[2] : a.device.model = t[1]) : (t = e.match(/Doov[\s-_](\w*)/i)) ? (a.device.manufacturer = "Doov", a.device.model = t[1]) : /koobee/i.test(e) ? a.device.manufacturer = "koobee" : /C69/i.test(e) ? a.device.manufacturer = "Sony" : /N787|N818S/i.test(e) ? a.device.manufacturer = "Haojixing" : (t = e.match(/(hs-|Hisense[\s-_])(\w*)/i)) && (a.device.manufacturer = "Hisense", a.device.model = t[2]);
        a.device.manufacturer && (a.device.manufacturer = a.device.manufacturer.substr(0, 1).toUpperCase() + a.device.manufacturer.substr(1).toLowerCase()), a.device.model && (a.device.model = a.device.model.toUpperCase().replace(/-+|_+|\s+/g, " "), a.device.model = a.device.model.match(/\s*(\w*\s*\w*)/)[1].replace(/\s+/, "-"), "Samsung" === a.device.manufacturer ? a.device.model = {
          "SCH-I95": "GT-I950",
          "SCH-I93": "GT-I930",
          "SCH-I86": "GT-I855",
          "SCH-N71": "GT-N710",
          "SCH-I73": "GT-S789",
          "SCH-P70": "GT-I915"
        }[a.device.model] || a.device.model : "Huawei" === a.device.manufacturer && (a.device.model = {
          CHE1: "CHE",
          CHE2: "CHE",
          G620S: "G621",
          C8817D: "G621"
        }[a.device.model] || a.device.model)), a.device.manufacturer && "Xiaomi" === a.device.manufacturer && ((t = a.device.model.match(/(hm|mi)-(note)/i)) || (t = a.device.model.match(/(hm|mi)-(\ds?)/i)) || (t = a.device.model.match(/(hm|mi)-(\d)[a-rt-z]/i))) && (a.device.model = t[1] + "-" + t[2]);
      }
      if ("desktop" === a.device.type ? (t = /360se(?:[ \/]([\w.]+))?/i.exec(e)) ? (a.browser.name = "360 security Explorer", a.browser.version = {
        original: t[1]
      }) : (t = /the world(?:[ \/]([\w.]+))?/i.exec(e)) ? (a.browser.name = "the world", a.browser.version = {
        original: t[1]
      }) : (t = /tencenttraveler ([\w.]+)/i.exec(e)) ? (a.browser.name = "tencenttraveler", a.browser.version = {
        original: t[1]
      }) : (t = /LBBROWSER/i.exec(e)) && (a.browser.name = "LBBROWSER") : "mobile" !== a.device.type && "tablet" !== a.device.type || ((t = /BaiduHD\s+([\w.]+)/i.exec(e)) ? (a.browser.name = "BaiduHD", a.browser.version = {
        original: t[1]
      }) : (t = /360.s*aphone\s*browser\s*\(version\s*([\w.]+)\)/i.exec(e)) ? (a.browser.name = "360 Browser", a.browser.version = {
        original: t[1]
      }) : (t = /flyflow\/([\w.]+)/i.exec(e)) ? (a.browser.name = "Baidu Browser", a.browser.version = {
        original: t[1]
      }) : (t = /baiduhd ([\w.]+)/i.exec(e)) ? (a.browser.name = "Baidu HD", a.browser.version = {
        original: t[1]
      }) : (t = /baidubrowser\/([\d\.]+)\s/i.exec(e)) ? (a.browser.name = "baidubrowser", a.browser.version = {
        original: t[1]
      }) : (t = /LieBaoFast\/([\w.]+)/i.exec(e)) ? (a.browser.name = "LieBao Fast", a.browser.version = {
        original: t[1]
      }) : (t = /LieBao\/([\w.]+)/i.exec(e)) ? (a.browser.name = "LieBao", a.browser.version = {
        original: t[1]
      }) : (t = /Sogou\w+\/([0-9\.]+)/i.exec(e)) ? (a.browser.name = "SogouMobileBrowser", a.browser.version = {
        original: t[1]
      }) : (t = /bdbrowser\w+\/([0-9\.]+)/i.exec(e)) ? (a.browser.name = "百度国际", a.browser.version = {
        original: t[1]
      }) : "Android" === a.os.name && /safari/i.test(e) && (t = /chrome\/([0-9\.]+)/i.exec(e)) ? (i = e.match(/\s+(\w+Browser)\/?([\d\.]*)/)) ? (a.browser.name = i[1], i[2] ? a.browser.version = {
        original: i[2]
      } : a.browser.version = {
        original: t[1]
      }) : (a.browser.name = "Android Chrome", a.browser.version = {
        original: t[1]
      }) : "Android" === a.os.name && /safari/i.test(e) && (t = /version\/([0-9\.]+)/i.exec(e)) ? (i = e.match(/\s+(\w+Browser)\/?([\d\.]*)/)) ? (a.browser.name = i[1], i[2] ? a.browser.version = {
        original: i[2]
      } : a.browser.version = {
        original: t[1]
      }) : (a.browser.name = "Android Browser", a.browser.version = {
        original: t[1]
      }) : /(ipad|iphone).* applewebkit\/.* mobile/i.test(e) && (a.browser.name = "Safari")), (t = e.match(/baiduboxapp\/?([\d\.]*)/i)) ? (a.browser.name = "百度框", t[1] && (a.browser.version = {
        original: t[1]
      })) : /BaiduLightAppRuntime/i.test(e) ? a.browser.name = "轻应用runtime" : /Weibo/i.test(e) ? a.browser.name = "微博" : /MQQ/i.test(e) ? a.browser.name = "手机QQ" : /hao123/i.test(e) && (a.browser.name = "hao123"), t = /MicroMessenger\/([\w.]+)/i.exec(e)) {
        a.browser.name = "微信";
        var r = t[1].replace(/_/g, ".");
        (i = /(\d+\.\d+\.\d+\.\d+)/.exec(r)) && (r = i[1]), a.browser.version = {
          original: r
        };
      }
      return (t = /UCBrowser\/([\w.]+)/i.exec(e)) && (a.browser.name = "UC Browser", a.browser.version = {
        original: t[1]
      }), (t = /OPR\/([\w.]+)/i.exec(e)) || (t = /OPiOS\/([\w.]+)/i.exec(e)) ? (a.browser.name = "Opera", a.browser.version = {
        original: t[1]
      }) : /Trident\/7/i.test(e) && /rv:11/i.test(e) ? (a.browser.name = "Internet Explorer", a.browser.version = {
        major: "11",
        original: "11"
      }) : /Edge\/12/i.test(e) && /Windows Phone|Windows NT/i.test(e) ? (a.browser.name = "Microsoft Edge", a.browser.version = {
        major: "12",
        original: "12"
      }) : (t = /miuibrowser\/([\w.]+)/i.exec(e)) && (a.browser.name = "miui browser", a.browser.version = {
        original: t[1]
      }), a.browser.name || (t = /Safari\/([\w.]+)/i.exec(e) && /Version/i.test(e)) && (a.browser.name = "Safari"), a.browser.name && !a.browser.version && (t = /Version\/([\w.]+)/i.exec(e)) && (a.browser.version = {
        original: t[1]
      }), "Windows" === a.os.name || /Windows/i.test(e) ? (a.os.name = "Windows", /NT 6.3/i.test(e) ? a.os.version = {
        alias: "8.1",
        original: "8.1"
      } : (/NT 6.4/i.test(e) || /NT 10.0/i.test(e)) && (a.os.version = {
        alias: "10",
        original: "10"
      })) : "Mac OS X" === a.os.name ? (a.os.name = "Mac OS X", (t = /Mac OS X[\s\_\-\/](\d+[\.\-\_]\d+[\.\-\_]?\d*)/i.exec(e)) ? a.os.version = {
        alias: t[1].replace(/_/g, "."),
        original: t[1].replace(/_/g, ".")
      } : a.os.version = {
        alias: "",
        original: ""
      }) : /Android/i.test(a.os.name) && (t = e.match(/Android[\s\_\-\/i686]?[\s\_\-\/](\d+[\.\-\_]\d+[\.\-\_]?\d*)/i)) && (a.os.version = {
        alias: t[1],
        original: t[1]
      }), a;
    };
  function rr() {
    var e,
      t,
      i = window.returnCitySN,
      a = navigator.userAgent,
      o = new or(window.navigator.userAgent) || {},
      r = navigator.connection;
    return {
      uploadType: "",
      t: "",
      page: Ra(),
      times: 1,
      serviceVersion: c.serviceVersion,
      serviceId: c.serviceId,
      e: c.environment,
      begin: new Date().getTime(),
      customerKey: Ba(),
      visiterKey: ka(),
      sid: va.sid,
      sr: screen.width + "x" + screen.height,
      vp: (e = document.documentElement.clientWidth || document.body.clientWidth, t = document.documentElement.clientHeight || document.body.clientHeight, e + "x" + t),
      ct: r ? r.effectiveType : "",
      ul: nr(),
      _v: "1.2.1-beta.2",
      o: location.href,
      ip: null == i ? void 0 : i.cip,
      contry: "",
      province: null == i ? void 0 : i.cname,
      city: "",
      userAgent: a,
      deviceBrowser: JSON.stringify(o.browser || {}),
      deviceModel: JSON.stringify(o.device || {}),
      deviceEngine: JSON.stringify(o.deviceEngine || {}),
      deviceOs: JSON.stringify(o.os || {})
    };
  }
  function nr() {
    var e = navigator.language || navigator.userLanguage;
    return e = e.substr(0, 2);
  }
  var sr,
    cr = {
      actions: []
    };
  function lr(e) {
    var t = _o2(_o2({}, e), {
      timestamp: +new Date() / 1e3
    });
    cr.actions.length < u("actionLength") ? cr.actions.push(t) : (cr.actions.push(t), cr.actions.shift());
  }
  function ur() {
    return cr.actions;
  }
  !function (e) {
    e.click = "click", e.navigation = "navigation", e.console_error = "console.error", e.console_log = "console.log", e.console_info = "console.info";
  }(sr || (sr = {}));
  var dr = function dr(e) {
      var t,
        i,
        a,
        o,
        r,
        n,
        s = [];
      if (!e || !e.tagName || "string" != typeof e.tagName) return "";
      if (s.push(null === (t = e.tagName) || void 0 === t ? void 0 : t.toLowerCase()), e.id && s.push("#".concat(e.id)), (i = e.className) && "[object String]" === Object.prototype.toString.call(i)) for (a = i.split(/\s+/), n = 0; n < a.length; n++) {
        a[n].indexOf("active") < 0 && s.push(".".concat(a[n]));
      }
      var c = ["type", "name", "title", "alt"];
      for (n = 0; n < c.length; n++) {
        o = c[n], (r = e.getAttribute(o)) && s.push("[".concat(o, '="').concat(r, '"]'));
      }
      return s.join("");
    },
    hr = function hr(e) {
      var t;
      if (!e || 1 !== e.nodeType) return "";
      var i = [],
        a = 0,
        o = "";
      i.push("(" + (null === (t = e.innerText) || void 0 === t ? void 0 : t.substr(0, 50)) + ")");
      for (var r = e || null; r && a++ < 5 && "html" !== (o = dr(r));) {
        i.push(o), r = r.parentNode;
      }
      return i.reverse().join(" > ");
    };
  function mr(e) {
    var t;
    try {
      t = e.target;
    } catch (e) {
      t = "<unknown>";
    }
    if ("INPUT" !== t.nodeName && "TEXTAREA" !== t.nodeName && 0 !== t.length) {
      var i = {
        type: "ui.click",
        data: {
          path: hr(t),
          message: ""
        }
      };
      if (lr({
        type: "ui.click",
        message: hr(t) || t
      }), !i.data.path) return;
      var r = rr(),
        n = _o2(_o2({}, r), {
          t: "behavior",
          uploadType: "behavior",
          behavior: i
        });
      h(a.BEHAVIOR, n, sr.click, e) && u("isBehavior") && wa(n, "behavior");
    }
  }
  function Sr(e) {
    var t = c.enableSPA ? Oa(location.hash.toLowerCase()) : location.pathname.toLowerCase();
    t && Tr(t, !1);
  }
  function pr(e) {
    var t = c.enableSPA ? Oa(e.detail.toLowerCase()) : e.detail.toLowerCase();
    t && Tr(t, !1);
  }
  function Tr(e, t) {
    !function (e, t) {
      var i = rr(),
        r = _o2(_o2({}, i), {
          t: "behavior",
          uploadType: "behavior",
          type: "navigation",
          from: t ? "" : i.page,
          to: e,
          fromStart: va.sBegin,
          fromEnd: Date.now()
        });
      lr({
        category: "navigation",
        type: "navigation",
        from: i.page,
        to: e
      }), h(a.BEHAVIOR, r, sr.navigation) && wa(r, "common");
    }(e, t), Xa && window.parent.postMessage({
      t: "setPage",
      href: location.href,
      page: e
    }, "*"), function (e) {
      va.page = e;
    }(e), function (e) {
      va.isFirst = e;
    }(t), va.sBegin = Date.now(), function () {
      var e = Ia();
      localStorage.setItem("pvuid", e);
    }(), function () {
      if (c.autoSendPv) {
        var e = rr(),
          t = b.parse(location.search.substring(1));
        wa(_o2(_o2({}, e), {
          t: "pv",
          uploadType: "pv",
          dt: document.title,
          dl: location.href,
          dr: document.referrer,
          dpr: window.devicePixelRatio,
          de: document.charset,
          us: t.utm_source,
          um: t.utm_medium,
          uc: t.utm_campaign
        }), "common");
      }
    }();
  }
  function vr() {
    var e,
      t,
      i,
      a,
      r,
      n,
      l,
      u = rr(),
      d = ma(),
      h = s((e = Ma(), t = va.monitorSegments.common, i = t.concat(va.monitorSegments.error), a = i.concat(va.monitorSegments.behavior), r = new Blob([JSON.stringify(e)]).size / 1024, n = new Blob([JSON.stringify(i)]).size / 1024, l = new Blob([JSON.stringify(a)]).size / 1024, r <= 64 ? e : l <= 64 ? a : n <= 64 ? i : t).map(function (e) {
        return Va(e);
      }));
    if (va.isFirst) {
      var m = _o2(_o2({}, u), {
        t: "bounceRate",
        uploadType: "bounceRate"
      });
      h.push(m);
    }
    var S = _o2(_o2({}, u), {
      t: "behavior",
      uploadType: "behavior",
      type: "navigation",
      from: u.page,
      to: "",
      fromStart: va.sBegin,
      fromEnd: Date.now()
    });
    h.push(S);
    var p = new FormData(),
      T = Ua(h);
    p.append("source", new Blob([T], {
      type: "application/x-bzip"
    })), (window.__fetch_ || window.fetch)(c.reportUrl + "?uuid=" + c.serviceId, {
      method: "POST",
      headers: {
        Authorization: "bearer " + d
      },
      keepalive: !0,
      body: p
    });
  }
  function fr(e) {
    var t = history[e];
    "function" == typeof t && (history[e] = function (i, a, o) {
      var r = 1 === arguments.length ? [arguments[0]] : Array.apply(null, arguments),
        n = location.href,
        s = t.apply(history, r);
      if (!o || "string" != typeof o) return s;
      if (o === n) return s;
      try {
        var c = n.split("#"),
          l = o.split("#"),
          u = Pa(c[0]),
          d = Pa(l[0]),
          h = c[1] && c[1].replace(/^\/?(.*)/, "$1"),
          m = l[1] && l[1].replace(/^\/?(.*)/, "$1");
        u !== d ? Na("historystatechanged", d) : h !== m && Na("historystatechanged", m);
      } catch (t) {
        Da("[retcode] error in " + e + ": " + t);
      }
      return s;
    }), history[e].toString = function (e) {
      return function () {
        return e + "() { [native code] }";
      };
    }(e);
  }
  var br,
    gr = new Map(),
    yr = function yr(e) {
      return e.url;
    },
    Cr = function Cr(e, t) {
      gr.set(yr(e), t);
    },
    Gr = ["", "fetchStart", "domainLookupStart", "domainLookupEnd", "connectStart", "connectEnd", "requestStart", "responseStart", "responseEnd", "", "domInteractive", "", "domContentLoadedEventEnd", "", "loadEventStart", "", "msFirstPaint", "secureConnectionStart"],
    Hr = new (function () {
      function e() {}
      return e.prototype.handleResource = function () {
        var e,
          t = this,
          i = window.performance;
        if (!i || "object" != typeof i || "function" != typeof i.getEntriesByType) return null;
        (va.resourceFlag && (this.handleInitResource(), e = !1, va.resourceFlag = e), window.PerformanceObserver) && new window.PerformanceObserver(function (e) {
          try {
            var i = Wa(e.getEntries());
            if (i.length > 0) wa(t.handleCommonResource(i), "common");
          } catch (e) {
            console.error(e);
          }
        }).observe({
          entryTypes: ["resource"]
        });
      }, e.prototype.handleInitResource = function () {
        wa(this.handleCommonResource(), "common");
      }, e.prototype.handleCommonResource = function (e) {
        var t = rr(),
          i = _o2(_o2({}, t), {
            dom: 0,
            load: 0,
            t: "res",
            uploadType: "res",
            ress: []
          }),
          a = performance.timing || {},
          r = e || Wa(performance.getEntriesByType("resource")) || [];
        if ("function" == typeof window.PerformanceNavigationTiming) {
          var n = performance.getEntriesByType("navigation")[0];
          n && (a = n);
        }
        if (xa({
          dom: [10, 8],
          load: [14, 1]
        }, function (e, t) {
          var o = a[Gr[e[1]]],
            r = a[Gr[e[0]]];
          if (void 0 !== o && void 0 !== r) {
            var n = Math.round(r - o);
            n >= 0 && n < 36e5 && (i[t] = n);
          }
        }), r = r.filter(function (e) {
          var t, i;
          return !((t = s(u("ignore").ignoreApis, [c.reportUrl, c.collector]), i = function i(t) {
            return e.name.indexOf(t) > -1;
          }, Array.isArray(t) ? t.reduce(function (e, t, a) {
            return i(t, a) ? a : e;
          }, -1) : -1) > -1);
        }), navigator.userAgent.indexOf("Edge") > -1) {
          var l = [];
          xa(r, function (e) {
            l.push({
              connectEnd: e.connectEnd,
              connectStart: e.connectStart,
              domainLookupEnd: e.connectStart,
              domainLookupStart: e.domainLookupStart,
              duration: e.duration,
              entryType: e.entryType,
              fetchStart: e.fetchStart,
              initiatorType: e.initiatorType,
              name: e.name,
              redirectEnd: e.redirectEnd,
              redirectStart: e.redirectStart,
              responseEnd: e.responseEnd,
              responseStart: e.responseStart,
              startTime: e.startTime
            });
          }), r = l;
        }
        return r = r.map(function (e) {
          if ("xmlhttprequest" === e.initiatorType || "fetch" === e.initiatorType) {
            var t = (i = {
              url: e.name
            }, gr.has(yr(i)) ? gr.get(yr(i)) : null);
            return t ? ((e = e.toJSON()).traceId = t, e) : e;
          }
          var i;
          return e;
        }), i.ress = r, i;
      }, e;
    }())(),
    wr = function () {
      function e() {}
      return e.prototype.getPerfTiming = function () {
        try {
          if (!window.performance || !window.performance.timing) return void console.log("your browser do not support performance");
          var e = window.performance.timing,
            t = 0,
            i = 1,
            a = new Date().getTime();
          if ("function" == typeof window.PerformanceNavigationTiming) {
            var o = performance.getEntriesByType("navigation")[0];
            o && (e = o, i = 2);
          }
          t = void 0 !== e.navigationStart ? parseInt(String(e.fetchStart - e.navigationStart), 10) : void 0 !== e.redirectEnd ? parseInt(String(e.redirectEnd - e.redirectStart), 10) : 0;
          var r = window.navigator.connection || window.navigator.mozConnection || window.navigator.webkitConnection,
            n = performance.navigation || {
              type: void 0
            },
            s = r ? r.effectiveType || r.type : "",
            c = r && (r.downlink || r.downlinkMax || r.bandwidth) || null,
            l = c > 999 ? 999 : c,
            u = 1 === n.type ? "Reload" : "Other";
          return a = 1 === i && e.fetchStart > 0 ? e.fetchStart : 2 === i && parseInt(String(e.loadEventStart - e.fetchStart), 10) > 0 ? Date.now() - parseInt(String(e.loadEventStart - e.fetchStart), 10) : Date.now(), new Promise(function (i) {
            0 !== e.loadEventEnd ? i({
              redirectTime: t,
              dns: parseInt(String(e.domainLookupEnd - e.domainLookupStart), 10),
              ttfb: parseInt(String(e.responseStart - e.requestStart), 10),
              tcp: parseInt(String(e.connectEnd - e.connectStart), 10),
              trans: parseInt(String(e.responseEnd - e.responseStart), 10),
              dom: parseInt(String(e.domInteractive - e.responseEnd), 10),
              fpt: parseInt(String(e.responseEnd - e.fetchStart), 10),
              ready: parseInt(String(e.domContentLoadedEventEnd - e.fetchStart), 10),
              load: parseInt(String(e.loadEventStart - e.fetchStart), 10),
              res: parseInt(String(e.loadEventStart - e.domContentLoadedEventEnd), 10),
              ssl: "https:" === location.protocol && e.secureConnectionStart > 0 ? parseInt(String(e.connectEnd - e.secureConnectionStart), 10) : void 0,
              tti: parseInt(String(e.domInteractive - e.fetchStart), 10),
              firstbyte: parseInt(String(e.responseStart - e.domainLookupStart), 10),
              fmp: 0,
              perfTiming: JSON.stringify(e),
              bandwidth: l,
              ct: s,
              navtype: u,
              begin: a
            }) : setTimeout(function () {
              0 !== e.loadEventEnd && i({
                redirectTime: t,
                dns: parseInt(String(e.domainLookupEnd - e.domainLookupStart), 10),
                ttfb: parseInt(String(e.responseStart - e.requestStart), 10),
                tcp: parseInt(String(e.connectEnd - e.connectStart), 10),
                trans: parseInt(String(e.responseEnd - e.responseStart), 10),
                dom: parseInt(String(e.domInteractive - e.responseEnd), 10),
                fpt: parseInt(String(e.responseEnd - e.fetchStart), 10),
                ready: parseInt(String(e.domContentLoadedEventEnd - e.fetchStart), 10),
                load: parseInt(String(e.loadEventStart - e.fetchStart), 10),
                res: parseInt(String(e.loadEventStart - e.domContentLoadedEventEnd), 10),
                ssl: "https:" === location.protocol && e.secureConnectionStart > 0 ? parseInt(String(e.connectEnd - e.secureConnectionStart), 10) : void 0,
                tti: parseInt(String(e.domInteractive - e.fetchStart), 10),
                firstbyte: parseInt(String(e.responseStart - e.domainLookupStart), 10),
                fmp: 0,
                perfTiming: JSON.stringify(e),
                bandwidth: l,
                ct: s,
                navtype: u,
                begin: a
              });
            }, 1e3);
          });
        } catch (e) {
          throw e;
        }
      }, e;
    }(),
    Ar = function Ar(e, t) {
      return window.getComputedStyle ? window.getComputedStyle(e, null)[t] : e.currentStyle[t];
    };
  !function (e) {
    e[e.SVG = 2] = "SVG", e[e.IMG = 2] = "IMG", e[e.CANVAS = 4] = "CANVAS", e[e.OBJECT = 4] = "OBJECT", e[e.EMBED = 4] = "EMBED", e[e.VIDEO = 4] = "VIDEO";
  }(br || (br = {}));
  var Mr = performance.now(),
    Er = ["SCRIPT", "STYLE", "META", "HEAD", "LINK"],
    Ir = window.innerWidth,
    xr = window.innerHeight,
    Lr = function () {
      function e() {
        this.fmpTime = 0, this.statusCollector = [], this.flag = !0, this.observer = null, this.callbackCount = 0, this.entries = {}, performance && performance.getEntries ? this.initObserver() : console.log("your browser do not support performance.getEntries");
      }
      return e.prototype.getFirstSnapShot = function () {
        var e = performance.now(),
          t = document.body;
        t && this.setTag(t, this.callbackCount), this.statusCollector.push({
          time: e
        });
      }, e.prototype.initObserver = function () {
        var e = this;
        this.getFirstSnapShot(), this.observer = new MutationObserver(function () {
          e.callbackCount += 1;
          var t = performance.now(),
            i = document.body;
          i && e.setTag(i, e.callbackCount), e.statusCollector.push({
            time: t
          });
        }), this.observer.observe(document, {
          childList: !0,
          subtree: !0
        }), "complete" === document.readyState ? this.calculateFinalScore() : window.addEventListener("load", function () {
          e.calculateFinalScore();
        }, !1);
      }, e.prototype.calculateFinalScore = function () {
        var e = this;
        if (MutationEvent && this.flag) if (this.checkNeedCancel(Mr)) {
          this.observer.disconnect(), this.flag = !1;
          for (var t = null, i = 0, a = this.getTreeScore(document.body).dpss; i < a.length; i++) {
            var o = a[i];
            t && t.st ? t.st < o.st && (t = o) : t = o;
          }
          if (performance.getEntries().forEach(function (t) {
            e.entries[t.name] = t.responseEnd;
          }), !t) return !1;
          var r = this.filterResult(t.els),
            n = this.getFmpTime(r);
          this.fmpTime = n;
        } else setTimeout(function () {
          e.calculateFinalScore();
        }, 500);
      }, e.prototype.getFmpTime = function (e) {
        for (var t, i, a, o = 0, r = 0, n = e; r < n.length; r++) {
          var s = n[r],
            c = 0;
          if (1 === s.weight) {
            var l = parseInt(s.ele.getAttribute("fmp_c"), 10);
            c = null === (t = this.statusCollector[l]) || void 0 === t ? void 0 : t.time;
          } else if (2 === s.weight) {
            if ("IMG" === s.ele.tagName) c = this.entries[s.ele.src];else if ("SVG" === s.ele.tagName) {
              l = parseInt(s.ele.getAttribute("fmp_c"), 10);
              c = null === (i = this.statusCollector[l]) || void 0 === i ? void 0 : i.time;
            } else {
              var u = Ar(s.ele, "background-image").match(/url\(\"(.*?)\"\)/),
                d = void 0;
              u && u[1] && (d = u[1]), (null == d ? void 0 : d.includes("http")) || u && (d = location.protocol + u[1]), c = this.entries[d];
            }
          } else if (4 === s.weight) if ("CANVAS" === s.ele.tagName) {
            l = parseInt(s.ele.getAttribute("fmp_c"), 10);
            c = this.statusCollector[l] && (null === (a = this.statusCollector[l]) || void 0 === a ? void 0 : a.time);
          } else "VIDEO" === s.ele.tagName && ((c = this.entries[s.ele.src]) || (c = this.entries[s.ele.poster]));
          "number" != typeof c && (c = 0), o < c && (o = c);
        }
        return o;
      }, e.prototype.filterResult = function (e) {
        if (1 === e.length) return e;
        var t = 0;
        e.forEach(function (e) {
          t += e.st;
        });
        var i = t / e.length;
        return e.filter(function (e) {
          return e.st > i;
        });
      }, e.prototype.checkNeedCancel = function (e) {
        var t = performance.now() - e,
          i = this.statusCollector.length > 0 ? this.statusCollector[this.statusCollector.length - 1].time : 0;
        return t > 3e3 || i > 1e3;
      }, e.prototype.getTreeScore = function (e) {
        if (!e) return {};
        for (var t = [], i = 0, a = e.children; i < a.length; i++) {
          var o = a[i];
          if (o.getAttribute("fmp_c")) {
            var r = this.getTreeScore(o);
            r.st && t.push(r);
          }
        }
        return this.calcaulteGrades(e, t);
      }, e.prototype.calcaulteGrades = function (e, t) {
        var i = e.getBoundingClientRect(),
          a = i.width,
          o = i.height,
          r = i.left,
          n = i.top,
          s = !0;
        (xr < n || Ir < r) && (s = !1);
        var c = 0;
        t.forEach(function (e) {
          c += e.st;
        });
        var l = Number(br[e.tagName]) || 1;
        1 === l && Ar(e, "background-image") && "initial" !== Ar(e, "background-image") && "none" !== Ar(e, "background-image") && (l = br.IMG);
        var u = s ? a * o * l : 0,
          d = [{
            ele: e,
            st: u,
            weight: l
          }],
          h = e,
          m = this.calculateAreaParent(e);
        if (c > u * m || 0 === m) {
          u = c, d = [];
          for (var S = 0, p = t; S < p.length; S++) {
            var T = p[S];
            d = d.concat(T.els);
          }
        }
        return {
          dpss: t,
          st: u,
          els: d,
          root: h
        };
      }, e.prototype.calculateAreaParent = function (e) {
        var t = e.getBoundingClientRect(),
          i = t.left,
          a = t.right,
          o = t.top,
          r = t.bottom,
          n = t.width,
          s = t.height,
          c = Ir,
          l = xr,
          u = a - i + (c - 0) - (Math.max(a, c) - Math.min(i, 0)),
          d = r - o + (l - 0) - (Math.max(r, l) - Math.min(o, 0));
        return u <= 0 || d <= 0 ? 0 : u * d / (n * s);
      }, e.prototype.setTag = function (e, t) {
        var i = e.tagName;
        if (-1 === Er.indexOf(i)) {
          var a = e.children;
          if (a && a.length > 0) for (var o = a.length - 1; o >= 0; o--) {
            var r = a[o];
            if (!(null !== r.getAttribute("fmp_c"))) {
              var n = r.getBoundingClientRect(),
                s = n.left,
                c = n.top,
                l = n.width,
                u = n.height;
              if (xr < c || Ir < s || 0 === l || 0 === u) continue;
              r.setAttribute("fmp_c", "" + t);
            }
            this.setTag(r, t);
          }
        }
      }, e;
    }(),
    Or = new (function () {
      function e() {
        this.perfConfig = {
          perfDetail: {}
        };
      }
      return e.prototype.recordPerf = function (e) {
        return void 0 === e && (e = !0), r(this, void 0, void 0, function () {
          var t,
            i,
            a = this;
          return n(this, function (r) {
            switch (r.label) {
              case 0:
                return t = {
                  fmpTime: void 0
                }, c.autoTracePerf ? (i = this.perfConfig, [4, new wr().getPerfTiming()]) : [3, 3];
              case 1:
                return i.perfDetail = r.sent(), c.useFmp && e ? [4, new Lr()] : [3, 3];
              case 2:
                t = r.sent(), r.label = 3;
              case 3:
                return setTimeout(function () {
                  var e;
                  if ((null === (e = a.perfConfig.perfDetail) || void 0 === e ? void 0 : e.tti) > 0) {
                    var i = c.autoTracePerf ? _o2(_o2({}, a.perfConfig.perfDetail), {
                        fmp: c.useFmp ? parseInt(String(t.fmpTime), 10) : void 0
                      }) : void 0,
                      r = rr();
                    wa(_o2(_o2(_o2({}, r), {
                      t: "perf",
                      uploadType: "perf"
                    }), i), "common");
                  }
                  a.clearPerf();
                }, 1e3), [2];
            }
          });
        });
      }, e.prototype.clearPerf = function () {
        window.performance && window.performance.clearResourceTimings && (window.performance.clearResourceTimings(), this.perfConfig = {
          perfDetail: {}
        });
      }, e;
    }())(),
    Pr = new (function () {
      function e() {}
      return e.prototype.handleErr = function (e) {
        switch (e.type) {
          case "error":
            e instanceof ErrorEvent ? this.reportCaughtError(e) : this.reportResourceError(e);
            break;
          case "unhandledrejection":
            this.reportPromiseError(e);
        }
      }, e.prototype.reportCaughtError = function (e) {
        var t,
          i = rr(),
          a = e.name || "CustomError",
          r = e.message || "",
          n = (null === (t = e.error) || void 0 === t ? void 0 : t.stack) || "";
        wa(_o2(_o2({}, i), {
          t: "error",
          uploadType: "error",
          st: "caughterror",
          cate: a,
          msg: r && r.substring(0, 200),
          detail: n && n.substring(0, 1e3),
          file: e.filename || "",
          line: e.lineno || "",
          col: e.colno || "",
          actions: JSON.stringify(ur())
        }), "error");
      }, e.prototype.reportResourceError = function (e) {
        var t,
          i = rr(),
          a = e.target;
        wa(_o2(_o2({}, i), {
          t: "error",
          uploadType: "error",
          st: "resource",
          msg: null === (t = a.outerHTML) || void 0 === t ? void 0 : t.substring(0, 200),
          file: a.src,
          stack: a.localName.toUpperCase()
        }), "error");
      }, e.prototype.reportPromiseError = function (e) {
        var t,
          i,
          a,
          r,
          n,
          s = rr();
        (null === (t = e.reason) || void 0 === t ? void 0 : t.name) && wa(_o2(_o2({}, s), {
          t: "error",
          uploadType: "error",
          st: "promise",
          msg: null === (a = null === (i = e.reason) || void 0 === i ? void 0 : i.message) || void 0 === a ? void 0 : a.substring(0, 200),
          detail: null === (n = null === (r = e.reason) || void 0 === r ? void 0 : r.stack) || void 0 === n ? void 0 : n.substring(0, 1e3),
          actions: JSON.stringify(ur())
        }), "error");
      }, e;
    }())();
  var Dr = "function" == typeof btoa,
    Nr = "function" == typeof Buffer,
    Xr = ("function" == typeof TextDecoder && new TextDecoder(), "function" == typeof TextEncoder ? new TextEncoder() : void 0),
    Rr = _toConsumableArray("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="),
    Br = (function (e) {
      var t = {};
      e.forEach(function (e, i) {
        return t[e] = i;
      });
    }(Rr), String.fromCharCode.bind(String)),
    kr = ("function" == typeof Uint8Array.from && Uint8Array.from.bind(Uint8Array), Dr ? function (e) {
      return btoa(e);
    } : Nr ? function (e) {
      return Buffer.from(e, "binary").toString("base64");
    } : function (e) {
      var t,
        i,
        a,
        o,
        r = "";
      var n = e.length % 3;
      for (var _n2 = 0; _n2 < e.length;) {
        if ((i = e.charCodeAt(_n2++)) > 255 || (a = e.charCodeAt(_n2++)) > 255 || (o = e.charCodeAt(_n2++)) > 255) throw new TypeError("invalid character found");
        t = i << 16 | a << 8 | o, r += Rr[t >> 18 & 63] + Rr[t >> 12 & 63] + Rr[t >> 6 & 63] + Rr[63 & t];
      }
      return n ? r.slice(0, n - 3) + "===".substring(n) : r;
    }),
    Ur = Nr ? function (e) {
      return Buffer.from(e).toString("base64");
    } : function (e) {
      var t = [];
      for (var _i2 = 0, _a2 = e.length; _i2 < _a2; _i2 += 4096) {
        t.push(Br.apply(null, e.subarray(_i2, _i2 + 4096)));
      }
      return kr(t.join(""));
    },
    Vr = function Vr(e) {
      if (e.length < 2) return (t = e.charCodeAt(0)) < 128 ? e : t < 2048 ? Br(192 | t >>> 6) + Br(128 | 63 & t) : Br(224 | t >>> 12 & 15) + Br(128 | t >>> 6 & 63) + Br(128 | 63 & t);
      var t = 65536 + 1024 * (e.charCodeAt(0) - 55296) + (e.charCodeAt(1) - 56320);
      return Br(240 | t >>> 18 & 7) + Br(128 | t >>> 12 & 63) + Br(128 | t >>> 6 & 63) + Br(128 | 63 & t);
    },
    Wr = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g,
    Fr = Nr ? function (e) {
      return Buffer.from(e, "utf8").toString("base64");
    } : Xr ? function (e) {
      return Ur(Xr.encode(e));
    } : function (e) {
      return kr(e.replace(Wr, Vr));
    },
    Zr = function Zr(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return t ? function (e) {
        return e.replace(/[+\/]/g, function (e) {
          return "+" == e ? "-" : "_";
        }).replace(/=+$/m, "");
      }(Fr(e)) : Fr(e);
    };
  var Kr,
    _r = Object.keys || function (e) {
      return $e(e, et);
    },
    zr = G ? Object.defineProperties : function (e, t) {
      I(e);
      for (var i, a = _r(t), o = a.length, r = 0; o > r;) {
        O.f(e, i = a[r++], t[i]);
      }
      return e;
    },
    jr = be("IE_PROTO"),
    Yr = function Yr() {},
    qr = function qr(e) {
      return "<script>" + e + "</" + "script>";
    },
    _Qr = function Qr() {
      try {
        Kr = document.domain && new ActiveXObject("htmlfile");
      } catch (e) {}
      var e, t;
      _Qr = Kr ? function (e) {
        e.write(qr("")), e.close();
        var t = e.parentWindow.Object;
        return e = null, t;
      }(Kr) : ((t = M("iframe")).style.display = "none", Wt.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(qr("document.F=Object")), e.close(), e.F);
      for (var i = et.length; i--;) {
        delete _Qr.prototype[et[i]];
      }
      return _Qr();
    };
  ge[jr] = !0;
  var Jr = Object.create || function (e, t) {
      var i;
      return null !== e ? (Yr.prototype = I(e), i = new Yr(), Yr.prototype = null, i[jr] = e) : i = _Qr(), void 0 === t ? i : zr(i, t);
    },
    $r = ce("unscopables"),
    en = Array.prototype;
  null == en[$r] && O.f(en, $r, {
    configurable: !0,
    value: Jr(null)
  });
  var tn = function tn(e) {
      en[$r][e] = !0;
    },
    an = Qe.includes;
  St({
    target: "Array",
    proto: !0
  }, {
    includes: function includes(e) {
      return an(this, e, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), tn("includes");
  var on = function on(e) {
      if (zo(e)) throw TypeError("The method doesn't accept regular expressions");
      return e;
    },
    rn = ce("match");
  St({
    target: "String",
    proto: !0,
    forced: !function (e) {
      var t = /./;
      try {
        "/./"[e](t);
      } catch (i) {
        try {
          return t[rn] = !1, "/./"[e](t);
        } catch (e) {}
      }
      return !1;
    }("includes")
  }, {
    includes: function includes(e) {
      return !!~String(k(this)).indexOf(on(e), arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var nn,
    sn,
    cn,
    ln = !C(function () {
      function e() {}
      return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
    }),
    un = be("IE_PROTO"),
    dn = Object.prototype,
    hn = ln ? Object.getPrototypeOf : function (e) {
      return e = U(e), W(e, un) ? e[un] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? dn : null;
    },
    mn = ce("iterator"),
    Sn = !1;
  [].keys && ("next" in (cn = [].keys()) ? (sn = hn(hn(cn))) !== Object.prototype && (nn = sn) : Sn = !0), (null == nn || C(function () {
    var e = {};
    return nn[mn].call(e) !== e;
  })) && (nn = {}), W(nn, mn) || D(nn, mn, function () {
    return this;
  });
  var pn = {
      IteratorPrototype: nn,
      BUGGY_SAFARI_ITERATORS: Sn
    },
    Tn = pn.IteratorPrototype,
    vn = function vn() {
      return this;
    },
    fn = function fn(e, t, i) {
      var a = t + " Iterator";
      return e.prototype = Jr(Tn, {
        next: P(1, i)
      }), bt(e, a, !1), Gt[a] = vn, e;
    },
    bn = Object.setPrototypeOf || ("__proto__" in {} ? function () {
      var e,
        t = !1,
        i = {};
      try {
        (e = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(i, []), t = i instanceof Array;
      } catch (e) {}
      return function (i, a) {
        return I(i), function (e) {
          if (!H(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype");
        }(a), t ? e.call(i, a) : i.__proto__ = a, i;
      };
    }() : void 0),
    gn = pn.IteratorPrototype,
    yn = pn.BUGGY_SAFARI_ITERATORS,
    Cn = ce("iterator"),
    Gn = "keys",
    Hn = "values",
    wn = "entries",
    An = function An() {
      return this;
    },
    Mn = function Mn(e, t, i, a, o, r, n) {
      fn(i, t, a);
      var s,
        c,
        l,
        u = function u(e) {
          if (e === o && p) return p;
          if (!yn && e in m) return m[e];
          switch (e) {
            case Gn:
            case Hn:
            case wn:
              return function () {
                return new i(this, e);
              };
          }
          return function () {
            return new i(this);
          };
        },
        d = t + " Iterator",
        h = !1,
        m = e.prototype,
        S = m[Cn] || m["@@iterator"] || o && m[o],
        p = !yn && S || u(o),
        T = "Array" == t && m.entries || S;
      if (T && (s = hn(T.call(new e())), gn !== Object.prototype && s.next && (hn(s) !== gn && (bn ? bn(s, gn) : "function" != typeof s[Cn] && D(s, Cn, An)), bt(s, d, !0))), o == Hn && S && S.name !== Hn && (h = !0, p = function p() {
        return S.call(this);
      }), m[Cn] !== p && D(m, Cn, p), Gt[t] = p, o) if (c = {
        values: u(Hn),
        keys: r ? p : u(Gn),
        entries: u(wn)
      }, n) for (l in c) {
        (yn || h || !(l in m)) && Ie(m, l, c[l]);
      } else St({
        target: t,
        proto: !0,
        forced: yn || h
      }, c);
      return c;
    },
    En = "Array Iterator",
    In = Ee.set,
    xn = Ee.getterFor(En),
    Ln = Mn(Array, "Array", function (e, t) {
      In(this, {
        type: En,
        target: ke(e),
        index: 0,
        kind: t
      });
    }, function () {
      var e = xn(this),
        t = e.target,
        i = e.kind,
        a = e.index++;
      return !t || a >= t.length ? (e.target = void 0, {
        value: void 0,
        done: !0
      }) : "keys" == i ? {
        value: a,
        done: !1
      } : "values" == i ? {
        value: t[a],
        done: !1
      } : {
        value: [a, t[a]],
        done: !1
      };
    }, "values");
  Gt.Arguments = Gt.Array, tn("keys"), tn("values"), tn("entries");
  var On = lo.charAt,
    Pn = "String Iterator",
    Dn = Ee.set,
    Nn = Ee.getterFor(Pn);
  Mn(String, "String", function (e) {
    Dn(this, {
      type: Pn,
      string: String(e),
      index: 0
    });
  }, function () {
    var e,
      t = Nn(this),
      i = t.string,
      a = t.index;
    return a >= i.length ? {
      value: void 0,
      done: !0
    } : (e = On(i, a), t.index += e.length, {
      value: e,
      done: !1
    });
  });
  var Xn = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    },
    Rn = ce("iterator"),
    Bn = ce("toStringTag"),
    kn = Ln.values;
  for (var Un in Xn) {
    var Vn = y[Un],
      Wn = Vn && Vn.prototype;
    if (Wn) {
      if (Wn[Rn] !== kn) try {
        D(Wn, Rn, kn);
      } catch (e) {
        Wn[Rn] = kn;
      }
      if (Wn[Bn] || D(Wn, Bn, Un), Xn[Un]) for (var Fn in Ln) {
        if (Wn[Fn] !== Ln[Fn]) try {
          D(Wn, Fn, Ln[Fn]);
        } catch (e) {
          Wn[Fn] = Ln[Fn];
        }
      }
    }
  }
  var Zn = ce("iterator"),
    Kn = !C(function () {
      var e = new URL("b?a=1&b=2&c=3", "http://a"),
        t = e.searchParams,
        i = "";
      return e.pathname = "c%20d", t.forEach(function (e, a) {
        t.delete("b"), i += a + e;
      }), !t.sort || "http://a/c%20d?a=1&c=3" !== e.href || "3" !== t.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t[Zn] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://тест").host || "#%D0%B1" !== new URL("http://a#б").hash || "a1c3" !== i || "x" !== new URL("http://x", void 0).host;
    }),
    _n = Object.assign,
    zn = Object.defineProperty,
    jn = !_n || C(function () {
      if (G && 1 !== _n({
        b: 1
      }, _n(zn({}, "a", {
        enumerable: !0,
        get: function get() {
          zn(this, "b", {
            value: 3,
            enumerable: !1
          });
        }
      }), {
        b: 2
      })).b) return !0;
      var e = {},
        t = {},
        i = Symbol(),
        a = "abcdefghijklmnopqrst";
      return e[i] = 7, a.split("").forEach(function (e) {
        t[e] = e;
      }), 7 != _n({}, e)[i] || _r(_n({}, t)).join("") != a;
    }) ? function (e, t) {
      for (var i = U(e), a = arguments.length, o = 1, r = at.f, n = Xe.f; a > o;) {
        for (var s, c = Be(arguments[o++]), l = r ? _r(c).concat(r(c)) : _r(c), u = l.length, d = 0; u > d;) {
          s = l[d++], G && !n.call(c, s) || (i[s] = c[s]);
        }
      }
      return i;
    } : _n,
    Yn = function Yn(e, t, i, a) {
      try {
        return a ? t(I(i)[0], i[1]) : t(i);
      } catch (t) {
        throw xt(e), t;
      }
    },
    qn = function qn(e) {
      var t,
        i,
        a,
        o,
        r,
        n,
        s = U(e),
        c = "function" == typeof this ? this : Array,
        l = arguments.length,
        u = l > 1 ? arguments[1] : void 0,
        d = void 0 !== u,
        h = It(s),
        m = 0;
      if (d && (u = Mt(u, l > 2 ? arguments[2] : void 0, 2)), null == h || c == Array && At(h)) for (i = new c(t = _e(s.length)); t > m; m++) {
        n = d ? u(s[m], m) : s[m], Io(i, m, n);
      } else for (r = (o = h.call(s)).next, i = new c(); !(a = r.call(o)).done; m++) {
        n = d ? Yn(o, u, [a.value, m], !0) : a.value, Io(i, m, n);
      }
      return i.length = m, i;
    },
    Qn = 2147483647,
    Jn = /[^\0-\u007E]/,
    $n = /[.\u3002\uFF0E\uFF61]/g,
    es = "Overflow: input needs wider integers to process",
    ts = Math.floor,
    is = String.fromCharCode,
    as = function as(e) {
      return e + 22 + 75 * (e < 26);
    },
    os = function os(e, t, i) {
      var a = 0;
      for (e = i ? ts(e / 700) : e >> 1, e += ts(e / t); e > 455; a += 36) {
        e = ts(e / 35);
      }
      return ts(a + 36 * e / (e + 38));
    },
    rs = function rs(e) {
      var t,
        i,
        a = [],
        o = (e = function (e) {
          for (var t = [], i = 0, a = e.length; i < a;) {
            var o = e.charCodeAt(i++);
            if (o >= 55296 && o <= 56319 && i < a) {
              var r = e.charCodeAt(i++);
              56320 == (64512 & r) ? t.push(((1023 & o) << 10) + (1023 & r) + 65536) : (t.push(o), i--);
            } else t.push(o);
          }
          return t;
        }(e)).length,
        r = 128,
        n = 0,
        s = 72;
      for (t = 0; t < e.length; t++) {
        (i = e[t]) < 128 && a.push(is(i));
      }
      var c = a.length,
        l = c;
      for (c && a.push("-"); l < o;) {
        var u = Qn;
        for (t = 0; t < e.length; t++) {
          (i = e[t]) >= r && i < u && (u = i);
        }
        var d = l + 1;
        if (u - r > ts((Qn - n) / d)) throw RangeError(es);
        for (n += (u - r) * d, r = u, t = 0; t < e.length; t++) {
          if ((i = e[t]) < r && ++n > Qn) throw RangeError(es);
          if (i == r) {
            for (var h = n, m = 36;; m += 36) {
              var S = m <= s ? 1 : m >= s + 26 ? 26 : m - s;
              if (h < S) break;
              var p = h - S,
                T = 36 - S;
              a.push(is(as(S + p % T))), h = ts(p / T);
            }
            a.push(is(as(h))), s = os(n, d, l == c), n = 0, ++l;
          }
        }
        ++n, ++r;
      }
      return a.join("");
    },
    ns = function ns(e) {
      var t = It(e);
      if ("function" != typeof t) throw TypeError(String(e) + " is not iterable");
      return I(t.call(e));
    },
    ss = Q("fetch"),
    cs = Q("Headers"),
    ls = ce("iterator"),
    us = "URLSearchParams",
    ds = "URLSearchParamsIterator",
    hs = Ee.set,
    ms = Ee.getterFor(us),
    Ss = Ee.getterFor(ds),
    ps = /\+/g,
    Ts = Array(4),
    vs = function vs(e) {
      return Ts[e - 1] || (Ts[e - 1] = RegExp("((?:%[\\da-f]{2}){" + e + "})", "gi"));
    },
    fs = function fs(e) {
      try {
        return decodeURIComponent(e);
      } catch (t) {
        return e;
      }
    },
    bs = function bs(e) {
      var t = e.replace(ps, " "),
        i = 4;
      try {
        return decodeURIComponent(t);
      } catch (e) {
        for (; i;) {
          t = t.replace(vs(i--), fs);
        }
        return t;
      }
    },
    gs = /[!'()~]|%20/g,
    ys = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+"
    },
    Cs = function Cs(e) {
      return ys[e];
    },
    Gs = function Gs(e) {
      return encodeURIComponent(e).replace(gs, Cs);
    },
    Hs = function Hs(e, t) {
      if (t) for (var i, a, o = t.split("&"), r = 0; r < o.length;) {
        (i = o[r++]).length && (a = i.split("="), e.push({
          key: bs(a.shift()),
          value: bs(a.join("="))
        }));
      }
    },
    ws = function ws(e) {
      this.entries.length = 0, Hs(this.entries, e);
    },
    As = function As(e, t) {
      if (e < t) throw TypeError("Not enough arguments");
    },
    Ms = fn(function (e, t) {
      hs(this, {
        type: ds,
        iterator: ns(ms(e).entries),
        kind: t
      });
    }, "Iterator", function () {
      var e = Ss(this),
        t = e.kind,
        i = e.iterator.next(),
        a = i.value;
      return i.done || (i.value = "keys" === t ? a.key : "values" === t ? a.value : [a.key, a.value]), i;
    }),
    Es = function Es() {
      Ct(this, Es, us);
      var e,
        t,
        i,
        a,
        o,
        r,
        n,
        s,
        c,
        l = arguments.length > 0 ? arguments[0] : void 0,
        u = this,
        d = [];
      if (hs(u, {
        type: us,
        entries: d,
        updateURL: function updateURL() {},
        updateSearchParams: ws
      }), void 0 !== l) if (H(l)) {
        if ("function" == typeof (e = It(l))) for (i = (t = e.call(l)).next; !(a = i.call(t)).done;) {
          if ((n = (r = (o = ns(I(a.value))).next).call(o)).done || (s = r.call(o)).done || !r.call(o).done) throw TypeError("Expected sequence with length 2");
          d.push({
            key: n.value + "",
            value: s.value + ""
          });
        } else for (c in l) {
          W(l, c) && d.push({
            key: c,
            value: l[c] + ""
          });
        }
      } else Hs(d, "string" == typeof l ? "?" === l.charAt(0) ? l.slice(1) : l : l + "");
    },
    Is = Es.prototype;
  Tt(Is, {
    append: function append(e, t) {
      As(arguments.length, 2);
      var i = ms(this);
      i.entries.push({
        key: e + "",
        value: t + ""
      }), i.updateURL();
    },
    delete: function _delete(e) {
      As(arguments.length, 1);
      for (var t = ms(this), i = t.entries, a = e + "", o = 0; o < i.length;) {
        i[o].key === a ? i.splice(o, 1) : o++;
      }
      t.updateURL();
    },
    get: function get(e) {
      As(arguments.length, 1);
      for (var t = ms(this).entries, i = e + "", a = 0; a < t.length; a++) {
        if (t[a].key === i) return t[a].value;
      }
      return null;
    },
    getAll: function getAll(e) {
      As(arguments.length, 1);
      for (var t = ms(this).entries, i = e + "", a = [], o = 0; o < t.length; o++) {
        t[o].key === i && a.push(t[o].value);
      }
      return a;
    },
    has: function has(e) {
      As(arguments.length, 1);
      for (var t = ms(this).entries, i = e + "", a = 0; a < t.length;) {
        if (t[a++].key === i) return !0;
      }
      return !1;
    },
    set: function set(e, t) {
      As(arguments.length, 1);
      for (var i, a = ms(this), o = a.entries, r = !1, n = e + "", s = t + "", c = 0; c < o.length; c++) {
        (i = o[c]).key === n && (r ? o.splice(c--, 1) : (r = !0, i.value = s));
      }
      r || o.push({
        key: n,
        value: s
      }), a.updateURL();
    },
    sort: function sort() {
      var e,
        t,
        i,
        a = ms(this),
        o = a.entries,
        r = o.slice();
      for (o.length = 0, i = 0; i < r.length; i++) {
        for (e = r[i], t = 0; t < i; t++) {
          if (o[t].key > e.key) {
            o.splice(t, 0, e);
            break;
          }
        }
        t === i && o.push(e);
      }
      a.updateURL();
    },
    forEach: function forEach(e) {
      for (var t, i = ms(this).entries, a = Mt(e, arguments.length > 1 ? arguments[1] : void 0, 3), o = 0; o < i.length;) {
        a((t = i[o++]).value, t.key, this);
      }
    },
    keys: function keys() {
      return new Ms(this, "keys");
    },
    values: function values() {
      return new Ms(this, "values");
    },
    entries: function entries() {
      return new Ms(this, "entries");
    }
  }, {
    enumerable: !0
  }), Ie(Is, ls, Is.entries), Ie(Is, "toString", function () {
    for (var e, t = ms(this).entries, i = [], a = 0; a < t.length;) {
      e = t[a++], i.push(Gs(e.key) + "=" + Gs(e.value));
    }
    return i.join("&");
  }, {
    enumerable: !0
  }), bt(Es, us), St({
    global: !0,
    forced: !Kn
  }, {
    URLSearchParams: Es
  }), Kn || "function" != typeof ss || "function" != typeof cs || St({
    global: !0,
    enumerable: !0,
    forced: !0
  }, {
    fetch: function fetch(e) {
      var t,
        i,
        a,
        o = [e];
      return arguments.length > 1 && (H(t = arguments[1]) && (i = t.body, Oe(i) === us && ((a = t.headers ? new cs(t.headers) : new cs()).has("content-type") || a.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t = Jr(t, {
        body: P(0, String(i)),
        headers: P(0, a)
      }))), o.push(t)), ss.apply(this, o);
    }
  });
  var xs,
    Ls = {
      URLSearchParams: Es,
      getState: ms
    },
    Os = lo.codeAt,
    Ps = y.URL,
    Ds = Ls.URLSearchParams,
    Ns = Ls.getState,
    Xs = Ee.set,
    Rs = Ee.getterFor("URL"),
    Bs = Math.floor,
    ks = Math.pow,
    Us = "Invalid scheme",
    Vs = "Invalid host",
    Ws = "Invalid port",
    Fs = /[A-Za-z]/,
    Zs = /[\d+-.A-Za-z]/,
    Ks = /\d/,
    _s = /^(0x|0X)/,
    zs = /^[0-7]+$/,
    js = /^\d+$/,
    Ys = /^[\dA-Fa-f]+$/,
    qs = /[\0\t\n\r #%/:?@[\\]]/,
    Qs = /[\0\t\n\r #/:?@[\\]]/,
    Js = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
    $s = /[\t\n\r]/g,
    ec = function ec(e, t) {
      var i, a, o;
      if ("[" == t.charAt(0)) {
        if ("]" != t.charAt(t.length - 1)) return Vs;
        if (!(i = ic(t.slice(1, -1)))) return Vs;
        e.host = i;
      } else if (uc(e)) {
        if (t = function (e) {
          var t,
            i,
            a = [],
            o = e.toLowerCase().replace($n, ".").split(".");
          for (t = 0; t < o.length; t++) {
            i = o[t], a.push(Jn.test(i) ? "xn--" + rs(i) : i);
          }
          return a.join(".");
        }(t), qs.test(t)) return Vs;
        if (null === (i = tc(t))) return Vs;
        e.host = i;
      } else {
        if (Qs.test(t)) return Vs;
        for (i = "", a = qn(t), o = 0; o < a.length; o++) {
          i += cc(a[o], oc);
        }
        e.host = i;
      }
    },
    tc = function tc(e) {
      var t,
        i,
        a,
        o,
        r,
        n,
        s,
        c = e.split(".");
      if (c.length && "" == c[c.length - 1] && c.pop(), (t = c.length) > 4) return e;
      for (i = [], a = 0; a < t; a++) {
        if ("" == (o = c[a])) return e;
        if (r = 10, o.length > 1 && "0" == o.charAt(0) && (r = _s.test(o) ? 16 : 8, o = o.slice(8 == r ? 1 : 2)), "" === o) n = 0;else {
          if (!(10 == r ? js : 8 == r ? zs : Ys).test(o)) return e;
          n = parseInt(o, r);
        }
        i.push(n);
      }
      for (a = 0; a < t; a++) {
        if (n = i[a], a == t - 1) {
          if (n >= ks(256, 5 - t)) return null;
        } else if (n > 255) return null;
      }
      for (s = i.pop(), a = 0; a < i.length; a++) {
        s += i[a] * ks(256, 3 - a);
      }
      return s;
    },
    ic = function ic(e) {
      var t,
        i,
        a,
        o,
        r,
        n,
        s,
        c = [0, 0, 0, 0, 0, 0, 0, 0],
        l = 0,
        u = null,
        d = 0,
        h = function h() {
          return e.charAt(d);
        };
      if (":" == h()) {
        if (":" != e.charAt(1)) return;
        d += 2, u = ++l;
      }
      for (; h();) {
        if (8 == l) return;
        if (":" != h()) {
          for (t = i = 0; i < 4 && Ys.test(h());) {
            t = 16 * t + parseInt(h(), 16), d++, i++;
          }
          if ("." == h()) {
            if (0 == i) return;
            if (d -= i, l > 6) return;
            for (a = 0; h();) {
              if (o = null, a > 0) {
                if (!("." == h() && a < 4)) return;
                d++;
              }
              if (!Ks.test(h())) return;
              for (; Ks.test(h());) {
                if (r = parseInt(h(), 10), null === o) o = r;else {
                  if (0 == o) return;
                  o = 10 * o + r;
                }
                if (o > 255) return;
                d++;
              }
              c[l] = 256 * c[l] + o, 2 != ++a && 4 != a || l++;
            }
            if (4 != a) return;
            break;
          }
          if (":" == h()) {
            if (d++, !h()) return;
          } else if (h()) return;
          c[l++] = t;
        } else {
          if (null !== u) return;
          d++, u = ++l;
        }
      }
      if (null !== u) for (n = l - u, l = 7; 0 != l && n > 0;) {
        s = c[l], c[l--] = c[u + n - 1], c[u + --n] = s;
      } else if (8 != l) return;
      return c;
    },
    ac = function ac(e) {
      var t, i, a, o;
      if ("number" == typeof e) {
        for (t = [], i = 0; i < 4; i++) {
          t.unshift(e % 256), e = Bs(e / 256);
        }
        return t.join(".");
      }
      if ("object" == typeof e) {
        for (t = "", a = function (e) {
          for (var t = null, i = 1, a = null, o = 0, r = 0; r < 8; r++) {
            0 !== e[r] ? (o > i && (t = a, i = o), a = null, o = 0) : (null === a && (a = r), ++o);
          }
          return o > i && (t = a, i = o), t;
        }(e), i = 0; i < 8; i++) {
          o && 0 === e[i] || (o && (o = !1), a === i ? (t += i ? ":" : "::", o = !0) : (t += e[i].toString(16), i < 7 && (t += ":")));
        }
        return "[" + t + "]";
      }
      return e;
    },
    oc = {},
    rc = jn({}, oc, {
      " ": 1,
      '"': 1,
      "<": 1,
      ">": 1,
      "`": 1
    }),
    nc = jn({}, rc, {
      "#": 1,
      "?": 1,
      "{": 1,
      "}": 1
    }),
    sc = jn({}, nc, {
      "/": 1,
      ":": 1,
      ";": 1,
      "=": 1,
      "@": 1,
      "[": 1,
      "\\": 1,
      "]": 1,
      "^": 1,
      "|": 1
    }),
    cc = function cc(e, t) {
      var i = Os(e, 0);
      return i > 32 && i < 127 && !W(t, e) ? e : encodeURIComponent(e);
    },
    lc = {
      ftp: 21,
      file: null,
      http: 80,
      https: 443,
      ws: 80,
      wss: 443
    },
    uc = function uc(e) {
      return W(lc, e.scheme);
    },
    dc = function dc(e) {
      return "" != e.username || "" != e.password;
    },
    hc = function hc(e) {
      return !e.host || e.cannotBeABaseURL || "file" == e.scheme;
    },
    mc = function mc(e, t) {
      var i;
      return 2 == e.length && Fs.test(e.charAt(0)) && (":" == (i = e.charAt(1)) || !t && "|" == i);
    },
    Sc = function Sc(e) {
      var t;
      return e.length > 1 && mc(e.slice(0, 2)) && (2 == e.length || "/" === (t = e.charAt(2)) || "\\" === t || "?" === t || "#" === t);
    },
    pc = function pc(e) {
      var t = e.path,
        i = t.length;
      !i || "file" == e.scheme && 1 == i && mc(t[0], !0) || t.pop();
    },
    Tc = function Tc(e) {
      return "." === e || "%2e" === e.toLowerCase();
    },
    vc = {},
    fc = {},
    bc = {},
    gc = {},
    yc = {},
    Cc = {},
    Gc = {},
    Hc = {},
    wc = {},
    Ac = {},
    Mc = {},
    Ec = {},
    Ic = {},
    xc = {},
    Lc = {},
    Oc = {},
    Pc = {},
    Dc = {},
    Nc = {},
    Xc = {},
    Rc = {},
    Bc = function Bc(e, t, i, a) {
      var o,
        r,
        n,
        s,
        c,
        l = i || vc,
        u = 0,
        d = "",
        h = !1,
        m = !1,
        S = !1;
      for (i || (e.scheme = "", e.username = "", e.password = "", e.host = null, e.port = null, e.path = [], e.query = null, e.fragment = null, e.cannotBeABaseURL = !1, t = t.replace(Js, "")), t = t.replace($s, ""), o = qn(t); u <= o.length;) {
        switch (r = o[u], l) {
          case vc:
            if (!r || !Fs.test(r)) {
              if (i) return Us;
              l = bc;
              continue;
            }
            d += r.toLowerCase(), l = fc;
            break;
          case fc:
            if (r && (Zs.test(r) || "+" == r || "-" == r || "." == r)) d += r.toLowerCase();else {
              if (":" != r) {
                if (i) return Us;
                d = "", l = bc, u = 0;
                continue;
              }
              if (i && (uc(e) != W(lc, d) || "file" == d && (dc(e) || null !== e.port) || "file" == e.scheme && !e.host)) return;
              if (e.scheme = d, i) return void (uc(e) && lc[e.scheme] == e.port && (e.port = null));
              d = "", "file" == e.scheme ? l = xc : uc(e) && a && a.scheme == e.scheme ? l = gc : uc(e) ? l = Hc : "/" == o[u + 1] ? (l = yc, u++) : (e.cannotBeABaseURL = !0, e.path.push(""), l = Nc);
            }
            break;
          case bc:
            if (!a || a.cannotBeABaseURL && "#" != r) return Us;
            if (a.cannotBeABaseURL && "#" == r) {
              e.scheme = a.scheme, e.path = a.path.slice(), e.query = a.query, e.fragment = "", e.cannotBeABaseURL = !0, l = Rc;
              break;
            }
            l = "file" == a.scheme ? xc : Cc;
            continue;
          case gc:
            if ("/" != r || "/" != o[u + 1]) {
              l = Cc;
              continue;
            }
            l = wc, u++;
            break;
          case yc:
            if ("/" == r) {
              l = Ac;
              break;
            }
            l = Dc;
            continue;
          case Cc:
            if (e.scheme = a.scheme, r == xs) e.username = a.username, e.password = a.password, e.host = a.host, e.port = a.port, e.path = a.path.slice(), e.query = a.query;else if ("/" == r || "\\" == r && uc(e)) l = Gc;else if ("?" == r) e.username = a.username, e.password = a.password, e.host = a.host, e.port = a.port, e.path = a.path.slice(), e.query = "", l = Xc;else {
              if ("#" != r) {
                e.username = a.username, e.password = a.password, e.host = a.host, e.port = a.port, e.path = a.path.slice(), e.path.pop(), l = Dc;
                continue;
              }
              e.username = a.username, e.password = a.password, e.host = a.host, e.port = a.port, e.path = a.path.slice(), e.query = a.query, e.fragment = "", l = Rc;
            }
            break;
          case Gc:
            if (!uc(e) || "/" != r && "\\" != r) {
              if ("/" != r) {
                e.username = a.username, e.password = a.password, e.host = a.host, e.port = a.port, l = Dc;
                continue;
              }
              l = Ac;
            } else l = wc;
            break;
          case Hc:
            if (l = wc, "/" != r || "/" != d.charAt(u + 1)) continue;
            u++;
            break;
          case wc:
            if ("/" != r && "\\" != r) {
              l = Ac;
              continue;
            }
            break;
          case Ac:
            if ("@" == r) {
              h && (d = "%40" + d), h = !0, n = qn(d);
              for (var p = 0; p < n.length; p++) {
                var T = n[p];
                if (":" != T || S) {
                  var v = cc(T, sc);
                  S ? e.password += v : e.username += v;
                } else S = !0;
              }
              d = "";
            } else if (r == xs || "/" == r || "?" == r || "#" == r || "\\" == r && uc(e)) {
              if (h && "" == d) return "Invalid authority";
              u -= qn(d).length + 1, d = "", l = Mc;
            } else d += r;
            break;
          case Mc:
          case Ec:
            if (i && "file" == e.scheme) {
              l = Oc;
              continue;
            }
            if (":" != r || m) {
              if (r == xs || "/" == r || "?" == r || "#" == r || "\\" == r && uc(e)) {
                if (uc(e) && "" == d) return Vs;
                if (i && "" == d && (dc(e) || null !== e.port)) return;
                if (s = ec(e, d)) return s;
                if (d = "", l = Pc, i) return;
                continue;
              }
              "[" == r ? m = !0 : "]" == r && (m = !1), d += r;
            } else {
              if ("" == d) return Vs;
              if (s = ec(e, d)) return s;
              if (d = "", l = Ic, i == Ec) return;
            }
            break;
          case Ic:
            if (!Ks.test(r)) {
              if (r == xs || "/" == r || "?" == r || "#" == r || "\\" == r && uc(e) || i) {
                if ("" != d) {
                  var f = parseInt(d, 10);
                  if (f > 65535) return Ws;
                  e.port = uc(e) && f === lc[e.scheme] ? null : f, d = "";
                }
                if (i) return;
                l = Pc;
                continue;
              }
              return Ws;
            }
            d += r;
            break;
          case xc:
            if (e.scheme = "file", "/" == r || "\\" == r) l = Lc;else {
              if (!a || "file" != a.scheme) {
                l = Dc;
                continue;
              }
              if (r == xs) e.host = a.host, e.path = a.path.slice(), e.query = a.query;else if ("?" == r) e.host = a.host, e.path = a.path.slice(), e.query = "", l = Xc;else {
                if ("#" != r) {
                  Sc(o.slice(u).join("")) || (e.host = a.host, e.path = a.path.slice(), pc(e)), l = Dc;
                  continue;
                }
                e.host = a.host, e.path = a.path.slice(), e.query = a.query, e.fragment = "", l = Rc;
              }
            }
            break;
          case Lc:
            if ("/" == r || "\\" == r) {
              l = Oc;
              break;
            }
            a && "file" == a.scheme && !Sc(o.slice(u).join("")) && (mc(a.path[0], !0) ? e.path.push(a.path[0]) : e.host = a.host), l = Dc;
            continue;
          case Oc:
            if (r == xs || "/" == r || "\\" == r || "?" == r || "#" == r) {
              if (!i && mc(d)) l = Dc;else if ("" == d) {
                if (e.host = "", i) return;
                l = Pc;
              } else {
                if (s = ec(e, d)) return s;
                if ("localhost" == e.host && (e.host = ""), i) return;
                d = "", l = Pc;
              }
              continue;
            }
            d += r;
            break;
          case Pc:
            if (uc(e)) {
              if (l = Dc, "/" != r && "\\" != r) continue;
            } else if (i || "?" != r) {
              if (i || "#" != r) {
                if (r != xs && (l = Dc, "/" != r)) continue;
              } else e.fragment = "", l = Rc;
            } else e.query = "", l = Xc;
            break;
          case Dc:
            if (r == xs || "/" == r || "\\" == r && uc(e) || !i && ("?" == r || "#" == r)) {
              if (".." === (c = (c = d).toLowerCase()) || "%2e." === c || ".%2e" === c || "%2e%2e" === c ? (pc(e), "/" == r || "\\" == r && uc(e) || e.path.push("")) : Tc(d) ? "/" == r || "\\" == r && uc(e) || e.path.push("") : ("file" == e.scheme && !e.path.length && mc(d) && (e.host && (e.host = ""), d = d.charAt(0) + ":"), e.path.push(d)), d = "", "file" == e.scheme && (r == xs || "?" == r || "#" == r)) for (; e.path.length > 1 && "" === e.path[0];) {
                e.path.shift();
              }
              "?" == r ? (e.query = "", l = Xc) : "#" == r && (e.fragment = "", l = Rc);
            } else d += cc(r, nc);
            break;
          case Nc:
            "?" == r ? (e.query = "", l = Xc) : "#" == r ? (e.fragment = "", l = Rc) : r != xs && (e.path[0] += cc(r, oc));
            break;
          case Xc:
            i || "#" != r ? r != xs && ("'" == r && uc(e) ? e.query += "%27" : e.query += "#" == r ? "%23" : cc(r, oc)) : (e.fragment = "", l = Rc);
            break;
          case Rc:
            r != xs && (e.fragment += cc(r, rc));
        }
        u++;
      }
    },
    kc = function kc(e) {
      var t,
        i,
        a = Ct(this, kc, "URL"),
        o = arguments.length > 1 ? arguments[1] : void 0,
        r = String(e),
        n = Xs(a, {
          type: "URL"
        });
      if (void 0 !== o) if (o instanceof kc) t = Rs(o);else if (i = Bc(t = {}, String(o))) throw TypeError(i);
      if (i = Bc(n, r, null, t)) throw TypeError(i);
      var s = n.searchParams = new Ds(),
        c = Ns(s);
      c.updateSearchParams(n.query), c.updateURL = function () {
        n.query = String(s) || null;
      }, G || (a.href = Vc.call(a), a.origin = Wc.call(a), a.protocol = Fc.call(a), a.username = Zc.call(a), a.password = Kc.call(a), a.host = _c.call(a), a.hostname = zc.call(a), a.port = jc.call(a), a.pathname = Yc.call(a), a.search = qc.call(a), a.searchParams = Qc.call(a), a.hash = Jc.call(a));
    },
    Uc = kc.prototype,
    Vc = function Vc() {
      var e = Rs(this),
        t = e.scheme,
        i = e.username,
        a = e.password,
        o = e.host,
        r = e.port,
        n = e.path,
        s = e.query,
        c = e.fragment,
        l = t + ":";
      return null !== o ? (l += "//", dc(e) && (l += i + (a ? ":" + a : "") + "@"), l += ac(o), null !== r && (l += ":" + r)) : "file" == t && (l += "//"), l += e.cannotBeABaseURL ? n[0] : n.length ? "/" + n.join("/") : "", null !== s && (l += "?" + s), null !== c && (l += "#" + c), l;
    },
    Wc = function Wc() {
      var e = Rs(this),
        t = e.scheme,
        i = e.port;
      if ("blob" == t) try {
        return new kc(t.path[0]).origin;
      } catch (e) {
        return "null";
      }
      return "file" != t && uc(e) ? t + "://" + ac(e.host) + (null !== i ? ":" + i : "") : "null";
    },
    Fc = function Fc() {
      return Rs(this).scheme + ":";
    },
    Zc = function Zc() {
      return Rs(this).username;
    },
    Kc = function Kc() {
      return Rs(this).password;
    },
    _c = function _c() {
      var e = Rs(this),
        t = e.host,
        i = e.port;
      return null === t ? "" : null === i ? ac(t) : ac(t) + ":" + i;
    },
    zc = function zc() {
      var e = Rs(this).host;
      return null === e ? "" : ac(e);
    },
    jc = function jc() {
      var e = Rs(this).port;
      return null === e ? "" : String(e);
    },
    Yc = function Yc() {
      var e = Rs(this),
        t = e.path;
      return e.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
    },
    qc = function qc() {
      var e = Rs(this).query;
      return e ? "?" + e : "";
    },
    Qc = function Qc() {
      return Rs(this).searchParams;
    },
    Jc = function Jc() {
      var e = Rs(this).fragment;
      return e ? "#" + e : "";
    },
    $c = function $c(e, t) {
      return {
        get: e,
        set: t,
        configurable: !0,
        enumerable: !0
      };
    };
  if (G && zr(Uc, {
    href: $c(Vc, function (e) {
      var t = Rs(this),
        i = String(e),
        a = Bc(t, i);
      if (a) throw TypeError(a);
      Ns(t.searchParams).updateSearchParams(t.query);
    }),
    origin: $c(Wc),
    protocol: $c(Fc, function (e) {
      var t = Rs(this);
      Bc(t, String(e) + ":", vc);
    }),
    username: $c(Zc, function (e) {
      var t = Rs(this),
        i = qn(String(e));
      if (!hc(t)) {
        t.username = "";
        for (var a = 0; a < i.length; a++) {
          t.username += cc(i[a], sc);
        }
      }
    }),
    password: $c(Kc, function (e) {
      var t = Rs(this),
        i = qn(String(e));
      if (!hc(t)) {
        t.password = "";
        for (var a = 0; a < i.length; a++) {
          t.password += cc(i[a], sc);
        }
      }
    }),
    host: $c(_c, function (e) {
      var t = Rs(this);
      t.cannotBeABaseURL || Bc(t, String(e), Mc);
    }),
    hostname: $c(zc, function (e) {
      var t = Rs(this);
      t.cannotBeABaseURL || Bc(t, String(e), Ec);
    }),
    port: $c(jc, function (e) {
      var t = Rs(this);
      hc(t) || ("" == (e = String(e)) ? t.port = null : Bc(t, e, Ic));
    }),
    pathname: $c(Yc, function (e) {
      var t = Rs(this);
      t.cannotBeABaseURL || (t.path = [], Bc(t, e + "", Pc));
    }),
    search: $c(qc, function (e) {
      var t = Rs(this);
      "" == (e = String(e)) ? t.query = null : ("?" == e.charAt(0) && (e = e.slice(1)), t.query = "", Bc(t, e, Xc)), Ns(t.searchParams).updateSearchParams(t.query);
    }),
    searchParams: $c(Qc),
    hash: $c(Jc, function (e) {
      var t = Rs(this);
      "" != (e = String(e)) ? ("#" == e.charAt(0) && (e = e.slice(1)), t.fragment = "", Bc(t, e, Rc)) : t.fragment = null;
    })
  }), Ie(Uc, "toJSON", function () {
    return Vc.call(this);
  }, {
    enumerable: !0
  }), Ie(Uc, "toString", function () {
    return Vc.call(this);
  }, {
    enumerable: !0
  }), Ps) {
    var el = Ps.createObjectURL,
      tl = Ps.revokeObjectURL;
    el && Ie(kc, "createObjectURL", function (e) {
      return el.apply(Ps, arguments);
    }), tl && Ie(kc, "revokeObjectURL", function (e) {
      return tl.apply(Ps, arguments);
    });
  }
  bt(kc, "URL"), St({
    global: !0,
    forced: !Kn,
    sham: !G
  }, {
    URL: kc
  });
  var il,
    al,
    ol,
    rl = ce("species"),
    nl = function nl(e, t) {
      var i;
      return Eo(e) && ("function" != typeof (i = e.constructor) || i !== Array && !Eo(i.prototype) ? H(i) && null === (i = i[rl]) && (i = void 0) : i = void 0), new (void 0 === i ? Array : i)(0 === t ? 0 : t);
    },
    sl = ce("isConcatSpreadable"),
    cl = 9007199254740991,
    ll = "Maximum allowed index exceeded",
    ul = ie >= 51 || !C(function () {
      var e = [];
      return e[sl] = !1, e.concat()[0] !== e;
    }),
    dl = Lo("concat"),
    hl = function hl(e) {
      if (!H(e)) return !1;
      var t = e[sl];
      return void 0 !== t ? !!t : Eo(e);
    };
  function ml() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
      var t = 16 * Math.random() | 0;
      return ("x" === e ? t : 3 & t | 8).toString(16);
    });
  }
  St({
    target: "Array",
    proto: !0,
    forced: !ul || !dl
  }, {
    concat: function concat(e) {
      var t,
        i,
        a,
        o,
        r,
        n = U(this),
        s = nl(n, 0),
        c = 0;
      for (t = -1, a = arguments.length; t < a; t++) {
        if (hl(r = -1 === t ? n : arguments[t])) {
          if (c + (o = _e(r.length)) > cl) throw TypeError(ll);
          for (i = 0; i < o; i++, c++) {
            i in r && Io(s, c, r[i]);
          }
        } else {
          if (c >= cl) throw TypeError(ll);
          Io(s, c++, r);
        }
      }
      return s.length = c, s;
    }
  }), function (e) {
    e.AJAX_ERROR = "ajax", e.RESOURCE_ERROR = "resource", e.VUE_ERROR = "vue", e.PROMISE_ERROR = "promise", e.JS_ERROR = "js", e.UNKNOWN_ERROR = "unknown";
  }(il || (il = {})), function (e) {
    e.INFO = "Info", e.WARNING = "Warning", e.ERROR = "Error";
  }(al || (al = {})), function (e) {
    e.ERROR = "/browser/errorLog", e.ERRORS = "/browser/errorLogs", e.PERF = "/browser/perfData", e.SEGMENT = "/v3/segment", e.SEGMENTS = "/v3/segments";
  }(ol || (ol = {}));
  var Sl,
    pl = "Http",
    Tl = "Exit";
  !function (e) {
    e[e.OPENING = 0] = "OPENING", e[e.OPENED = 1] = "OPENED", e[e.DONE = 4] = "DONE";
  }(Sl || (Sl = {}));
  var vl = "<browser>";
  function fl() {
    var e = window.fetch;
    window.__fetch_ = e, window.fetch = function (t, i) {
      var a,
        o = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Mo(Object(i), !0).forEach(function (t) {
              Ao(e, t, i[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Mo(Object(i)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
            });
          }
          return e;
        }({
          headers: {}
        }, i),
        r = {
          traceId: "",
          service: c.service + vl,
          spans: [],
          serviceInstance: c.serviceVersion,
          traceSegmentId: ""
        },
        n = {};
      if (t.includes("http://") || t.includes("https://")) try {
        n = new URL(t);
      } catch (e) {
        n = t;
      } else n = t;
      var s = ml(),
        l = ml(),
        u = {
          startTime: new Date().getTime(),
          traceId: s,
          traceSegmentId: l
        },
        d = String(Zr(s)),
        h = String(Zr(l)),
        m = String(Zr(r.service)),
        S = String(Zr(r.serviceInstance)),
        p = String(Zr(Ra())),
        T = String(Zr((null === (a = n) || void 0 === a ? void 0 : a.host) || n)),
        v = r.spans.length,
        f = "".concat(1, "-", d, "-").concat(h, "-").concat(v, "-").concat(m, "-").concat(S, "-").concat(p, "-").concat(T);
      return c.isTrace && (o.headers["".concat(c.namespace)] = f), e(t, o).then(function (e) {
        return Na("fetchReadyStateChange", {
          segment: r,
          url: t,
          options: i,
          response: e,
          segCollector: u
        }), e;
      });
    };
  }
  function bl() {
    var e = window.XMLHttpRequest;
    window.__oXMLHttpRequest_ = e;
    var t = XMLHttpRequest.prototype.send,
      i = XMLHttpRequest.prototype.open,
      a = XMLHttpRequest.prototype.setRequestHeader;
    function o(e) {
      Na("xhrReadyStateChange", this);
    }
    window.XMLHttpRequest = function () {
      var r = new e();
      return r.Config = {
        getOpenParams: [],
        getSendConfig: [],
        getHeader: {}
      }, r.addEventListener("readystatechange", function () {
        o.call(this, "xhrReadyStateChange");
      }, !1), r.setRequestHeader = function (e, t) {
        try {
          a.apply(this, arguments), this.Config.getHeader[e] = t;
        } catch (e) {
          return null;
        }
      }, r.open = function (e, t) {
        return this.Config.getOpenParams = arguments, this.Config.getHeader.method = e, i.apply(this, arguments);
      }, r.send = function (e) {
        return this.Config.getSendParams = arguments, t.apply(this, arguments);
      }, r;
    };
  }
  var gl = function () {
    function e(e, t) {
      this.url = "", this.type = e, this.url = t, "SEGMENTS" === e && (this.url.indexOf("?") > 0 ? this.url = t + "&uuid=" + c.serviceId : this.url = t + "?uuid=" + c.serviceId);
    }
    return e.prototype.sendByXhr = function (e) {
      return r(this, void 0, void 0, function () {
        var t, i, a, o;
        return n(this, function (r) {
          switch (r.label) {
            case 0:
              return delete e.collector, this.url ? [4, ma()] : [2];
            case 1:
              return (t = r.sent()) && (i = window.__oXMLHttpRequest_ || window.XMLHttpRequest, (a = new i()).open("post", this.url, !0), a.setRequestHeader("Content-Type", "application/json"), a.setRequestHeader("Authorization", "bearer " + t), a.onreadystatechange = function () {
                4 === a.readyState && 401 === a.status && pa();
              }, o = Array.isArray(e) ? e : [e], a.send(JSON.stringify(d(this.url, o)))), [2];
          }
        });
      });
    }, e.prototype.sendByXhrFormData = function (e) {
      return r(this, void 0, void 0, function () {
        var t, i, a, o, r, s;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              return delete e.collector, this.url ? [4, ma()] : [2];
            case 1:
              return (t = n.sent()) && (i = window.__oXMLHttpRequest_ || window.XMLHttpRequest, (a = new i()).open("post", this.url, !0), a.setRequestHeader("Authorization", "bearer " + t), a.onreadystatechange = function () {
                4 === a.readyState && 401 === a.status && pa();
              }, o = (o = Array.isArray(e) ? e : [e]).map(function (e) {
                return Va(e);
              }), r = new FormData(), s = Ua(d(this.url, o)), r.append("source", new Blob([s], {
                type: "application/x-bzip"
              })), a.send(r)), [2];
          }
        });
      });
    }, e;
  }();
  function yl(e, t) {
    if (0 === t || t >= 400) return !1;
    var i = e;
    try {
      i = JSON.parse(i);
    } catch (e) {}
    return "function" == typeof u("apiCheckStatus") ? !!u("apiCheckStatus")(i) : !0 !== (null == i ? void 0 : i.failed);
  }
  function Cl(e) {
    if ("string" == typeof e) try {
      return new Blob([e]).size;
    } catch (e) {
      console.warn(e);
    }
    return 0;
  }
  function Gl() {
    var e = va.customSegments;
    e.length > 0 && (new gl("CUSTOM", u("customUrl") + "?uuid=" + u("serviceId")).sendByXhrFormData(s(e)), va.customSegments.splice(0, e.length));
  }
  var Hl = new (function () {
    function e() {}
    return e.prototype.register = function (e) {
      var t;
      e ? (t = !0, va.isRegister = t, l(e), Tr(c.enableSPA && "hash" === c.hashRouter ? Oa(location.hash.toLowerCase()) : location.pathname.toLowerCase(), !0), c.enableSPA && this.addListenRouterChange(), c.autoTracePerf && this.sendPerf(), c.isError && this.addListenJs(), this.addListenAjax(), pa(), this.addListenBehavior(), c.isResource && this.sendResource(), c.isCustom && (La("beforeunload", Gl), setInterval(Gl, u("pushIntervalDuration"))), window.__bb = this, this.addListenUnload()) : console.warn("请输入一个options");
    }, e.prototype.sendPerf = function () {
      "complete" === document.readyState ? Or.recordPerf() : window.addEventListener("load", function () {
        Or.recordPerf();
      }, !1), c.enableSPA && (La("hashchange", function () {
        return Or.recordPerf(!1);
      }), La("historystatechanged", function () {
        return Or.recordPerf(!1);
      }));
    }, e.prototype.sendResource = function () {
      Hr.handleResource();
    }, e.prototype.addListenBehavior = function () {
      this.addListenClick();
    }, e.prototype.addListenClick = function () {
      La("click", mr);
    }, e.prototype.addListenRouterChange = function () {
      fr("pushState"), fr("replaceState"), La("hashchange", Sr), La("historystatechanged", pr);
    }, e.prototype.addListenJs = function () {
      La("error", function (e) {
        return Pr.handleErr(e);
      });
    }, e.prototype.addHandler = function (e, t) {
      var i, a;
      null === (a = null === (i = c.handlers[e]) || void 0 === i ? void 0 : i.push) || void 0 === a || a.call(i, t);
    }, e.prototype.addListenAjax = function () {
      !function () {
        var e = this,
          t = [];
        bl(), fl(), window.addEventListener("xhrReadyStateChange", function (e) {
          var i = {
              traceId: "",
              service: c.service + vl,
              spans: [],
              serviceInstance: c.serviceVersion,
              traceSegmentId: ""
            },
            r = e.detail.readyState,
            n = e.detail.Config.getOpenParams,
            s = e.detail.Config.getSendParams,
            l = e.detail.Config.getHeader,
            u = {};
          if (n[1].includes("http://") || n[1].includes("https://")) try {
            u = new URL(n[1]);
          } catch (e) {
            u = n[1];
          } else u = n[1];
          if (r === Sl.OPENED) {
            var d = ml(),
              m = ml();
            t.push({
              event: e.detail,
              startTime: new Date().getTime(),
              traceId: d,
              traceSegmentId: m
            });
            var S = String(Zr(d)),
              p = String(Zr(m)),
              T = String(Zr(i.service)),
              v = String(Zr(i.serviceInstance)),
              f = String(Zr(Ra())),
              b = String(Zr((null == u ? void 0 : u.host) || "")),
              g = "1-" + S + "-" + p + "-" + i.spans.length + "-" + T + "-" + v + "-" + f + "-" + b;
            c.isTrace && e.detail.setRequestHeader("" + c.namespace, g);
          }
          if (r === Sl.DONE) {
            for (var y = 0; y < t.length; y++) {
              if (t[y].event.readyState === Sl.DONE) {
                var C = {};
                if (t[y].event.status) try {
                  C = new URL(t[y].event.responseURL);
                } catch (e) {
                  C = t[y].event.responseURL;
                }
                if (c.isTrace) {
                  var G = {
                    operationName: Ra(),
                    startTime: t[y].startTime,
                    endTime: new Date().getTime(),
                    spanId: i.spans.length,
                    spanLayer: pl,
                    spanType: Tl,
                    isError: 0 === e.detail.status || e.detail.status >= 400,
                    parentSpanId: i.spans.length - 1,
                    componentId: 10001,
                    peer: (null == C ? void 0 : C.host) || "",
                    tags: c.detailMode ? [{
                      key: "http.method",
                      value: n[0]
                    }, {
                      key: "url",
                      value: t[y].event.responseURL
                    }, va.contextId && {
                      key: "contextId",
                      value: va.contextId
                    }].filter(Boolean) : void 0
                  };
                  (i = _o2(_o2({}, i), {
                    traceId: t[y].traceId,
                    traceSegmentId: t[y].traceSegmentId
                  })).spans.push(G), Cr({
                    url: n[1]
                  }, t[y].traceId);
                }
                if (c.isAjax) {
                  var H = _o2(_o2({}, rr()), {
                    traceId: c.isTrace ? t[y].traceId : "",
                    traceSegmentId: c.isTrace ? t[y].traceSegmentId : "",
                    t: "api",
                    uploadType: "api",
                    begin: t[y].startTime,
                    url: n[1],
                    duration: new Date().getTime() - t[y].startTime,
                    success: yl(["", "text", "json"].includes(t[y].event.responseType) ? t[y].event.responseText : "", e.detail.status),
                    requestHeader: JSON.stringify(l),
                    requestMethod: l.method || "get",
                    requestBody: null,
                    responseHeader: JSON.stringify(t[y].event.getAllResponseHeaders()),
                    responseStatus: t[y].event.status,
                    responseBody: c.isResponse ? ["", "text", "json"].includes(t[y].event.responseType) ? t[y].event.responseText : '{"hint":"Too much data not to show"}' : null,
                    transferSize: Cl(t[y].event.responseText)
                  });
                  try {
                    H.requestBody = c.isRequest ? s[0] : null;
                  } catch (e) {}
                  (w = h(a.API, H)) && wa(w, "api");
                }
                lr({
                  type: "http",
                  category: "xhr",
                  traceId: c.isTrace ? t[y].traceId : "",
                  method: l.method || "GET",
                  url: n[1],
                  statusCode: t[y].event.status
                }), t.splice(y, 1);
              }
            }
            var w;
            c.isTrace && (w = h(a.SEGMENT, i)) && ba(w);
          }
        }), window.addEventListener("fetchReadyStateChange", function (t) {
          return r(e, void 0, void 0, function () {
            var e, i, r, s, l, u, d, m, S, p, T, v;
            return n(this, function (n) {
              switch (n.label) {
                case 0:
                  e = t.detail, i = e.response, r = e.options, s = void 0 === r ? {} : r, l = e.segCollector, u = t.detail.segment, delete (d = s).body, m = {};
                  try {
                    m = new URL(i.url);
                  } catch (e) {
                    m = i.url;
                  }
                  if (c.isTrace && (S = {
                    operationName: Ra(),
                    startTime: l.startTime,
                    endTime: new Date().getTime(),
                    spanId: u.spans.length,
                    spanLayer: pl,
                    spanType: Tl,
                    isError: 0 === t.detail.status || t.detail.status >= 400,
                    parentSpanId: u.spans.length - 1,
                    componentId: 10001,
                    peer: (null == m ? void 0 : m.host) || "",
                    tags: c.detailMode ? [{
                      key: "http.method",
                      value: s.method || "get"
                    }, {
                      key: "url",
                      value: i.url
                    }, va.contextId && {
                      key: "contextId",
                      value: va.contextId
                    }].filter(Boolean) : void 0
                  }, (u = _o2(_o2({}, u), {
                    traceId: l.traceId,
                    traceSegmentId: l.traceSegmentId
                  })).spans.push(S), Cr({
                    url: i.url
                  }, l.traceId)), !c.isAjax) return [3, 5];
                  p = _o2(_o2({}, rr()), {
                    traceId: c.isTrace ? l.traceId : "",
                    traceSegmentId: c.isTrace ? l.traceSegmentId : "",
                    t: "api",
                    uploadType: "api",
                    begin: l.startTime,
                    url: i.url,
                    duration: new Date().getTime() - l.startTime,
                    requestHeader: JSON.stringify(d),
                    requestBody: null,
                    requestMethod: s.method || "get",
                    responseHeader: JSON.stringify(i.headers),
                    responseStatus: i.status,
                    responseBody: null
                  });
                  try {
                    p.requestBody = c.isRequest ? JSON.stringify(s.body) : null;
                  } catch (e) {}
                  T = "", n.label = 1;
                case 1:
                  return n.trys.push([1, 3,, 4]), [4, i.clone().text()];
                case 2:
                  return T = n.sent(), [3, 4];
                case 3:
                  return n.sent(), [3, 4];
                case 4:
                  p.transferSize = Cl(T), c.isResponse && (p.responseBody = T), p.success = yl(T, i.status), (v = h(a.API, p)) && wa(v, "api"), n.label = 5;
                case 5:
                  return lr({
                    type: "http",
                    category: "fetch",
                    traceId: c.isTrace ? l.traceId : "",
                    method: s.method || "GET",
                    url: i.url,
                    statusCode: i.status
                  }), c.isTrace && (v = h(a.SEGMENT, u)) && ba(v), [2];
              }
            });
          });
        }), La("beforeunload", function () {
          va.segments.length > 0 && new gl("SEGMENTS", c.collector).sendByXhr(va.segments);
        }), setInterval(function () {
          ya(), va.segments.length > 0 && (new gl("SEGMENTS", c.collector).sendByXhr(s(va.segments)), va.segments.splice(0, va.segments.length));
          var e = Ma();
          e.length > 0 && (Ta.sendByXhr(e), Ha());
        }, u("pushIntervalDuration"));
      }();
    }, e.prototype.addListenUnload = function () {
      La("beforeunload", vr), this.destroy();
    }, e.prototype.startTrace = function () {
      fa(Ia()), console.log("自定义trace开启");
    }, e.prototype.stopTrace = function () {
      console.log("自定义trace停止：可通过该上下文标识在服务链路功能中进行链路查询，标识：" + va.contextId);
      var e = va.contextId;
      return fa(), e;
    }, e.prototype.addCustomMsg = function (e) {
      !function (e) {
        u("isCustom") && Aa(e);
      }(e);
    }, e.prototype.setPerformance = function (e) {
      l(e), this.sendPerf();
    }, e.prototype.destroy = function () {}, e;
  }())();
  return window.ClientMonitor = Hl, Hl;
});